export interface StringsType {
  domain: string;
  lang: string;
  completeness: number;
  plural_forms: string;
  locale_data: {
    messages: Record<string, unknown>;
  };
}
export const strings: Record<string, StringsType> = {};

strings["it"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "it",
        plural_forms: "nplurals=2; plural=(n != 1);",
      },
      "required": ["necessario"],
      "Validation failed unexpectedly. Please contact the developers: %1$s": [
        "La convalida non è riuscita in modo imprevisto. Contatta gli sviluppatori: %1$s",
      ],
      "Terms of service": ["Condizioni d'uso"],
      "Read the terms of service before continuing.": [
        "Leggi i termini di servizio prima di continuare.",
      ],
      "Terms acceptance": ["Accettazione dei termini"],
      "Accept the terms of service before continuing.": [
        "Accetta i termini di servizio prima di continuare.",
      ],
      "Looks like the JSON in the request was malformed.": [
        "Sembra che il formato JSON nella richiesta non sia valido.",
      ],
      "The request timed out. Check your connection.": [
        "La richiesta è scaduta. Controlla la connessione.",
      ],
      "The %1$s request to %2$s failed after %3$s seconds.": [
        "La richiesta di %1$s a %2$s non è riuscita dopo %3$s secondi.",
      ],
      "The last request time is %1$s": ["L'ora dell'ultima richiesta è %1$s"],
      "The request was cancelled.": ["La richiesta è stata annullata."],
      "The %1$s request %2$s failed with code %3$s.": [
        "La richiesta %1$s %2$s non è riuscita con il codice %3$s.",
      ],
      "The request was made at %1$s": [
        "La richiesta è stata effettuata alle %1$s",
      ],
      "Too many requests were made to the server and this action was throttled.":
        [
          "Sono state effettuate troppe richieste al server e questa azione è stata limitata.",
        ],
      'The request "%1$s %2$s" failed with code %3$s': [
        'La richiesta "%1$s %2$s" non è riuscita con il codice %3$s',
      ],
      "The server's response was malformed.": [
        "La risposta del server non era valida.",
      ],
      'The response to "%1$s %2$s" failed with code %3$s': [
        'La risposta a "%1$s %2$s" non è riuscita con il codice %3$s',
      ],
      "The content type is %1$s": ["Il tipo di contenuto è %1$s"],
      'The validation error is "%1$s"': ['L\'errore di convalida è "%1$s"'],
      "Due to a network problem the request could not be finished.": [
        "A causa di un problema di rete non è stato possibile completare la richiesta.",
      ],
      "The %1$s request to %2$s failed.": [
        "La richiesta di %1$s a %2$s non è riuscita.",
      ],
      "The server's response was unexpected. This means the client and the server are not in sync about the protocol.":
        [
          "La risposta del server è stata inaspettata. Ciò significa che il client e il server non sono sincronizzati riguardo al protocollo.",
        ],
      "The %1$s request to %2$s failed with code %3$s": [
        "La richiesta di %1$s a %2$s non è riuscita con il codice %3$s",
      ],
      'And the server says: "%1$s"': ['E il server dice: "%1$s"'],
      "Unexpected error": ["Errore imprevisto"],
      "An unexpected error occurred and was not handled properly. To report it, copy the details and create an issue at https://bugs.taler.net.":
        [
          "Si è verificato un errore imprevisto che non è stato gestito correttamente. Per segnalarlo, copia i dettagli e crea una segnalazione su https://bugs.taler.net.",
        ],
      "Render error.": ["Errore di rendering."],
      "The operation failed.": ["L'operazione è fallita."],
      "The server rejected the operation without a specific error message.": [
        "Il server ha rifiutato l'operazione senza un messaggio di errore specifico.",
      ],
      "Unexpected error.": ["Errore imprevisto."],
      "The runtime threw an Error which was not properly handled. Please report this at https://bugs.taler.net.":
        [
          "Il runtime ha generato un errore che non è stato gestito correttamente. Si prega di segnalarlo su https://bugs.taler.net.",
        ],
      "Copy details": ["Copia dettagli"],
      "Dismiss notification": ["Ignora notifica"],
      "Copy this text manually:": ["Copia questo testo manualmente:"],
      "Technical details": ["Dettagli tecnici"],
      "Select language": ["Seleziona la lingua"],
      "Languages": ["Lingue"],
      "Loading": ["Caricamento"],
      "Show notifications": ["Mostra notifiche"],
      "Open profile": ["Apri profilo"],
      "Open settings": ["Apri le impostazioni"],
      "Close panel": ["Chiudi pannello"],
      "Menu": ["Menu"],
      "Sidebar": ["Barra laterale"],
      "Log out": ["Esci"],
      "Sites": ["Siti"],
      "Copyright": ["Copyright"],
      "Version %1$s (%2$s)": ["Versione %1$s (%2$s)"],
      "Testing with %1$s": ["Test con %1$s"],
      "stop testing": ["Interrompi il test"],
      "Learn more about %1$s": ["Ulteriori informazioni su %1$s"],
      "Hide details": ["Nascondi dettagli"],
      "Show details": ["Mostra dettagli"],
      "Show more info": ["Mostra più informazioni"],
      "never": ["mai"],
      "in %1$s": ["tra %1$s"],
      "%1$s ago": ["%1$s fa"],
      "Pagination": ["Paginazione"],
      "Page %1$s": ["Pagina %1$s"],
      "First page": ["Prima pagina"],
      "Previous": ["Precedente"],
      "Next": ["Successivo"],
      "Checking compatibility of this webapp with backend service...": [
        "Verifica della compatibilità di questa webapp con il servizio backend...",
      ],
      "There was an error trying to contact the backend service.": [
        "Si è verificato un errore durante il tentativo di contattare il servizio di backend.",
      ],
      'The server version is not supported. Supported version "%1$s", server version "%2$s"':
        [
          'La versione del server non è supportata. Versione supportata "%1$s", versione server "%2$s"',
        ],
      "Retry": ["Riprova"],
      'The server version is not supported. Supported version "%1$s".': [
        'La versione del server non è supportata. Versione supportata "%1$s".',
      ],
      "Not recorded": ["Non registrato"],
      "Provider": ["Fornitore"],
      "Acceptance status": ["Stato di accettazione"],
      "Accepted": ["Accettato"],
      "Accepted terms version": ["Versione dei termini accettati"],
      "Terms opened or downloaded": ["Termini aperti o scaricati"],
      "Yes": ["Sì"],
      "No": ["No"],
      "Try again": ["Riprova"],
      "Downloading PDF…": ["Download del PDF…"],
      "Download PDF": ["Scarica PDF"],
      "Done": ["Fatto"],
      "The terms are not available as Markdown or plain text.": [
        "I termini non sono disponibili come Markdown o testo normale.",
      ],
      "These terms are too large to display safely.": [
        "Questi termini sono troppo grandi per essere visualizzati in modo sicuro.",
      ],
      "The terms of service could not be loaded.": [
        "Impossibile caricare i termini di servizio.",
      ],
      "Close terms of service": ["Chiudi le condizioni d'uso"],
      "Loading terms of service…": ["Caricamento delle condizioni d'uso…"],
      "The PDF could not be downloaded.": ["Impossibile scaricare il PDF."],
      "Read the terms provided by %1$s before recording your acceptance.": [
        "Leggi i termini forniti da %1$s prima di registrare la tua accettazione.",
      ],
      "Read terms again": ["Leggi di nuovo i termini"],
      "Read terms": ["Leggi i termini"],
      "Your acceptance applies to the version shown above.": [
        "La tua accettazione si applica alla versione mostrata sopra.",
      ],
      "Review the terms of service": ["Rivedi i termini di servizio"],
      "Read the terms before recording your acceptance.": [
        "Leggi i termini prima di registrare la tua accettazione.",
      ],
      "Accept the terms of service": ["Accetta i termini di servizio"],
      "I have read and accept the terms of service": [
        "Ho letto e accetto i termini di servizio",
      ],
      "Open the terms before accepting them.": [
        "Apri i termini prima di accettarli.",
      ],
      "Email verification": ["Verifica e-mail"],
      "Challenge email ownership.": [
        "Verifica la titolarità dell'indirizzo e-mail.",
      ],
      "E-Mail": ["E-mail"],
      "Postal verification": ["Verifica postale"],
      "Challenge address ownership.": [
        "Verifica la titolarità dell'indirizzo postale.",
      ],
      "Name": ["Nome"],
      "Address": ["Indirizzo"],
      "Country": ["Paese"],
      "Phone verification": ["Verifica telefonica"],
      "Challenge phone number ownership.": [
        "Verifica la titolarità del numero di telefono.",
      ],
      "Phone": ["Telefono"],
      "Generic note": ["Nota generica"],
      "Free-form, generic note": ["Nota generica e in forma libera"],
      "Note / Memorandum": ["Nota/Memorandum"],
      "Free-form notes": ["Note in formato libero"],
      "Supplemental File Upload": ["Caricamento file supplementare"],
      "Optional supplemental information for the establishment of the business relationship with the customer.":
        [
          "Informazioni integrative facoltative per l'instaurazione del rapporto commerciale con il cliente.",
        ],
      "Supplemental Files": ["File supplementari"],
      "Description": ["Descrizione"],
      "File (PDF)": ["File (PDF)"],
      "Upload multiple documents": ["Carica più documenti"],
      "Upload multiple documents.": ["Carica più documenti."],
      "Requested documents": ["Documenti richiesti"],
      "Document identifier": ["Identificatore del documento"],
      "Title": ["Titolo"],
      "Required": ["Obbligatorio"],
      "Document upload (%1$s)": ["Caricamento documento (%1$s)"],
      "Simple form": ["Modulo semplice"],
      "Full Name": ["Nome e cognome"],
      "Birthdate": ["Data di nascita"],
      "Comment": ["Commento"],
      "Resolution": ["Risoluzione"],
      "New state": ["Nuovo stato"],
      "Frozen": ["Congelato"],
      "Pending": ["In sospeso"],
      "Normal": ["Normale"],
      "New threshold": ["Nuova soglia"],
      "German": ["tedesco"],
      "English": ["Inglese"],
      "Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange (K)":
        [
          "Identificazione della persona che esercita il controllo di persone giuridiche operative e società di persone non quotate in borsa (K)",
        ],
      "for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnership that are beneficial owners":
        [
          "per le persone giuridiche operative e le società di persone che sono controparti, nonché, per analogia, per quelle che sono aventi diritto economico",
        ],
      "Establishment of the controlling person (submitted by customer)": [
        "Identificazione della persona che esercita il controllo (presentata dal cliente)",
      ],
      "Identity of the contracting partner": ["Identità della controparte"],
      "Name and address": ["Nome e indirizzo"],
      "Contracting partner": ["Controparte"],
      "Controlling person(s)": ["Persona/e che esercita/no il controllo"],
      "Reason for control": ["Motivo del controllo"],
      "Holding 25% or more": ["Partecipazione pari o superiore al 25%"],
      "The person(s) listed below is/are holding 25% or more of the contracting partner's shares (capital shares or voting rights)":
        [
          "La/e persona/e elencata/e di seguito detiene/detengono almeno il 25% delle quote della controparte (quote di capitale o diritti di voto)",
        ],
      "Other way": ["Altra modalità"],
      "If the capital shares or voting rights cannot be determined or in case there are no capital shares or voting rights 25% or more, the contracting partner hereby declares that the person(s) listed below is/are controlling the contracting partner in other ways":
        [
          "Se non è possibile determinare le quote di capitale o i diritti di voto, oppure se nessuno detiene almeno il 25%, la controparte dichiara che la/e persona/e elencata/e di seguito esercita/esercitano il controllo in altro modo",
        ],
      "Managing director": ["Amministratore"],
      "In case this/these person(s) cannot be determined or this/these person(s) does/do not exist, the contracting partner hereby declares that the person(s) listed below is/are the managing director(s)":
        [
          "Se non è possibile determinare tali persone o se non esistono, la controparte dichiara che la/e persona/e elencata/e di seguito è/sono l’amministratore/gli amministratori",
        ],
      "Can't be empty": ["Non può essere vuoto"],
      "Full name": ["Nome completo"],
      "Actual address of domicile": ["Indirizzo effettivo del domicilio"],
      "Fiduciary holding assets": [
        "Detenzione fiduciaria di valori patrimoniali",
      ],
      "Is a third person the beneficial owner of the assets held in the account/securities account?":
        [
          "Un terzo è l’avente diritto economico dei valori patrimoniali detenuti sul conto/deposito titoli?",
        ],
      "Signature(s)": ["Firma/e"],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery)":
        [
          "Fornire deliberatamente informazioni false su questo modulo è un reato (articolo 251 del Codice penale svizzero, falsificazione di documenti)",
        ],
      "The contracting partner hereby undertakes to inform automatically of any changes to the information contained herein.":
        [
          "La controparte si impegna a comunicare spontaneamente qualsiasi modifica delle informazioni qui contenute.",
        ],
      "Date": ["Data"],
      "Establishment of the controlling person (submitted by AML officer)": [
        "Identificazione della persona che esercita il controllo (presentata dall'addetto LRD)",
      ],
      "Signed Declaration": ["Dichiarazione firmata"],
      "Signed declaration by the customer": [
        "Dichiarazione firmata dal cliente",
      ],
      "The uploaded document must contain the customer's signature on the beneficial owner declaration.":
        [
          "Il documento caricato dovrà contenere la firma del cliente sulla dichiarazione del titolare effettivo.",
        ],
      "Signed Document": ["Documento firmato"],
      "invalid format": ["formato non valido"],
      "it can't be in the future": ["non può essere in futuro"],
      "it can't be greater than 120 years": [
        "non può essere superiore a 120 anni",
      ],
      "Last name(s), first name(s)/entity": ["Cognome/i, nome/i/entità"],
      "Actual address of domicile/registered office": [
        "Indirizzo effettivo di domicilio/sede legale",
      ],
      "Date(s) of birth": ["Data/e di nascita"],
      "Nationality": ["Nazionalità"],
      "Date of death (if deceased)": ["Data di morte (se deceduto)"],
      "Foundations (as well as similar constructs) (S)": [
        "Fondazioni (e strutture analoghe) (S)",
      ],
      "Declaration for foundations and similar constructs.": [
        "Dichiarazione per fondazioni e strutture analoghe.",
      ],
      "Contracting partner and foundation": ["Controparte e fondazione"],
      "The undersigned hereby declare(s) that as board member of the foundation, or of the highest supervisory body of an underlying company of a foundation, known as:":
        [
          "Il/I sottoscritto/i dichiara/no, in qualità di membro/i del consiglio della fondazione o del massimo organo di vigilanza di una società sottostante a una fondazione denominata:",
        ],
      "Name of the foundation": ["Nome della fondazione"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following:":
        [
          "e, in tale qualità, fornisce/forniscono in buona fede le informazioni seguenti:",
        ],
      "Name and information pertaining to the foundation": [
        "Nome e informazioni relative alla fondazione",
      ],
      "Type of foundation": ["Tipo di fondazione"],
      "Discretionary foundation": ["Fondazione discrezionale"],
      "Non-discretionary foundation": ["Fondazione non discrezionale"],
      "Revocability": ["Revocabilità"],
      "Revocable foundation": ["Fondazione revocabile"],
      "Irrevocable foundation": ["Fondazione irrevocabile"],
      "Information pertaining to the founder": [
        "Informazioni relative al fondatore",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, founder (individual(s) or entity/entities).":
        [
          "Informazioni sul fondatore economico effettivo, non fiduciario (persona/e fisica/fisiche o giuridica/giuridiche).",
        ],
      "Founder(s)": ["Fondatore/i"],
      "Does the founder have the right to revoke the foundation?": [
        "Il fondatore ha il diritto di revocare la fondazione?",
      ],
      "Founders of pre-existing foundations": [
        "Fondatori di fondazioni preesistenti",
      ],
      "Complete this section if the foundation results from a restructuring (re-settlement) or merger of pre-existing foundations.":
        [
          "Compila questa sezione se la fondazione deriva da una ristrutturazione (re-settlement) o dalla fusione di fondazioni preesistenti.",
        ],
      "Founder(s) of the pre-existing foundation(s)": [
        "Fondatore/i della/e fondazione/i preesistente/i",
      ],
      "Beneficiaries": ["Beneficiari"],
      "Beneficiaries determined at the time this form is signed": [
        "Beneficiari determinati al momento della firma del presente modulo",
      ],
      "Does the beneficiary have an actual right to claim distributions?": [
        "Il beneficiario ha un diritto effettivo a richiedere le distribuzioni?",
      ],
      "Known group(s) of beneficiaries": ["Gruppo(i) noto(i) di beneficiari"],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the founder).":
        [
          "In aggiunta ai beneficiari definiti, o se non è stato definito alcun beneficiario (ad esempio, discendenti del fondatore).",
        ],
      "Provide at least one beneficiary or group of beneficiaries": [
        "Fornire almeno un beneficiario o un gruppo di beneficiari",
      ],
      "Further persons": ["Ulteriori persone"],
      "Persons entitled to determine or nominate representatives of the foundation when those representatives may dispose of assets or change asset distributions or the nomination of beneficiaries.":
        [
          "Persone autorizzate a designare o nominare i rappresentanti della fondazione quando tali rappresentanti possono disporre di beni o modificare la distribuzione dei beni o la nomina dei beneficiari.",
        ],
      "Further person(s)": ["Ulteriori persone"],
      "Is/are there (a) further person(s) with the right to revoke the foundation?":
        [
          "Esiste/ci sono altre persone con il diritto di revocare la fondazione?",
        ],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery).":
        [
          "Fornire deliberatamente informazioni false su questo modulo è un reato (articolo 251 del Codice penale svizzero, falsificazione di documenti).",
        ],
      "The contracting partner(s) undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "La controparte si impegna a comunicare spontaneamente qualsiasi modifica delle informazioni qui contenute.",
        ],
      "Declaration for trusts (T)": ["Dichiarazione per i trust (T)"],
      "Declaration for trusts.": ["Dichiarazione per i trust."],
      "Contracting partner and trust": ["Controparte e trust"],
      "The undersigned hereby declare(s) that as trustee or a member of highest supervisory body of an underlying company of a trust known as:":
        [
          "Il/I sottoscritto/i dichiara/no, in qualità di trustee o di membro/i del massimo organo di vigilanza di una società sottostante a un trust denominato:",
        ],
      "Name of the trust": ["Nome del trust"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following information:":
        [
          "e, in tale qualità, fornisce/forniscono in buona fede le informazioni seguenti:",
        ],
      "Name and information pertaining to the trust": [
        "Nome e informazioni relative al trust",
      ],
      "Type of trust": ["Tipo di trust"],
      "Discretionary trust": ["Trust discrezionale"],
      "Non-discretionary trust": ["Trust non discrezionale"],
      "Revocable trust": ["Trust revocabile"],
      "Irrevocable trust": ["Trust irrevocabile"],
      "Information pertaining to the settlor": [
        "Informazioni relative al disponente",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, settlor of the trust (individual(s) or entity/entities).":
        [
          "Informazioni sul disponente economico effettivo, non fiduciario, del trust (persona/e fisica/fisiche o giuridica/giuridiche).",
        ],
      "Settlor(s)": ["Disponente/i"],
      "Does the settlor have the right to revoke the trust?": [
        "Il disponente ha il diritto di revocare il trust?",
      ],
      "Settlors of pre-existing trusts": ["Disponenti di trust preesistenti"],
      "Complete this section if the trust results from a restructuring (re-settlement) or merger of pre-existing trusts.":
        [
          "Compila questa sezione se il trust deriva da una ristrutturazione (re-settlement) o dalla fusione di trust preesistenti.",
        ],
      "Settlor(s) of the pre-existing trust(s)": [
        "Disponente/i del/dei trust preesistente/i",
      ],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the settlor).":
        [
          "In aggiunta ai beneficiari definiti, o se non è stato definito alcun beneficiario (ad esempio, discendenti del disponente).",
        ],
      "Protectors": ["Protector"],
      "Protector(s)": ["Protector"],
      "Does the protector have the right to revoke the trust?": [
        "Il protector ha il diritto di revocare il trust?",
      ],
      "Further persons having the right to appoint the trustee of a trust.": [
        "Ulteriori persone che hanno il diritto di nominare il trustee di un trust.",
      ],
      "Do any further persons have the right to revoke the trust?": [
        "Altre persone hanno il diritto di revocare il trust?",
      ],
      "The contracting partner(s) hereby declare(s) to be entitled to open a business relationship for the trust above or its underlying company.":
        [
          "La controparte dichiara di essere autorizzata ad avviare un rapporto d’affari per il trust sopra indicato o per la relativa società sottostante.",
        ],
      "The contracting partner(s) hereby undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "La controparte si impegna a comunicare spontaneamente qualsiasi modifica delle informazioni qui contenute.",
        ],
      "The customer is the person with whom the member concludes the contract with regard to the financial service provided (civil law). If the\n  member acts as the director of a domiciliary company, then that domiciliary company is the customer.":
        [
          "Il cliente è la persona con la quale il membro stipula il contratto relativo al servizio finanziario fornito (diritto civile). Se il\n  membro funge da amministratore di una società di sede, tale società di sede è quindi il cliente.",
        ],
      "Identification Form (customer)": ["Modulo di identificazione (cliente)"],
      "The customer has to be identified on entering into a permanent business relationship or on concluding a cash transaction, which meets the according threshold.":
        [
          "Il cliente deve essere identificato al momento dell'avvio di un rapporto d'affari permanente o al momento della conclusione di una transazione in contanti, che raggiunge la soglia corrispondente.",
        ],
      "Correspondence language:": ["Lingua della corrispondenza:"],
      "French": ["Francese"],
      "Italian": ["Italiano"],
      "Identification form (basic customer information)": [
        "Modulo di identificazione (informazioni di base sul cliente)",
      ],
      "Information on customer": ["Informazioni sul cliente"],
      "Customer type": ["Tipologia cliente"],
      "Natural person (incl. sole proprietors)": [
        "Persona fisica (incl. imprese individuali)",
      ],
      "Legal entity": ["Persona giuridica"],
      "Applicable if customer is a natural person": [
        "Applicabile se il cliente è una persona fisica",
      ],
      "Residential address in Switzerland": [
        "Indirizzo di residenza in Svizzera",
      ],
      "Telephone": ["Telefono"],
      "Email": ["E-mail"],
      "Date of birth": ["Data di nascita"],
      "Copy of identification document": ["Copia del documento di identità"],
      "Only official government IDs (incl. passports) are accepted. Please scan both sides if applicable.":
        [
          "Sono accettati solo documenti d'identità governativi ufficiali (compresi i passaporti). Si prega di eseguire la scansione di entrambi i lati, se applicabile.",
        ],
      "Sole proprietor": ["Ditta individuale"],
      "Information on customer (sole proprietor)": [
        "Informazioni sul cliente (ditta individuale)",
      ],
      "Applicable only if customer is a sole proprietor": [
        "Applicabile solo se il cliente è una ditta individuale",
      ],
      "Company name": ["Nome dell'azienda"],
      "Registered office": ["Sede legale"],
      "Company identification document": [
        "Documento d'identificazione della società",
      ],
      "Information on customer (legal entity)": [
        "Informazioni sul cliente (persona giuridica)",
      ],
      "Applicable if customer is a legal entity": [
        "Applicabile se il cliente è una persona giuridica",
      ],
      "Domicile": ["Domicilio"],
      "Contact person": ["Referente"],
      "Copy of identification document (not older than 12 months)": [
        "Copia del documento di identità (non più vecchio di 12 mesi)",
      ],
      "Company share registry file": ["Registro degli azionisti della società"],
      "Correspondence Preferences": ["Preferenze di corrispondenza"],
      "Information on the natural persons who establish the business relationship for legal entities and partnerships":
        [
          "Informazioni sulle persone fisiche che instaurano il rapporto commerciale per le persone giuridiche e le società di persone",
        ],
      "For legal entities and partnerships the identity of the natural persons who establish the business relationship must be verified.":
        [
          "Per le persone giuridiche e le società di persone è necessario verificare l'identità delle persone fisiche che instaurano il rapporto commerciale.",
        ],
      "Persons establishing the legal relationship": [
        "Persone che instaurano il rapporto giuridico",
      ],
      "Residential address": ["Indirizzo residenziale"],
      "Signing authority of the person": ["Diritto di firma della persona"],
      "Power of attorney arrangements": ["Regole di procura"],
      "Sole signature authority": ["Diritto di firma individuale"],
      "Collective authority with two signatures": [
        "Diritto di firma collettiva a due",
      ],
      "Other (please specify)": ["Altro (specificare)"],
      "Other type of signing authority": ["Altro tipo di diritto di firma"],
      "Evidence of signing authority:": ["Prova del diritto di firma:"],
      "Company register extract": ["Estratto del registro delle imprese"],
      "Mandate": ["Mandato"],
      "Other": ["Altro"],
      "Specify other way of establishing signing authority:": [
        "Specifica un altro modo per attestare il diritto di firma:",
      ],
      "Copy of document that serves as evidence of signing authority:": [
        "Copia del documento che attesta il diritto di firma:",
      ],
      "Customer classification": ["Classificazione dei clienti"],
      "Classification for the establishment of the beneficial owner of the assets and/or controlling person":
        [
          "Classificazione per l’identificazione dell’avente diritto economico dei valori patrimoniali e/o della persona che esercita il controllo",
        ],
      "The customer is:": ["Il cliente è:"],
      "A natural person and there are no doubts that this person is the sole beneficial owner of the assets":
        [
          "Una persona fisica, senza alcun dubbio che sia l’unico avente diritto economico dei valori patrimoniali",
        ],
      "An operational legal entity or partnership": [
        "Una persona giuridica operativa o una società di persone",
      ],
      "A foundation (or a similar construct; incl. underlying companies)": [
        "Una fondazione (o struttura analoga, comprese le società sottostanti)",
      ],
      "A trust (incl. underlying companies)": [
        "Un trust (comprese le società sottostanti)",
      ],
      "A life insurance policy with separately managed accounts / securities accounts (so-called insurance wrappers)":
        [
          "Una polizza di assicurazione sulla vita con conti/depositi a gestione separata (i cosiddetti wrapper assicurativi)",
        ],
      "Special Clarifications": ["Chiarimenti particolari"],
      "When a business relationship or transaction is associated with increased risk, appears unusual or evidence exists that the assets are the proceeds of a felony or a qualified tax offence, the member has to perform additional clarifications.":
        [
          "Se una relazione d'affari o una transazione presenta un rischio maggiore, appare insolita o esistono prove che i beni sono il provento di un crimine o di un reato fiscale qualificato, il membro deve fornire ulteriori chiarimenti.",
        ],
      "Customer": ["Cliente"],
      "Reason for special clarifications": [
        "Motivo dei chiarimenti particolari",
      ],
      "Reason": ["Motivo"],
      "Description of the circumstances/transactions, which triggered the special clarifications":
        [
          "Descrizione delle circostanze/operazioni che hanno dato luogo ai chiarimenti particolari",
        ],
      "can't be empty": ["non può essere vuoto"],
      "Used means of clarification": ["Mezzi di chiarimento utilizzati"],
      "Means": ["Mezzi"],
      "Gathering of information from the customer, beneficial owner of the assets, controlling person":
        [
          "Raccolta di informazioni presso il cliente, l’avente diritto economico dei valori patrimoniali o la persona che esercita il controllo",
        ],
      "Consultation of generally accessible sources and databases": [
        "Consultazione di fonti e banche dati generalmente accessibili",
      ],
      "Enquiries with trustworthy persons": [
        "Richieste di informazioni a persone affidabili",
      ],
      "Other, which?": ["Altro, quale?"],
      "Other means of clarification:": ["Altri mezzi di chiarimento:"],
      "Optional supplemental information for the special clarifications.": [
        "Informazioni integrative facoltative per i chiarimenti particolari.",
      ],
      "Summary and plausibility check of the gathered information": [
        "Verifica di sintesi e plausibilità delle informazioni raccolte",
      ],
      "The results of the clarifications have to be documented and their plausibility has to be checked.":
        [
          "I risultati dei chiarimenti devono essere documentati e la loro plausibilità deve essere verificata.",
        ],
      "Summary": ["Riepilogo"],
      "Gathered/Consulted documents": ["Documenti raccolti/consultati"],
      "Result of the special clarification": [
        "Esito dei chiarimenti particolari",
      ],
      "Result": ["Risultato"],
      "No suspicion": ["Nessun sospetto"],
      "The plausibility of the circumstances could be checked, no reasonable suspicion pursuant to Art. 9 AMLA (possibly update of customer profile and/or risk profile)":
        [
          "La plausibilità delle circostanze ha potuto essere verificata, nessun ragionevole sospetto ai sensi dell'art. 9 LRD (eventuale aggiornamento del profilo del cliente e/o del profilo di rischio)",
        ],
      "Reasonable suspicion": ["Ragionevole sospetto"],
      "Reasonable suspicion pursuant to Art. 9 AMLA, duty to file a report with MROS":
        ["Il ragionevole sospetto ex art. 9 LRD, obbligo di denuncia a MROS"],
      "Simple suspicion": ["Semplice sospetto"],
      "Simple suspicion pursuant to Art. 305ter Para. 2 StGB, right to notify MROS":
        [
          "Semplice sospetto ex art. 305ter par. 2 StGB, diritto di notificare MROS",
        ],
      "Other, what?": ["Altro, cosa?"],
      "Result clarification": ["Esito dei chiarimenti"],
      "Identification Form (acceptance)": [
        "Modulo di identificazione (accettazione)",
      ],
      "Acceptance of business relationship": [
        "Accettazione del rapporto commerciale",
      ],
      "Date (conclusion of contract):": ["Data (conclusione del contratto):"],
      "Accepted via:": ["Accettato tramite:"],
      "Face to face": ["Di persona"],
      "Authenticated copy of identification document": [
        "Copia autenticata del documento di identità",
      ],
      "Residential address validated": ["Indirizzo di residenza convalidato"],
      "Further information:": ["Ulteriori informazioni:"],
      "Evaluation with regard to embargo procedures/terrorism lists on establishing the business relationship":
        [
          "Valutazione in merito a procedure di embargo/liste antiterrorismo all'instaurazione del rapporto commerciale",
        ],
      "Verification whether the customer, beneficial owners of the assets, controlling persons, authorized representatives or other involved persons are listed on an embargo/terrorism list.":
        [
          "Verifica se il cliente, gli aventi diritto economico, i detentori del controllo, i rappresentanti autorizzati o altre persone coinvolte sono iscritti in una lista di embargo/terrorismo.",
        ],
      "Embargo/terrorism status:": ["Stato di embargo/terrorismo:"],
      "Not listed on embargo/terrorism list.": [
        "Non presente in una lista di embargo/terrorismo.",
      ],
      "Listed on embargo/terrorism list.": [
        "Presente in una lista di embargo/terrorismo.",
      ],
      "Embargo/terrorism information:": ["Informazioni su embargo/terrorismo:"],
      "Verification date": ["Data di verifica"],
      "Supplemental files": ["File supplementari"],
      "Risk Profile AMLA": ["Profilo di rischio LRD"],
      "Evaluation of politically exposed persons (PEP-Check)": [
        "Valutazione delle persone politicamente esposte (PEP-Check)",
      ],
      "This evaluation has to be completed by all members for every business relationship.":
        [
          "Questa valutazione deve essere completata da tutti i membri per ogni rapporto d'affari.",
        ],
      "Foreign PEP": ["PEP estera"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a foreign PEP or closely related to such a person?":
        [
          "Il cliente, l’avente diritto economico, la persona che esercita il controllo o il rappresentante autorizzato è una PEP estera o una persona a essa strettamente legata?",
        ],
      "Domestic PEP": ["PEP nazionale"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a domestic PEP or closely related to such a person?":
        [
          "Il cliente, l’avente diritto economico, la persona che esercita il controllo o il rappresentante autorizzato è una PEP nazionale o una persona a essa strettamente legata?",
        ],
      "PEP of International Organisations": [
        "PEP di organizzazioni internazionali",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a PEP in International Organisations or closely related to such a person?":
        [
          "Il cliente, l’avente diritto economico, la persona che esercita il controllo o il rappresentante autorizzato è una PEP di un’organizzazione internazionale o una persona a essa strettamente legata?",
        ],
      "Acceptance date": ["Data di accettazione"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with a PEP was obtained on.":
        [
          "Data della decisione dell’organo direttivo superiore di accettare un rapporto d’affari con una PEP.",
        ],
      'Evaluation "high risk" or non-cooperative country': [
        'Valutazione "ad alto rischio" o paese non cooperativo',
      ],
      "High-risk or non-cooperative country": [
        "Paese ad alto rischio o non cooperativo",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative in a country considered by the FATF as high-risk or non-cooperative and for which FATF requires increased diligence?":
        [
          "Il cliente, l’avente diritto economico, la persona che esercita il controllo o il rappresentante autorizzato si trova in un paese che il GAFI considera ad alto rischio o non cooperativo e per il quale richiede una diligenza accresciuta?",
        ],
      "When the decision of the Senior executive body on the acceptance of such a business relationship was obtained on.":
        [
          "Data della decisione dell’organo direttivo superiore di accettare tale rapporto d’affari.",
        ],
      "Evaluation of business relationship risk": [
        "Valutazione del rischio del rapporto d'affari",
      ],
      "Country risk": ["Rischio Paese"],
      "Applicable country risk types": ["Tipi di rischio paese applicabili"],
      "Nationality of the customer": ["Nazionalità del cliente"],
      "Nationality of the beneficial owner of the assets": [
        "Nazionalità dell’avente diritto economico dei valori patrimoniali",
      ],
      "Domicile/residential address of the customer": [
        "Domicilio/indirizzo di residenza del cliente",
      ],
      "Domicile/residential address of the beneficial owner of the assets": [
        "Domicilio/indirizzo di residenza dell’avente diritto economico dei valori patrimoniali",
      ],
      "Domicile/residential address of the controlling person": [
        "Domicilio/indirizzo di residenza della persona che esercita il controllo",
      ],
      "Country risk level (nationality)": [
        "Livello di rischio paese (nazionalità)",
      ],
      "Risk category according to VQF country list (VQF doc. no. 902.4.1)": [
        "Categoria di rischio secondo l'elenco dei paesi VQF (doc. VQF n. 902.4.1)",
      ],
      "Low (Risk 0)": ["Basso (rischio 0)"],
      "Risk 0 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Rischio 0 secondo la lista dei paesi VQF (doc. VQF n. 902.4.1)",
      ],
      "Medium (Risk 1)": ["Medio (rischio 1)"],
      "Risk 1 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Rischio 1 secondo la lista dei paesi VQF (doc. VQF n. 902.4.1)",
      ],
      "High (Risk 2)": ["Alto (rischio 2)"],
      "Risk 2 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Rischio 2 secondo la lista dei paesi VQF (doc. VQF n. 902.4.1)",
      ],
      "Country risk type (place of business activity)": [
        "Tipologia di rischio paese (sede di attività commerciale)",
      ],
      "Beneficial owner": ["Avente diritto economico"],
      "Country risk level (business activity)": [
        "Livello di rischio paese (attività commerciale)",
      ],
      "Industry risk": ["Rischio del settore"],
      "Industry risk source": ["Fonte di rischio del settore"],
      "Beneficial owner of the assets": [
        "Avente diritto economico dei valori patrimoniali",
      ],
      "Industry risk level": ["Livello di rischio del settore"],
      "Transparent (Risk Level 0)": ["Trasparente (livello di rischio 0)"],
      "Clearly defined, transparent, easily comprehensible business activity well known to the member.":
        [
          "Attività commerciale chiaramente definita, trasparente, facilmente comprensibile e ben nota al membro.",
        ],
      "High cash transactions (Risk Level 1)": [
        "Transazioni in contanti elevate (livello di rischio 1)",
      ],
      "Business activity with a high level of cash transactions.": [
        "Attività commerciale con un elevato livello di transazioni in contanti.",
      ],
      "Not well known (Risk Level 1)": ["Non ben noto (livello di rischio 1)"],
      "Business activity not well known to the member.": [
        "Attività commerciale non ben nota al membro.",
      ],
      "High-risk trade (Risk Level 2)": [
        "Commercio ad alto rischio (livello di rischio 2)",
      ],
      "Trade in munitions/arms, raw gem stones/diamonds, jewellery, international trade in exotic animals, casino and lottery business, trade in erotic wares.":
        [
          "Commercio di munizioni/armi, pietre preziose/diamanti grezzi, gioielli, commercio internazionale di animali esotici, attività di casinò e lotterie, commercio di articoli erotici.",
        ],
      "Unknown industry (Risk Level 2)": [
        "Settore sconosciuto (livello di rischio 2)",
      ],
      "Member has no personal knowledge of the customer’s industry.": [
        "Il membro non ha alcuna conoscenza personale del settore del cliente.",
      ],
      "Contact risk": ["Rischio di contatto"],
      "Type of contact to the customer/beneficial owner of the assets.": [
        "Tipo di contatto con il cliente/l’avente diritto economico dei valori patrimoniali.",
      ],
      "Contact risk level": ["Livello di rischio di contatto"],
      "Low contact risk": ["Basso rischio di contatto"],
      "Personal acquaintance between member and customer/beneficial owner of the assets over several years (at least 2) prior to entering into the business relationship":
        [
          "Conoscenza personale tra il socio e il cliente/avente diritto economico dei beni per diversi anni (almeno 2) prima dell'inizio del rapporto d'affari",
        ],
      "Medium contact risk": ["Rischio di contatto medio"],
      "The customer/beneficial owner was not personally known to the member for several years (at least 2) prior to entering into the business relationship; however (a) no business was entered into in the absence of the customer/beneficial owner, or (b) the customer was at least introduced/brokered by a trusted third party.":
        [
          "Il cliente/avente economicamente diritto non era conosciuto personalmente dal membro già da diversi anni (almeno 2) prima dell'inizio del rapporto d'affari; tuttavia (a) non è stata avviata alcuna attività in assenza del cliente/titolare economico, o (b) il cliente è stato almeno presentato/intermediato da una terza persona di fiducia.",
        ],
      "High contact risk": ["Alto rischio di contatto"],
      "The customer/beneficial owner was not personally known to the member and business was entered into in the absence of the former (relationship by correspondence) and the customer was not introduced/brokered by a trusted third party.":
        [
          "Il cliente/avente diritto economico non era conosciuto personalmente dal membro e l'affare è stato concluso in sua assenza (rapporto per corrispondenza) e il cliente non è stato presentato/intermediato da una persona terza di fiducia.",
        ],
      "Summary evaluation": ["Valutazione complessiva"],
      "Justification for risk assessment": [
        "Giustificazione della valutazione del rischio",
      ],
      "Risk classification": ["Classificazione del rischio"],
      "Conclusion whether the business relationship is with or without increased risk.":
        [
          "Conclusione sulla presenza o meno di un rischio maggiore nel rapporto d’affari.",
        ],
      "No high risk": ["Nessun rischio elevato"],
      "High risk": ["Rischio elevato"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with increased risk was obtained on.":
        [
          "Data della decisione dell’organo direttivo superiore di accettare un rapporto d’affari a rischio maggiore.",
        ],
      "Customer Profile": ["Profilo del cliente"],
      "The information below has to refer to the persons from whom the assets originate ultimately (e.g. beneficial owner of the assets, founder/creator of a trust or foundation). Is the customer an operational legal entity or partnership the information may refer to the entity itself (not to the controlling person), unless the entity holds the assets in trust for a third party.":
        [
          "Le informazioni seguenti devono riferirsi alle persone da cui provengono in ultima istanza i valori patrimoniali (ad esempio l’avente diritto economico, il fondatore o il disponente di un trust o di una fondazione). Se il cliente è una persona giuridica operativa o una società di persone, le informazioni possono riferirsi all’entità stessa (non alla persona che esercita il controllo), salvo che l’entità detenga fiduciariamente i valori patrimoniali per un terzo.",
        ],
      "Business activity": ["Attività commerciale"],
      "Profession, business activities, etc. (former, current, potentially planned)":
        [
          "Professione, attività imprenditoriali, ecc. (precedenti, attuali, potenzialmente previste)",
        ],
      "Financial circumstances": ["Situazione finanziaria"],
      "Income and assets, liabilities (estimated)": [
        "Reddito e patrimonio, passività (stimate)",
      ],
      "Origin of the deposited assets involved": [
        "Origine dei valori patrimoniali depositati",
      ],
      "Will the customer deposit assets with Taler Operations AG?": [
        "Il cliente depositerà il patrimonio presso la Taler Operations AG?",
      ],
      "Nature, amount and currency of deposited assets.": [
        "Natura, importo e valuta dei beni depositati.",
      ],
      "Category": ["Categoria"],
      "Savings": ["Risparmi"],
      "Own business operations": ["Operazioni aziendali proprie"],
      "Inheritance": ["Eredità"],
      "Category clarification": ["Chiarimento della categoria"],
      "Detailed description of the origins/economic background of the assets involved in the business relationship":
        [
          "Descrizione dettagliata dell'origine/contesto economico dei beni oggetto del rapporto commerciale",
        ],
      "Nature and purpose of the business relationship": [
        "Natura e scopo del rapporto commerciale",
      ],
      "Purpose of the business relationship": [
        "Scopo del rapporto commerciale",
      ],
      "Information on the planned development of the business relationship and the assets":
        [
          "Informazioni sullo sviluppo previsto del rapporto commerciale e del patrimonio",
        ],
      "Details on usual business volume": [
        "Dettagli sul volume d'affari abituale",
      ],
      "Relationship with third parties": ["Rapporto con terzi"],
      "Relation of the customer to the beneficial owner, controlling persons, authorised signatories and other persons involved in the business relationship":
        [
          "Rapporto del cliente con l’avente diritto economico, le persone che esercitano il controllo, i firmatari autorizzati e le altre persone coinvolte nel rapporto d’affari",
        ],
      "Relation to other AMLA-Files": ["Relazione con altri dossier LRD"],
      "Introducer / agents / references": ["Presentatore/agenti/riferimenti"],
      "Further information": ["Ulteriori informazioni"],
      "Other relevant information": ["Altre informazioni rilevanti"],
      "Declaration of identity of the beneficial owner (A) — customer": [
        "Dichiarazione concernente l’avente diritto economico (A) — cliente",
      ],
      "The customer completes the declaration directly in the form.": [
        "Il cliente completa la dichiarazione direttamente nel modulo.",
      ],
      "Declaration of identity of the beneficial owner": [
        "Dichiarazione concernente l’avente diritto economico",
      ],
      "Beneficial owner details": ["Dati dell’avente diritto economico"],
      "Beneficial owner(s)": ["Avente/i diritto economico"],
      "The person(s) listed below is/are the beneficial owner(s) of the assets involved in the business relationship. If the contracting partner is also the sole beneficial owner of the assets, the contracting partner's detail must be set out below":
        [
          "La/e persona/e indicata/e di seguito è/sono l’avente/gli aventi diritto economico dei valori patrimoniali oggetto del rapporto d’affari. Se la controparte è anche l’unico avente diritto economico, occorre indicarne di seguito i dati.",
        ],
      "Domicile address": ["Indirizzo di domicilio"],
      "Declaration of identity of the beneficial owner (A) — AML officer": [
        "Dichiarazione concernente l’avente diritto economico (A) — addetto LRD",
      ],
      "The AML officer records the declaration and uploads the customer's signed PDF.":
        [
          "L'addetto LRD registra la dichiarazione e carica il PDF firmato dal cliente.",
        ],
      "January": ["gennaio"],
      "February": ["febbraio"],
      "March": ["marzo"],
      "April": ["aprile"],
      "May": ["maggio"],
      "June": ["giugno"],
      "July": ["luglio"],
      "August": ["agosto"],
      "September": ["settembre"],
      "October": ["ottobre"],
      "November": ["novembre"],
      "December": ["dicembre"],
      "Previous year": ["L'anno precedente"],
      "Next year": ["L'anno prossimo"],
      "Previous month": ["Mese precedente"],
      "Next month": ["Il mese prossimo"],
      "Close dialog": ["Chiudi la finestra di dialogo"],
      "Official form language": ["Lingua ufficiale del modulo"],
      "This form is shown in an official, legally binding language.": [
        "Il presente modulo è presentato in una lingua ufficiale giuridicamente vincolante.",
      ],
      "Official translation": ["Traduzione ufficiale"],
      "This form is shown in an official translation, but it is not legally binding. Only the %1$s text is legally binding.":
        [
          "Questo modulo è riportato in una traduzione ufficiale, ma non è giuridicamente vincolante. Solo il testo %1$s è giuridicamente vincolante.",
        ],
      "Unofficial form translation": ["Traduzione non ufficiale del modulo"],
      "This form is not officially supported in the selected language. The translation may be incomplete, and some text may be shown in %1$s. Only the %2$s text is legally binding.":
        [
          "Questo modulo non è ufficialmente supportato nella lingua selezionata. La traduzione potrebbe essere incompleta e parte del testo potrebbe essere mostrata in %1$s. Solo il testo %2$s è giuridicamente vincolante.",
        ],
      "Shorten file contents.": ["Tronca il contenuto del file."],
      "Result JSON:": ["Risultato JSON:"],
      "List of fields with errors": ["Elenco dei campi con errori"],
      "Delete this item?": ["Eliminare questo elemento?"],
      "Keep item": ["Mantieni elemento"],
      "Delete item": ["Elimina elemento"],
      "Cancel": ["Annulla"],
      "Delete": ["Elimina"],
      "Add item": ["Aggiungi elemento"],
      "Save changes": ["Salva le modifiche"],
      "Item %1$s": ["Elemento %1$s"],
      "Edit %1$s": ["Modifica %1$s"],
      "Edit": ["Modifica"],
      "Clear selection": ["Cancella selezione"],
      "Toggle choices": ["Attiva/disattiva le scelte"],
      "No element found": ["Nessun elemento trovato"],
      "years": ["anni"],
      "months": ["mesi"],
      "days": ["giorni"],
      "hours": ["ore"],
      "minutes": ["minuti"],
      "seconds": ["secondi"],
      "No expiration": ["Nessuna scadenza"],
      "Forever": ["Per sempre"],
      "The selected file is too large.": [
        "Il file selezionato è troppo grande.",
      ],
      "The selected file could not be read.": [
        "Impossibile leggere il file selezionato.",
      ],
      "Upload a file": ["Carica un file"],
      "Clear": ["Svuota"],
      "Download a copy.": ["Scarica una copia."],
      "This option is not available.": ["Questa opzione non è disponibile."],
      "The maximum number of selections has been reached.": [
        "È stato raggiunto il numero massimo di selezioni.",
      ],
      "Remove %1$s": ["Rimuovi %1$s"],
      "Simple comment": ["Commento semplice"],
      "Terms URL": ["URL dei termini"],
      "Terms version": ["Versione dei termini"],
      "Provider name": ["Nome del fornitore"],
      "Only show the external link": ["Mostra solo il collegamento esterno"],
      "Name and birthdate": ["Nome e data di nascita"],
      "Select an example from the list on the left.": [
        "Seleziona un esempio dall'elenco a sinistra.",
      ],
      "Example not found.": ["Esempio non trovato."],
      "An error occurred while rendering the example.": [
        "Si è verificato un errore durante il rendering dell'esempio.",
      ],
      "Group": ["Gruppo"],
      "Component": ["Componente"],
      "Example": ["Esempio"],
      "Arguments": ["Argomenti"],
      "Dataset": ["Set di dati"],
      "Dataset %1$s of %2$s": ["Set di dati %1$s di %2$s"],
      "Select a story": ["Seleziona uno scenario"],
      "Open stories navigation": ["Apri la navigazione degli scenari"],
      "Stories navigation": ["Navigazione degli scenari"],
      "Stories": ["Scenari"],
      "Close stories navigation": ["Chiudi la navigazione degli scenari"],
      "Language": ["Lingua"],
      "%1$s": ["%1$s"],
      "Free-form message": ["Messaggio in formato libero"],
      "Are you a cross-border truck driver?": [
        "Sei un camionista transfrontaliero?",
      ],
      "How much cash are you carrying?": ["Quanto contante porti con te?"],
      "Germany": ["Germania"],
      "Switzerland": ["Svizzera"],
      "Sign-in failed": ["Accesso non riuscito"],
      "Check your password.": ["Controlla la tua password."],
      "Try again in a moment.": ["Riprova tra un attimo."],
      "First error": ["Primo errore"],
      "First description": ["Prima descrizione"],
      "Second error": ["Secondo errore"],
      "Second description": ["Seconda descrizione"],
      "Saved": ["Salvato"],
      "Request failed": ["Richiesta non riuscita"],
      "Try again.": ["Riprova."],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n != 1);",
  lang: "it",
  completeness: 100,
};

strings["fr"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "fr",
        plural_forms: "nplurals=2; plural=n > 1;",
      },
      "required": ["requis"],
      "Validation failed unexpectedly. Please contact the developers: %1$s": [
        "Échec inattendu de la validation. Veuillez contacter les développeurs : %1$s",
      ],
      "Terms of service": ["Conditions d'utilisation"],
      "Read the terms of service before continuing.": [
        "Lisez les conditions d’utilisation avant de continuer.",
      ],
      "Terms acceptance": ["Acceptation des conditions"],
      "Accept the terms of service before continuing.": [
        "Acceptez les conditions d’utilisation avant de continuer.",
      ],
      "Looks like the JSON in the request was malformed.": [
        "Il semble que le JSON de la requête était mal formé.",
      ],
      "The request timed out. Check your connection.": [
        "La requête a expiré. Vérifiez votre connexion.",
      ],
      "The %1$s request to %2$s failed after %3$s seconds.": [
        "La requête %1$s vers %2$s a échoué après %3$s secondes.",
      ],
      "The last request time is %1$s": [
        "L'heure de la dernière requête est %1$s",
      ],
      "The request was cancelled.": ["La requête a été annulée."],
      "The %1$s request %2$s failed with code %3$s.": [
        "La requête %1$s %2$s a échoué avec le code %3$s.",
      ],
      "The request was made at %1$s": ["La requête a été effectuée à %1$s"],
      "Too many requests were made to the server and this action was throttled.":
        [
          "Trop de requêtes ont été envoyées au serveur et cette action a été limitée.",
        ],
      'The request "%1$s %2$s" failed with code %3$s': [
        "La requête « %1$s %2$s » a échoué avec le code %3$s",
      ],
      "The server's response was malformed.": [
        "La réponse du serveur était mal formée.",
      ],
      'The response to "%1$s %2$s" failed with code %3$s': [
        "La réponse à « %1$s %2$s » a échoué avec le code %3$s",
      ],
      "The content type is %1$s": ["Le type de contenu est %1$s"],
      'The validation error is "%1$s"': ["L'erreur de validation est « %1$s »"],
      "Due to a network problem the request could not be finished.": [
        "En raison d'un problème réseau, la requête n'a pas pu être terminée.",
      ],
      "The %1$s request to %2$s failed.": [
        "La requête %1$s vers %2$s a échoué.",
      ],
      "The server's response was unexpected. This means the client and the server are not in sync about the protocol.":
        [
          "La réponse du serveur était inattendue. Cela signifie que le client et le serveur ne sont pas synchronisés concernant le protocole.",
        ],
      "The %1$s request to %2$s failed with code %3$s": [
        "La requête %1$s vers %2$s a échoué avec le code %3$s",
      ],
      'And the server says: "%1$s"': ["Et le serveur répond : « %1$s »"],
      "Unexpected error": ["Erreur inattendue"],
      "An unexpected error occurred and was not handled properly. To report it, copy the details and create an issue at https://bugs.taler.net.":
        [
          "Une erreur inattendue s’est produite et n’a pas été correctement traitée. Pour la signaler, copiez les détails et créez un ticket sur https://bugs.taler.net.",
        ],
      "Render error.": ["Erreur d’affichage."],
      "The operation failed.": ["L’opération a échoué."],
      "The server rejected the operation without a specific error message.": [
        "Le serveur a rejeté l’opération sans fournir de message d’erreur précis.",
      ],
      "Unexpected error.": ["Erreur inattendue."],
      "The runtime threw an Error which was not properly handled. Please report this at https://bugs.taler.net.":
        [
          "L’environnement d’exécution a levé une erreur qui n’a pas été correctement traitée. Veuillez la signaler sur https://bugs.taler.net.",
        ],
      "Copy details": ["Copier les détails"],
      "Dismiss notification": ["Fermer la notification"],
      "Copy this text manually:": ["Copiez ce texte manuellement :"],
      "Technical details": ["Détails techniques"],
      "Select language": ["Sélectionner la langue"],
      "Languages": ["Langues"],
      "Loading": ["Chargement"],
      "Show notifications": ["Afficher les notifications"],
      "Open profile": ["Ouvrir le profil"],
      "Open settings": ["Ouvrir les paramètres"],
      "Close panel": ["Fermer le panneau"],
      "Menu": ["Menu"],
      "Sidebar": ["Barre latérale"],
      "Log out": ["Déconnexion"],
      "Sites": ["Sites"],
      "Copyright": ["Droits d’auteur"],
      "Version %1$s (%2$s)": ["Version %1$s (%2$s)"],
      "Testing with %1$s": ["Test avec %1$s"],
      "stop testing": ["arrêter le test"],
      "Learn more about %1$s": ["En savoir plus sur %1$s"],
      "Hide details": ["Masquer les détails"],
      "Show details": ["Afficher les détails"],
      "Show more info": ["Afficher plus d'informations"],
      "never": ["jamais"],
      "in %1$s": ["dans %1$s"],
      "%1$s ago": ["il y a %1$s"],
      "Pagination": ["Pagination"],
      "Page %1$s": ["Page %1$s"],
      "First page": ["Première page"],
      "Previous": ["Précédent"],
      "Next": ["Suivant"],
      "Checking compatibility of this webapp with backend service...": [
        "Vérification de la compatibilité de cette application avec le service backend…",
      ],
      "There was an error trying to contact the backend service.": [
        "Une erreur est survenue lors de la prise de contact avec le service backend.",
      ],
      'The server version is not supported. Supported version "%1$s", server version "%2$s"':
        [
          "La version du serveur n'est pas prise en charge. Version prise en charge « %1$s », version du serveur « %2$s »",
        ],
      "Retry": ["Réessayer"],
      'The server version is not supported. Supported version "%1$s".': [
        "La version du serveur n'est pas prise en charge. Version prise en charge : « %1$s ».",
      ],
      "Not recorded": ["Non enregistré"],
      "Provider": ["Fournisseur"],
      "Acceptance status": ["État de l’acceptation"],
      "Accepted": ["Accepté"],
      "Accepted terms version": ["Version des conditions acceptée"],
      "Terms opened or downloaded": ["Conditions ouvertes ou téléchargées"],
      "Yes": ["Oui"],
      "No": ["Non"],
      "Try again": ["Réessayer"],
      "Downloading PDF…": ["Téléchargement du PDF…"],
      "Download PDF": ["Télécharger le PDF"],
      "Done": ["Terminé"],
      "The terms are not available as Markdown or plain text.": [
        "Les conditions ne sont disponibles ni au format Markdown ni en texte brut.",
      ],
      "These terms are too large to display safely.": [
        "Ces conditions sont trop volumineuses pour être affichées en toute sécurité.",
      ],
      "The terms of service could not be loaded.": [
        "Les conditions d’utilisation n’ont pas pu être chargées.",
      ],
      "Close terms of service": ["Fermer les conditions d’utilisation"],
      "Loading terms of service…": ["Chargement des conditions d’utilisation…"],
      "The PDF could not be downloaded.": [
        "Le PDF n’a pas pu être téléchargé.",
      ],
      "Read the terms provided by %1$s before recording your acceptance.": [
        "Lisez les conditions fournies par %1$s avant d’enregistrer votre acceptation.",
      ],
      "Read terms again": ["Relire les conditions"],
      "Read terms": ["Lire les conditions"],
      "Your acceptance applies to the version shown above.": [
        "Votre acceptation s’applique à la version affichée ci-dessus.",
      ],
      "Review the terms of service": ["Consulter les conditions d’utilisation"],
      "Read the terms before recording your acceptance.": [
        "Lisez les conditions avant d’enregistrer votre acceptation.",
      ],
      "Accept the terms of service": ["Accepter les conditions d’utilisation"],
      "I have read and accept the terms of service": [
        "J’ai lu et j’accepte les conditions d’utilisation",
      ],
      "Open the terms before accepting them.": [
        "Ouvrez les conditions avant de les accepter.",
      ],
      "Email verification": ["Vérification de l’adresse courriel"],
      "Challenge email ownership.": [
        "Vérifier la possession de l'adresse courriel.",
      ],
      "E-Mail": ["Courriel"],
      "Postal verification": ["Vérification de l’adresse postale"],
      "Challenge address ownership.": [
        "Vérifier la possession de l'adresse postale.",
      ],
      "Name": ["Nom"],
      "Address": ["Adresse"],
      "Country": ["Pays"],
      "Phone verification": ["Vérification du téléphone"],
      "Challenge phone number ownership.": [
        "Vérifier la possession du numéro de téléphone.",
      ],
      "Phone": ["Téléphone"],
      "Generic note": ["Note générique"],
      "Free-form, generic note": ["Note générique, en texte libre"],
      "Note / Memorandum": ["Note / Mémorandum"],
      "Free-form notes": ["Notes en texte libre"],
      "Supplemental File Upload": ["Téléversement de fichier supplémentaire"],
      "Optional supplemental information for the establishment of the business relationship with the customer.":
        [
          "Informations supplémentaires facultatives pour l'établissement de la relation d'affaires avec le client.",
        ],
      "Supplemental Files": ["Fichiers supplémentaires"],
      "Description": ["Description"],
      "File (PDF)": ["Fichier (PDF)"],
      "Upload multiple documents": ["Téléverser plusieurs documents"],
      "Upload multiple documents.": ["Téléversez plusieurs documents."],
      "Requested documents": ["Documents demandés"],
      "Document identifier": ["Identifiant du document"],
      "Title": ["Titre"],
      "Required": ["Obligatoire"],
      "Document upload (%1$s)": ["Téléversement de document (%1$s)"],
      "Simple form": ["Formulaire simple"],
      "Full Name": ["Nom complet"],
      "Birthdate": ["Date de naissance"],
      "Comment": ["Commentaire"],
      "Resolution": ["Résolution"],
      "New state": ["Nouvel état"],
      "Frozen": ["Gelé"],
      "Pending": ["En attente"],
      "Normal": ["Normal"],
      "New threshold": ["Nouveau seuil"],
      "German": ["Allemand"],
      "English": ["Anglais"],
      "Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange (K)":
        [
          "Établissement de la personne de contrôle des entités juridiques et sociétés de personnes opérationnelles non cotées en bourse (K)",
        ],
      "for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnership that are beneficial owners":
        [
          "pour les entités juridiques et sociétés de personnes opérationnelles qui sont le partenaire contractant, ainsi que, par analogie, pour celles qui sont les ayants droit économiques",
        ],
      "Establishment of the controlling person (submitted by customer)": [
        "Établissement de la personne de contrôle (soumis par le client)",
      ],
      "Identity of the contracting partner": [
        "Identité du partenaire contractant",
      ],
      "Name and address": ["Nom et adresse"],
      "Contracting partner": ["Partenaire contractant"],
      "Controlling person(s)": ["Personne(s) de contrôle"],
      "Reason for control": ["Motif du contrôle"],
      "Holding 25% or more": ["Détention de 25 % ou plus"],
      "The person(s) listed below is/are holding 25% or more of the contracting partner's shares (capital shares or voting rights)":
        [
          "La ou les personnes indiquées ci-dessous détiennent 25 % ou plus des parts du partenaire contractant (parts de capital ou droits de vote)",
        ],
      "Other way": ["Autre moyen"],
      "If the capital shares or voting rights cannot be determined or in case there are no capital shares or voting rights 25% or more, the contracting partner hereby declares that the person(s) listed below is/are controlling the contracting partner in other ways":
        [
          "Si les parts de capital ou les droits de vote ne peuvent pas être déterminés, ou s'il n'existe pas de parts de capital ou de droits de vote de 25 % ou plus, le partenaire contractant déclare par la présente que la ou les personnes indiquées ci-dessous contrôlent le partenaire contractant par d'autres moyens",
        ],
      "Managing director": ["Directeur général"],
      "In case this/these person(s) cannot be determined or this/these person(s) does/do not exist, the contracting partner hereby declares that the person(s) listed below is/are the managing director(s)":
        [
          "Si cette ou ces personnes ne peuvent pas être déterminées ou n'existent pas, le partenaire contractant déclare par la présente que la ou les personnes indiquées ci-dessous sont le ou les directeurs généraux",
        ],
      "Can't be empty": ["Ne peut pas être vide"],
      "Full name": ["Nom complet"],
      "Actual address of domicile": ["Adresse de domicile actuelle"],
      "Fiduciary holding assets": ["Détention fiduciaire d'actifs"],
      "Is a third person the beneficial owner of the assets held in the account/securities account?":
        [
          "Une tierce personne est-elle l'ayant droit économique des actifs détenus sur le compte/compte de titres ?",
        ],
      "Signature(s)": ["Signature(s)"],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery)":
        [
          "Fournir délibérément de fausses informations sur ce formulaire constitue une infraction pénale (article 251 du Code pénal suisse, faux dans les titres)",
        ],
      "The contracting partner hereby undertakes to inform automatically of any changes to the information contained herein.":
        [
          "Le partenaire contractant s'engage par la présente à signaler spontanément toute modification des informations contenues dans le présent document.",
        ],
      "Date": ["Date"],
      "Establishment of the controlling person (submitted by AML officer)": [
        "Établissement de la personne de contrôle (soumis par le responsable LBA)",
      ],
      "Signed Declaration": ["Déclaration signée"],
      "Signed declaration by the customer": [
        "Déclaration signée par le client",
      ],
      "The uploaded document must contain the customer's signature on the beneficial owner declaration.":
        [
          "Le document téléversé doit contenir la signature du client sur la déclaration de l'ayant droit économique.",
        ],
      "Signed Document": ["Document signé"],
      "invalid format": ["format non valide"],
      "it can't be in the future": ["cela ne peut pas être dans le futur"],
      "it can't be greater than 120 years": [
        "cela ne peut pas dépasser 120 ans",
      ],
      "Last name(s), first name(s)/entity": ["Nom(s), prénom(s)/entité"],
      "Actual address of domicile/registered office": [
        "Adresse effective du domicile/siège social",
      ],
      "Date(s) of birth": ["Date(s) de naissance"],
      "Nationality": ["Nationalité"],
      "Date of death (if deceased)": [
        "Date du décès (si la personne est décédée)",
      ],
      "Foundations (as well as similar constructs) (S)": [
        "Fondations (ainsi que constructions similaires) (S)",
      ],
      "Declaration for foundations and similar constructs.": [
        "Déclaration relative aux fondations et constructions similaires.",
      ],
      "Contracting partner and foundation": [
        "Partenaire contractant et fondation",
      ],
      "The undersigned hereby declare(s) that as board member of the foundation, or of the highest supervisory body of an underlying company of a foundation, known as:":
        [
          "Le ou les soussignés déclarent par la présente agir en qualité de membre du conseil de fondation ou de l’organe de surveillance suprême d’une société sous-jacente à une fondation dénommée :",
        ],
      "Name of the foundation": ["Nom de la fondation"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following:":
        [
          "et fournissent, en cette qualité et au mieux de leur connaissance, les informations suivantes :",
        ],
      "Name and information pertaining to the foundation": [
        "Nom et informations concernant la fondation",
      ],
      "Type of foundation": ["Type de fondation"],
      "Discretionary foundation": ["Fondation discrétionnaire"],
      "Non-discretionary foundation": ["Fondation non discrétionnaire"],
      "Revocability": ["Révocabilité"],
      "Revocable foundation": ["Fondation révocable"],
      "Irrevocable foundation": ["Fondation irrévocable"],
      "Information pertaining to the founder": [
        "Informations concernant le fondateur",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, founder (individual(s) or entity/entities).":
        [
          "Informations concernant le fondateur économique ultime, et non fiduciaire (personne(s) physique(s) ou entité(s)).",
        ],
      "Founder(s)": ["Fondateur(s)"],
      "Does the founder have the right to revoke the foundation?": [
        "Le fondateur a-t-il le droit de révoquer la fondation ?",
      ],
      "Founders of pre-existing foundations": [
        "Fondateurs de fondations préexistantes",
      ],
      "Complete this section if the foundation results from a restructuring (re-settlement) or merger of pre-existing foundations.":
        [
          "Remplissez cette section si la fondation résulte d’une restructuration (nouvelle constitution) ou de la fusion de fondations préexistantes.",
        ],
      "Founder(s) of the pre-existing foundation(s)": [
        "Fondateur(s) de la ou des fondations préexistantes",
      ],
      "Beneficiaries": ["Bénéficiaires"],
      "Beneficiaries determined at the time this form is signed": [
        "Bénéficiaires déterminés au moment de la signature du présent formulaire",
      ],
      "Does the beneficiary have an actual right to claim distributions?": [
        "Le bénéficiaire dispose-t-il d’un droit effectif d’exiger des distributions ?",
      ],
      "Known group(s) of beneficiaries": [
        "Groupe(s) connu(s) de bénéficiaires",
      ],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the founder).":
        [
          "En plus des bénéficiaires désignés, ou si aucun bénéficiaire n’a été désigné (par exemple, les descendants du fondateur).",
        ],
      "Provide at least one beneficiary or group of beneficiaries": [
        "Indiquez au moins un bénéficiaire ou un groupe de bénéficiaires",
      ],
      "Further persons": ["Autres personnes"],
      "Persons entitled to determine or nominate representatives of the foundation when those representatives may dispose of assets or change asset distributions or the nomination of beneficiaries.":
        [
          "Personnes habilitées à désigner ou à nommer des représentants de la fondation lorsque ces représentants peuvent disposer des actifs ou modifier leur distribution ou la désignation des bénéficiaires.",
        ],
      "Further person(s)": ["Autre(s) personne(s)"],
      "Is/are there (a) further person(s) with the right to revoke the foundation?":
        [
          "Existe-t-il d’autres personnes ayant le droit de révoquer la fondation ?",
        ],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery).":
        [
          "Fournir délibérément de fausses informations dans ce formulaire constitue une infraction pénale (faux dans les titres au sens de l’article 251 du Code pénal suisse).",
        ],
      "The contracting partner(s) undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Le ou les partenaires contractants s’engagent à signaler spontanément toute modification des informations contenues dans le présent document.",
        ],
      "Declaration for trusts (T)": ["Déclaration relative aux trusts (T)"],
      "Declaration for trusts.": ["Déclaration relative aux trusts."],
      "Contracting partner and trust": ["Partenaire contractant et trust"],
      "The undersigned hereby declare(s) that as trustee or a member of highest supervisory body of an underlying company of a trust known as:":
        [
          "Le ou les soussignés déclarent par la présente agir en qualité de trustee ou de membre de l’organe de surveillance suprême d’une société sous-jacente à un trust dénommé :",
        ],
      "Name of the trust": ["Nom du trust"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following information:":
        [
          "et fournissent, en cette qualité et au mieux de leur connaissance, les informations suivantes :",
        ],
      "Name and information pertaining to the trust": [
        "Nom et informations concernant le trust",
      ],
      "Type of trust": ["Type de trust"],
      "Discretionary trust": ["Trust discrétionnaire"],
      "Non-discretionary trust": ["Trust non discrétionnaire"],
      "Revocable trust": ["Trust révocable"],
      "Irrevocable trust": ["Trust irrévocable"],
      "Information pertaining to the settlor": [
        "Informations concernant le constituant",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, settlor of the trust (individual(s) or entity/entities).":
        [
          "Informations concernant le constituant économique ultime, et non fiduciaire, du trust (personne(s) physique(s) ou entité(s)).",
        ],
      "Settlor(s)": ["Constituant(s)"],
      "Does the settlor have the right to revoke the trust?": [
        "Le constituant a-t-il le droit de révoquer le trust ?",
      ],
      "Settlors of pre-existing trusts": [
        "Constituants de trusts préexistants",
      ],
      "Complete this section if the trust results from a restructuring (re-settlement) or merger of pre-existing trusts.":
        [
          "Remplissez cette section si le trust résulte d’une restructuration (nouvelle constitution) ou de la fusion de trusts préexistants.",
        ],
      "Settlor(s) of the pre-existing trust(s)": [
        "Constituant(s) du ou des trusts préexistants",
      ],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the settlor).":
        [
          "En plus des bénéficiaires désignés, ou si aucun bénéficiaire n’a été désigné (par exemple, les descendants du constituant).",
        ],
      "Protectors": ["Protecteurs"],
      "Protector(s)": ["Protecteur(s)"],
      "Does the protector have the right to revoke the trust?": [
        "Le protecteur a-t-il le droit de révoquer le trust ?",
      ],
      "Further persons having the right to appoint the trustee of a trust.": [
        "Autres personnes ayant le droit de nommer le trustee d’un trust.",
      ],
      "Do any further persons have the right to revoke the trust?": [
        "D’autres personnes ont-elles le droit de révoquer le trust ?",
      ],
      "The contracting partner(s) hereby declare(s) to be entitled to open a business relationship for the trust above or its underlying company.":
        [
          "Le ou les partenaires contractants déclarent par la présente être habilités à ouvrir une relation d’affaires pour le trust susmentionné ou sa société sous-jacente.",
        ],
      "The contracting partner(s) hereby undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Le ou les partenaires contractants s’engagent par la présente à signaler spontanément toute modification des informations contenues dans le présent document.",
        ],
      "The customer is the person with whom the member concludes the contract with regard to the financial service provided (civil law). If the\n  member acts as the director of a domiciliary company, then that domiciliary company is the customer.":
        [
          "Le client est la personne avec laquelle le membre conclut le contrat concernant le service financier fourni (droit civil). Si le\n  membre agit en tant qu'administrateur d'une société de domicile, alors cette société de domicile est le client.",
        ],
      "Identification Form (customer)": [
        "Formulaire d'identification (client)",
      ],
      "The customer has to be identified on entering into a permanent business relationship or on concluding a cash transaction, which meets the according threshold.":
        [
          "Le client doit être identifié lors de l'établissement d'une relation d'affaires durable ou de la conclusion d'une transaction en espèces atteignant le seuil correspondant.",
        ],
      "Correspondence language:": ["Langue de correspondance :"],
      "French": ["Français"],
      "Italian": ["Italien"],
      "Identification form (basic customer information)": [
        "Formulaire d'identification (informations de base sur le client)",
      ],
      "Information on customer": ["Informations sur le client"],
      "Customer type": ["Type de client"],
      "Natural person (incl. sole proprietors)": [
        "Personne physique (y compris les entrepreneurs individuels)",
      ],
      "Legal entity": ["Personne morale"],
      "Applicable if customer is a natural person": [
        "Applicable si le client est une personne physique",
      ],
      "Residential address in Switzerland": ["Adresse de domicile en Suisse"],
      "Telephone": ["Téléphone"],
      "Email": ["Courriel"],
      "Date of birth": ["Date de naissance"],
      "Copy of identification document": ["Copie d'une pièce d'identité"],
      "Only official government IDs (incl. passports) are accepted. Please scan both sides if applicable.":
        [
          "Seules les pièces d'identité officielles délivrées par une autorité (y compris les passeports) sont acceptées. Veuillez scanner les deux faces si applicable.",
        ],
      "Sole proprietor": ["Entrepreneur individuel"],
      "Information on customer (sole proprietor)": [
        "Informations sur le client (entrepreneur individuel)",
      ],
      "Applicable only if customer is a sole proprietor": [
        "Applicable uniquement si le client est un entrepreneur individuel",
      ],
      "Company name": ["Raison sociale"],
      "Registered office": ["Siège social"],
      "Company identification document": [
        "Document d'identification de la société",
      ],
      "Information on customer (legal entity)": [
        "Informations sur le client (personne morale)",
      ],
      "Applicable if customer is a legal entity": [
        "Applicable si le client est une personne morale",
      ],
      "Domicile": ["Domicile"],
      "Contact person": ["Personne de contact"],
      "Copy of identification document (not older than 12 months)": [
        "Copie d'une pièce d'identité (datant de moins de 12 mois)",
      ],
      "Company share registry file": [
        "Registre des actionnaires de la société",
      ],
      "Correspondence Preferences": ["Préférences de correspondance"],
      "Information on the natural persons who establish the business relationship for legal entities and partnerships":
        [
          "Informations sur les personnes physiques qui établissent la relation d'affaires pour le compte de personnes morales et de sociétés de personnes",
        ],
      "For legal entities and partnerships the identity of the natural persons who establish the business relationship must be verified.":
        [
          "Pour les personnes morales et les sociétés de personnes, l'identité des personnes physiques qui établissent la relation d'affaires doit être vérifiée.",
        ],
      "Persons establishing the legal relationship": [
        "Personnes établissant la relation d'affaires",
      ],
      "Residential address": ["Adresse de domicile"],
      "Signing authority of the person": [
        "Pouvoir de signature de la personne",
      ],
      "Power of attorney arrangements": ["Modalités de procuration"],
      "Sole signature authority": ["Pouvoir de signature individuelle"],
      "Collective authority with two signatures": [
        "Pouvoir de signature collective à deux",
      ],
      "Other (please specify)": ["Autre (veuillez préciser)"],
      "Other type of signing authority": ["Autre type de pouvoir de signature"],
      "Evidence of signing authority:": [
        "Justificatif du pouvoir de signature :",
      ],
      "Company register extract": ["Extrait du registre du commerce"],
      "Mandate": ["Mandat"],
      "Other": ["Autre"],
      "Specify other way of establishing signing authority:": [
        "Précisez un autre moyen d'établir le pouvoir de signature :",
      ],
      "Copy of document that serves as evidence of signing authority:": [
        "Copie du document servant de justificatif du pouvoir de signature :",
      ],
      "Customer classification": ["Classification du client"],
      "Classification for the establishment of the beneficial owner of the assets and/or controlling person":
        [
          "Classification pour la détermination de l'ayant droit économique des avoirs et/ou de la personne de contrôle",
        ],
      "The customer is:": ["Le client est :"],
      "A natural person and there are no doubts that this person is the sole beneficial owner of the assets":
        [
          "Une personne physique, sans aucun doute quant au fait qu'elle est l'unique ayant droit économique des avoirs",
        ],
      "An operational legal entity or partnership": [
        "Une personne morale opérationnelle ou une société de personnes",
      ],
      "A foundation (or a similar construct; incl. underlying companies)": [
        "Une fondation (ou une structure similaire ; y compris les sociétés sous-jacentes)",
      ],
      "A trust (incl. underlying companies)": [
        "Un trust (y compris les sociétés sous-jacentes)",
      ],
      "A life insurance policy with separately managed accounts / securities accounts (so-called insurance wrappers)":
        [
          "Une police d'assurance-vie avec comptes ou comptes-titres gérés séparément (dites « enveloppes d'assurance »)",
        ],
      "Special Clarifications": ["Clarifications particulières"],
      "When a business relationship or transaction is associated with increased risk, appears unusual or evidence exists that the assets are the proceeds of a felony or a qualified tax offence, the member has to perform additional clarifications.":
        [
          "Lorsqu'une relation d'affaires ou une transaction présente un risque accru, semble inhabituelle ou qu'il existe des indices que les valeurs patrimoniales proviennent d'un crime ou d'un délit fiscal qualifié, le membre doit procéder à des clarifications supplémentaires.",
        ],
      "Customer": ["Client"],
      "Reason for special clarifications": [
        "Motif des clarifications particulières",
      ],
      "Reason": ["Motif"],
      "Description of the circumstances/transactions, which triggered the special clarifications":
        [
          "Description des circonstances/transactions ayant déclenché les clarifications particulières",
        ],
      "can't be empty": ["ne peut pas être vide"],
      "Used means of clarification": ["Moyens de clarification utilisés"],
      "Means": ["Moyens"],
      "Gathering of information from the customer, beneficial owner of the assets, controlling person":
        [
          "Collecte d'informations auprès du client, de l'ayant droit économique des actifs, de la personne de contrôle",
        ],
      "Consultation of generally accessible sources and databases": [
        "Consultation de sources et bases de données généralement accessibles",
      ],
      "Enquiries with trustworthy persons": [
        "Renseignements auprès de personnes dignes de confiance",
      ],
      "Other, which?": ["Autre, lequel ?"],
      "Other means of clarification:": ["Autres moyens de clarification :"],
      "Optional supplemental information for the special clarifications.": [
        "Informations supplémentaires facultatives pour les clarifications particulières.",
      ],
      "Summary and plausibility check of the gathered information": [
        "Résumé et vérification de la plausibilité des informations recueillies",
      ],
      "The results of the clarifications have to be documented and their plausibility has to be checked.":
        [
          "Les résultats des clarifications doivent être documentés et leur plausibilité doit être vérifiée.",
        ],
      "Summary": ["Résumé"],
      "Gathered/Consulted documents": ["Documents recueillis/consultés"],
      "Result of the special clarification": [
        "Résultat de la clarification particulière",
      ],
      "Result": ["Résultat"],
      "No suspicion": ["Aucun soupçon"],
      "The plausibility of the circumstances could be checked, no reasonable suspicion pursuant to Art. 9 AMLA (possibly update of customer profile and/or risk profile)":
        [
          "La plausibilité des circonstances a pu être vérifiée, aucun soupçon fondé au sens de l'art. 9 LBA (mise à jour éventuelle du profil client et/ou du profil de risque)",
        ],
      "Reasonable suspicion": ["Soupçon fondé"],
      "Reasonable suspicion pursuant to Art. 9 AMLA, duty to file a report with MROS":
        [
          "Soupçon fondé au sens de l'art. 9 LBA, obligation de communication au MROS",
        ],
      "Simple suspicion": ["Soupçon simple"],
      "Simple suspicion pursuant to Art. 305ter Para. 2 StGB, right to notify MROS":
        [
          "Soupçon simple au sens de l'art. 305ter, al. 2, CP, droit de communication au MROS",
        ],
      "Other, what?": ["Autre, quoi ?"],
      "Result clarification": ["Résultat de la clarification"],
      "Identification Form (acceptance)": [
        "Formulaire d'identification (acceptation)",
      ],
      "Acceptance of business relationship": [
        "Acceptation de la relation d'affaires",
      ],
      "Date (conclusion of contract):": ["Date (conclusion du contrat) :"],
      "Accepted via:": ["Accepté via :"],
      "Face to face": ["En face à face"],
      "Authenticated copy of identification document": [
        "Copie certifiée conforme d'une pièce d'identité",
      ],
      "Residential address validated": ["Adresse de domicile vérifiée"],
      "Further information:": ["Informations complémentaires :"],
      "Evaluation with regard to embargo procedures/terrorism lists on establishing the business relationship":
        [
          "Évaluation au regard des procédures d'embargo / listes de terrorisme lors de l'établissement de la relation d'affaires",
        ],
      "Verification whether the customer, beneficial owners of the assets, controlling persons, authorized representatives or other involved persons are listed on an embargo/terrorism list.":
        [
          "Vérification que le client, les ayants droit économiques des avoirs, les personnes de contrôle, les représentants autorisés ou d'autres personnes impliquées ne figurent pas sur une liste d'embargo ou de terrorisme.",
        ],
      "Embargo/terrorism status:": ["Statut embargo/terrorisme :"],
      "Not listed on embargo/terrorism list.": [
        "Ne figure pas sur une liste d'embargo ou de terrorisme.",
      ],
      "Listed on embargo/terrorism list.": [
        "Figure sur une liste d'embargo ou de terrorisme.",
      ],
      "Embargo/terrorism information:": [
        "Informations sur l'embargo/le terrorisme :",
      ],
      "Verification date": ["Date de vérification"],
      "Supplemental files": ["Documents complémentaires"],
      "Risk Profile AMLA": ["Profil de risque LBA"],
      "Evaluation of politically exposed persons (PEP-Check)": [
        "Évaluation des personnes politiquement exposées (contrôle PPE)",
      ],
      "This evaluation has to be completed by all members for every business relationship.":
        [
          "Cette évaluation doit être complétée par tous les membres pour chaque relation d'affaires.",
        ],
      "Foreign PEP": ["PPE étrangère"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a foreign PEP or closely related to such a person?":
        [
          "Le client, l'ayant droit économique, la personne de contrôle ou le représentant autorisé est-il une PPE étrangère ou étroitement lié(e) à une telle personne ?",
        ],
      "Domestic PEP": ["PPE nationale"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a domestic PEP or closely related to such a person?":
        [
          "Le client, l'ayant droit économique, la personne de contrôle ou le représentant autorisé est-il une PPE nationale ou étroitement lié(e) à une telle personne ?",
        ],
      "PEP of International Organisations": [
        "PPE d'organisations internationales",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a PEP in International Organisations or closely related to such a person?":
        [
          "Le client, l'ayant droit économique, la personne de contrôle ou le représentant autorisé est-il une PPE d'organisations internationales ou étroitement lié(e) à une telle personne ?",
        ],
      "Acceptance date": ["Date d'acceptation"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with a PEP was obtained on.":
        [
          "Date à laquelle la décision de l'organe de direction supérieur relative à l'acceptation d'une relation d'affaires avec une PPE a été obtenue.",
        ],
      'Evaluation "high risk" or non-cooperative country': [
        "Évaluation « pays à haut risque » ou non coopératif",
      ],
      "High-risk or non-cooperative country": [
        "Pays à haut risque ou non coopératif",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative in a country considered by the FATF as high-risk or non-cooperative and for which FATF requires increased diligence?":
        [
          "Le client, l'ayant droit économique, la personne de contrôle ou le représentant autorisé se trouve-t-il dans un pays considéré par le GAFI comme à haut risque ou non coopératif et pour lequel le GAFI exige une diligence accrue ?",
        ],
      "When the decision of the Senior executive body on the acceptance of such a business relationship was obtained on.":
        [
          "Date à laquelle la décision de l'organe de direction supérieur relative à l'acceptation d'une telle relation d'affaires a été obtenue.",
        ],
      "Evaluation of business relationship risk": [
        "Évaluation du risque de la relation d'affaires",
      ],
      "Country risk": ["Risque pays"],
      "Applicable country risk types": ["Types de risque pays applicables"],
      "Nationality of the customer": ["Nationalité du client"],
      "Nationality of the beneficial owner of the assets": [
        "Nationalité de l'ayant droit économique des avoirs",
      ],
      "Domicile/residential address of the customer": [
        "Domicile / adresse de domicile du client",
      ],
      "Domicile/residential address of the beneficial owner of the assets": [
        "Domicile / adresse de domicile de l'ayant droit économique des avoirs",
      ],
      "Domicile/residential address of the controlling person": [
        "Domicile / adresse de domicile de la personne de contrôle",
      ],
      "Country risk level (nationality)": [
        "Niveau de risque pays (nationalité)",
      ],
      "Risk category according to VQF country list (VQF doc. no. 902.4.1)": [
        "Catégorie de risque selon la liste des pays VQF (doc. VQF n° 902.4.1)",
      ],
      "Low (Risk 0)": ["Faible (risque 0)"],
      "Risk 0 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risque 0 selon la liste des pays VQF (doc. VQF n° 902.4.1)",
      ],
      "Medium (Risk 1)": ["Moyen (risque 1)"],
      "Risk 1 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risque 1 selon la liste des pays VQF (doc. VQF n° 902.4.1)",
      ],
      "High (Risk 2)": ["Élevé (risque 2)"],
      "Risk 2 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risque 2 selon la liste des pays VQF (doc. VQF n° 902.4.1)",
      ],
      "Country risk type (place of business activity)": [
        "Type de risque pays (lieu de l'activité commerciale)",
      ],
      "Beneficial owner": ["Ayant droit économique"],
      "Country risk level (business activity)": [
        "Niveau de risque pays (activité commerciale)",
      ],
      "Industry risk": ["Risque sectoriel"],
      "Industry risk source": ["Source du risque sectoriel"],
      "Beneficial owner of the assets": ["Ayant droit économique des avoirs"],
      "Industry risk level": ["Niveau de risque sectoriel"],
      "Transparent (Risk Level 0)": ["Transparent (niveau de risque 0)"],
      "Clearly defined, transparent, easily comprehensible business activity well known to the member.":
        [
          "Activité commerciale clairement définie, transparente, facilement compréhensible et bien connue du membre.",
        ],
      "High cash transactions (Risk Level 1)": [
        "Volume élevé de transactions en espèces (niveau de risque 1)",
      ],
      "Business activity with a high level of cash transactions.": [
        "Activité commerciale impliquant un niveau élevé de transactions en espèces.",
      ],
      "Not well known (Risk Level 1)": ["Peu connu (niveau de risque 1)"],
      "Business activity not well known to the member.": [
        "Activité commerciale peu connue du membre.",
      ],
      "High-risk trade (Risk Level 2)": [
        "Commerce à haut risque (niveau de risque 2)",
      ],
      "Trade in munitions/arms, raw gem stones/diamonds, jewellery, international trade in exotic animals, casino and lottery business, trade in erotic wares.":
        [
          "Commerce de munitions/armes, de pierres précieuses brutes/diamants, de bijoux, commerce international d'animaux exotiques, activités de casino et de loterie, commerce d'articles érotiques.",
        ],
      "Unknown industry (Risk Level 2)": [
        "Secteur d’activité inconnu (niveau de risque 2)",
      ],
      "Member has no personal knowledge of the customer’s industry.": [
        "Le membre n'a aucune connaissance personnelle du secteur d'activité du client.",
      ],
      "Contact risk": ["Risque de contact"],
      "Type of contact to the customer/beneficial owner of the assets.": [
        "Type de contact avec le client / l'ayant droit économique des avoirs.",
      ],
      "Contact risk level": ["Niveau de risque de contact"],
      "Low contact risk": ["Risque de contact faible"],
      "Personal acquaintance between member and customer/beneficial owner of the assets over several years (at least 2) prior to entering into the business relationship":
        [
          "Connaissance personnelle entre le membre et le client / l'ayant droit économique des avoirs depuis plusieurs années (au moins 2) avant l'établissement de la relation d'affaires",
        ],
      "Medium contact risk": ["Risque de contact moyen"],
      "The customer/beneficial owner was not personally known to the member for several years (at least 2) prior to entering into the business relationship; however (a) no business was entered into in the absence of the customer/beneficial owner, or (b) the customer was at least introduced/brokered by a trusted third party.":
        [
          "Le client / l'ayant droit économique n'était pas connu personnellement du membre depuis plusieurs années (au moins 2) avant l'établissement de la relation d'affaires ; toutefois (a) aucune opération n'a été conclue en l'absence du client / de l'ayant droit économique, ou (b) le client a au moins été présenté ou mis en relation par un tiers de confiance.",
        ],
      "High contact risk": ["Risque de contact élevé"],
      "The customer/beneficial owner was not personally known to the member and business was entered into in the absence of the former (relationship by correspondence) and the customer was not introduced/brokered by a trusted third party.":
        [
          "Le client / l'ayant droit économique n'était pas connu personnellement du membre et l'opération a été conclue en son absence (relation par correspondance), et le client n'a pas été présenté ou mis en relation par un tiers de confiance.",
        ],
      "Summary evaluation": ["Évaluation récapitulative"],
      "Justification for risk assessment": [
        "Justification de l'évaluation des risques",
      ],
      "Risk classification": ["Classification du risque"],
      "Conclusion whether the business relationship is with or without increased risk.":
        [
          "Conclusion quant à savoir si la relation d'affaires présente ou non un risque accru.",
        ],
      "No high risk": ["Pas de risque élevé"],
      "High risk": ["Risque élevé"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with increased risk was obtained on.":
        [
          "Date à laquelle la décision de l'organe de direction supérieur relative à l'acceptation d'une relation d'affaires présentant un risque accru a été obtenue.",
        ],
      "Customer Profile": ["Profil du client"],
      "The information below has to refer to the persons from whom the assets originate ultimately (e.g. beneficial owner of the assets, founder/creator of a trust or foundation). Is the customer an operational legal entity or partnership the information may refer to the entity itself (not to the controlling person), unless the entity holds the assets in trust for a third party.":
        [
          "Les informations ci-dessous doivent se rapporter aux personnes dont proviennent en dernier ressort les avoirs (p. ex. l'ayant droit économique des avoirs, le fondateur/créateur d'un trust ou d'une fondation). Si le client est une personne morale opérationnelle ou une société de personnes, les informations peuvent se rapporter à l'entité elle-même (et non à la personne de contrôle), sauf si l'entité détient les avoirs en fiducie pour un tiers.",
        ],
      "Business activity": ["Activité commerciale"],
      "Profession, business activities, etc. (former, current, potentially planned)":
        [
          "Profession, activités commerciales, etc. (antérieures, actuelles, éventuellement prévues)",
        ],
      "Financial circumstances": ["Situation financière"],
      "Income and assets, liabilities (estimated)": [
        "Revenus et avoirs, engagements (estimés)",
      ],
      "Origin of the deposited assets involved": [
        "Origine des avoirs déposés concernés",
      ],
      "Will the customer deposit assets with Taler Operations AG?": [
        "Le client va-t-il déposer des avoirs auprès de Taler Operations AG ?",
      ],
      "Nature, amount and currency of deposited assets.": [
        "Nature, montant et devise des avoirs déposés.",
      ],
      "Category": ["Catégorie"],
      "Savings": ["Épargne"],
      "Own business operations": ["Activités commerciales propres"],
      "Inheritance": ["Héritage"],
      "Category clarification": ["Précision sur la catégorie"],
      "Detailed description of the origins/economic background of the assets involved in the business relationship":
        [
          "Description détaillée de l'origine/du contexte économique des avoirs impliqués dans la relation d'affaires",
        ],
      "Nature and purpose of the business relationship": [
        "Nature et but de la relation d'affaires",
      ],
      "Purpose of the business relationship": ["But de la relation d'affaires"],
      "Information on the planned development of the business relationship and the assets":
        [
          "Informations sur le développement prévu de la relation d'affaires et des avoirs",
        ],
      "Details on usual business volume": [
        "Précisions sur le volume d'affaires habituel",
      ],
      "Relationship with third parties": ["Relations avec des tiers"],
      "Relation of the customer to the beneficial owner, controlling persons, authorised signatories and other persons involved in the business relationship":
        [
          "Relation du client avec l'ayant droit économique, les personnes de contrôle, les signataires autorisés et les autres personnes impliquées dans la relation d'affaires",
        ],
      "Relation to other AMLA-Files": ["Relation avec d'autres dossiers LBA"],
      "Introducer / agents / references": [
        "Apporteur d'affaires / agents / références",
      ],
      "Further information": ["Informations complémentaires"],
      "Other relevant information": ["Autres informations pertinentes"],
      "Declaration of identity of the beneficial owner (A) — customer": [
        "Déclaration d’identité de l’ayant droit économique (A) — client",
      ],
      "The customer completes the declaration directly in the form.": [
        "Le client remplit la déclaration directement dans le formulaire.",
      ],
      "Declaration of identity of the beneficial owner": [
        "Déclaration d'identité de l'ayant droit économique",
      ],
      "Beneficial owner details": ["Coordonnées de l'ayant droit économique"],
      "Beneficial owner(s)": ["Ayant(s) droit économique(s)"],
      "The person(s) listed below is/are the beneficial owner(s) of the assets involved in the business relationship. If the contracting partner is also the sole beneficial owner of the assets, the contracting partner's detail must be set out below":
        [
          "La ou les personnes énumérées ci-dessous sont l'ayant droit économique ou les ayants droit économiques des avoirs impliqués dans la relation d'affaires. Si le cocontractant est également l'unique ayant droit économique des avoirs, ses coordonnées doivent être indiquées ci-dessous.",
        ],
      "Domicile address": ["Adresse de domicile"],
      "Declaration of identity of the beneficial owner (A) — AML officer": [
        "Déclaration d’identité de l’ayant droit économique (A) — responsable LBA",
      ],
      "The AML officer records the declaration and uploads the customer's signed PDF.":
        [
          "Le responsable LBA saisit la déclaration et téléverse le PDF signé par le client.",
        ],
      "January": ["Janvier"],
      "February": ["Février"],
      "March": ["Mars"],
      "April": ["Avril"],
      "May": ["Mai"],
      "June": ["Juin"],
      "July": ["Juillet"],
      "August": ["Août"],
      "September": ["Septembre"],
      "October": ["Octobre"],
      "November": ["Novembre"],
      "December": ["Décembre"],
      "Previous year": ["Année précédente"],
      "Next year": ["Année suivante"],
      "Previous month": ["Mois précédent"],
      "Next month": ["Mois suivant"],
      "Close dialog": ["Fermer la boîte de dialogue"],
      "Official form language": ["Langue officielle du formulaire"],
      "This form is shown in an official, legally binding language.": [
        "Ce formulaire est affiché dans une langue officielle faisant foi.",
      ],
      "Official translation": ["Traduction officielle"],
      "This form is shown in an official translation, but it is not legally binding. Only the %1$s text is legally binding.":
        [
          "Ce formulaire est affiché dans une traduction officielle, mais celle-ci ne fait pas foi. Seul le texte en %1$s fait foi.",
        ],
      "Unofficial form translation": [
        "Traduction non officielle du formulaire",
      ],
      "This form is not officially supported in the selected language. The translation may be incomplete, and some text may be shown in %1$s. Only the %2$s text is legally binding.":
        [
          "Ce formulaire n’est pas officiellement disponible dans la langue sélectionnée. La traduction peut être incomplète et certains textes peuvent être affichés en %1$s. Seul le texte en %2$s fait foi.",
        ],
      "Shorten file contents.": ["Abréger le contenu des fichiers."],
      "Result JSON:": ["Résultat JSON :"],
      "List of fields with errors": ["Liste des champs comportant des erreurs"],
      "Delete this item?": ["Supprimer cet élément ?"],
      "Keep item": ["Conserver l’élément"],
      "Delete item": ["Supprimer l’élément"],
      "Cancel": ["Annuler"],
      "Delete": ["Supprimer"],
      "Add item": ["Ajouter un élément"],
      "Save changes": ["Enregistrer les modifications"],
      "Item %1$s": ["Élément %1$s"],
      "Edit %1$s": ["Modifier %1$s"],
      "Edit": ["Modifier"],
      "Clear selection": ["Effacer la sélection"],
      "Toggle choices": ["Afficher les choix"],
      "No element found": ["Aucun élément trouvé"],
      "years": ["ans"],
      "months": ["mois"],
      "days": ["jours"],
      "hours": ["heures"],
      "minutes": ["minutes"],
      "seconds": ["secondes"],
      "No expiration": ["Sans date d’expiration"],
      "Forever": ["Indéfiniment"],
      "The selected file is too large.": [
        "Le fichier sélectionné est trop volumineux.",
      ],
      "The selected file could not be read.": [
        "Le fichier sélectionné n’a pas pu être lu.",
      ],
      "Upload a file": ["Téléverser un fichier"],
      "Clear": ["Effacer"],
      "Download a copy.": ["Télécharger une copie."],
      "This option is not available.": ["Cette option n’est pas disponible."],
      "The maximum number of selections has been reached.": [
        "Le nombre maximal de sélections a été atteint.",
      ],
      "Remove %1$s": ["Supprimer %1$s"],
      "Simple comment": ["Commentaire simple"],
      "Terms URL": ["URL des conditions"],
      "Terms version": ["Version des conditions"],
      "Provider name": ["Nom du fournisseur"],
      "Only show the external link": ["Afficher uniquement le lien externe"],
      "Name and birthdate": ["Nom et date de naissance"],
      "Select an example from the list on the left.": [
        "Sélectionnez un exemple dans la liste de gauche.",
      ],
      "Example not found.": ["Exemple introuvable."],
      "An error occurred while rendering the example.": [
        "Une erreur s’est produite lors de l’affichage de l’exemple.",
      ],
      "Group": ["Groupe"],
      "Component": ["Composant"],
      "Example": ["Exemple"],
      "Arguments": ["Arguments"],
      "Dataset": ["Jeu de données"],
      "Dataset %1$s of %2$s": ["Jeu de données %1$s sur %2$s"],
      "Select a story": ["Sélectionner un exemple"],
      "Open stories navigation": ["Ouvrir la navigation des exemples"],
      "Stories navigation": ["Navigation des exemples"],
      "Stories": ["Exemples"],
      "Close stories navigation": ["Fermer la navigation des exemples"],
      "Language": ["Langue"],
      "%1$s": ["%1$s"],
      "Free-form message": ["Message libre"],
      "Are you a cross-border truck driver?": [
        "Êtes-vous chauffeur de camion transfrontalier ?",
      ],
      "How much cash are you carrying?": [
        "Combien d’espèces transportez-vous ?",
      ],
      "Germany": ["Allemagne"],
      "Switzerland": ["Suisse"],
      "Sign-in failed": ["Échec de la connexion"],
      "Check your password.": ["Vérifiez votre mot de passe."],
      "Try again in a moment.": ["Réessayez dans un instant."],
      "First error": ["Première erreur"],
      "First description": ["Première description"],
      "Second error": ["Deuxième erreur"],
      "Second description": ["Deuxième description"],
      "Saved": ["Enregistré"],
      "Request failed": ["Échec de la requête"],
      "Try again.": ["Réessayez."],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n > 1;",
  lang: "fr",
  completeness: 100,
};

strings["es"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "es_AR",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "required": ["obligatorio"],
      "Validation failed unexpectedly. Please contact the developers: %1$s": [
        "La validación falló inesperadamente. Contacte a los desarrolladores: %1$s",
      ],
      "Terms of service": ["Términos de servicio"],
      "Read the terms of service before continuing.": [
        "Lea los términos de servicio antes de continuar.",
      ],
      "Terms acceptance": ["Aceptación de los términos"],
      "Accept the terms of service before continuing.": [
        "Acepte los términos de servicio antes de continuar.",
      ],
      "Looks like the JSON in the request was malformed.": [
        "Parece que el JSON de la solicitud tenía un formato incorrecto.",
      ],
      "The %1$s request to %2$s failed after %3$s seconds.": [
        "La solicitud %1$s a %2$s falló después de %3$s segundos.",
      ],
      "The last request time is %1$s": [
        "La hora de la última solicitud es %1$s",
      ],
      "The request was cancelled.": ["El pedido se canceló."],
      "The %1$s request %2$s failed with code %3$s.": [
        "La solicitud %1$s %2$s falló con el código %3$s.",
      ],
      "The request was made at %1$s": ["La solicitud se realizó a las %1$s"],
      "Too many requests were made to the server and this action was throttled.":
        [
          "Se realizaron demasiadas solicitudes al servidor y esta acción fue limitada.",
        ],
      'The request "%1$s %2$s" failed with code %3$s': [
        'La solicitud "%1$s %2$s" falló con el código %3$s',
      ],
      "The server's response was malformed.": [
        "La respuesta del servidor tenía un formato incorrecto.",
      ],
      'The response to "%1$s %2$s" failed with code %3$s': [
        'La respuesta a "%1$s %2$s" falló con el código %3$s',
      ],
      "The content type is %1$s": ["El tipo de contenido es %1$s"],
      'The validation error is "%1$s"': ['El error de validación es "%1$s"'],
      "Due to a network problem the request could not be finished.": [
        "Debido a un problema de red, la solicitud no pudo finalizarse.",
      ],
      "The %1$s request to %2$s failed.": ["La solicitud %1$s a %2$s falló."],
      "The server's response was unexpected. This means the client and the server are not in sync about the protocol.":
        [
          "La respuesta del servidor fue inesperada. Esto significa que el cliente y el servidor no están sincronizados respecto al protocolo.",
        ],
      "The %1$s request to %2$s failed with code %3$s": [
        "La solicitud %1$s a %2$s falló con el código %3$s",
      ],
      'And the server says: "%1$s"': ['Y el servidor dice: "%1$s"'],
      "Unexpected error": ["Error inesperado"],
      "Render error.": ["Error de representación."],
      "The operation failed.": ["La operación falló."],
      "The server rejected the operation without a specific error message.": [
        "El servidor rechazó la operación sin un mensaje de error específico.",
      ],
      "Unexpected error.": ["Error inesperado."],
      "The runtime threw an Error which was not properly handled. Please report this at https://bugs.taler.net.":
        [
          "El entorno de ejecución generó un error que no se manejó correctamente. Notifíquelo en https://bugs.taler.net.",
        ],
      "Copy details": ["Copiar detalles"],
      "Dismiss notification": ["Descartar notificación"],
      "Copy this text manually:": ["Copie este texto manualmente:"],
      "Technical details": ["Detalles técnicos"],
      "Select language": ["Seleccionar idioma"],
      "Languages": ["Idiomas"],
      "Loading": ["Cargando"],
      "Show notifications": ["Mostrar notificaciones"],
      "Open profile": ["Abrir perfil"],
      "Open settings": ["Abrir configuración"],
      "Close panel": ["Cerrar panel"],
      "Menu": ["Menú"],
      "Sidebar": ["Barra lateral"],
      "Log out": ["Cerrar sesión"],
      "Sites": ["Sitios"],
      "Copyright": [""],
      "Version %1$s (%2$s)": [""],
      "Testing with %1$s": ["Prueba con %1$s"],
      "stop testing": ["finalizar la prueba"],
      "Learn more about %1$s": ["Más información sobre %1$s"],
      "Hide details": ["Ocultar detalles"],
      "Show details": ["Mostrar detalles"],
      "Show more info": ["Mostrar más información"],
      "never": ["nunca"],
      "in %1$s": ["en %1$s"],
      "%1$s ago": ["hace %1$s"],
      "Pagination": ["Paginación"],
      "Page %1$s": ["Página %1$s"],
      "First page": ["Primera página"],
      "Previous": ["Anterior"],
      "Next": ["Siguiente"],
      "Checking compatibility of this webapp with backend service...": [
        "Comprobando la compatibilidad de esta aplicación web con el servicio backend...",
      ],
      "There was an error trying to contact the backend service.": [
        "Se produjo un error al intentar contactar con el servicio backend.",
      ],
      'The server version is not supported. Supported version "%1$s", server version "%2$s"':
        [
          'La versión del servidor no es compatible. Versión compatible "%1$s", versión del servidor "%2$s"',
        ],
      "Retry": ["Reintentar"],
      'The server version is not supported. Supported version "%1$s".': [
        'La versión del servidor no es compatible. Versión compatible: "%1$s".',
      ],
      "Not recorded": [""],
      "Provider": [""],
      "Yes": ["Sí"],
      "No": ["No"],
      "Try again": ["Intentar de nuevo"],
      "Downloading PDF…": ["Descargando el PDF…"],
      "Download PDF": ["Descargar PDF"],
      "Done": ["Listo"],
      "The terms are not available as Markdown or plain text.": [
        "Los términos no están disponibles en Markdown ni en texto sin formato.",
      ],
      "These terms are too large to display safely.": [
        "Estos términos son demasiado grandes para mostrarlos de forma segura.",
      ],
      "The terms of service could not be loaded.": [
        "No se pudieron cargar los términos de servicio.",
      ],
      "Close terms of service": ["Cerrar los términos de servicio"],
      "Loading terms of service…": ["Cargando los términos de servicio…"],
      "The PDF could not be downloaded.": ["No se pudo descargar el PDF."],
      "Read the terms provided by %1$s before recording your acceptance.": [
        "Lea los términos proporcionados por %1$s antes de registrar su aceptación.",
      ],
      "Read terms again": ["Volver a leer los términos"],
      "Read terms": ["Leer los términos"],
      "Your acceptance applies to the version shown above.": [
        "Su aceptación se aplica a la versión mostrada arriba.",
      ],
      "Review the terms of service": ["Revisar los términos de servicio"],
      "Read the terms before recording your acceptance.": [
        "Lea los términos antes de registrar su aceptación.",
      ],
      "I have read and accept the terms of service": [
        "He leído y acepto los términos de servicio",
      ],
      "Open the terms before accepting them.": [
        "Abra los términos antes de aceptarlos.",
      ],
      "Email verification": ["Verificación del correo electrónico"],
      "Challenge email ownership.": [
        "Verificar la titularidad del correo electrónico.",
      ],
      "E-Mail": ["Correo electrónico"],
      "Postal verification": ["Verificación de la dirección postal"],
      "Challenge address ownership.": [
        "Verificar la titularidad de la dirección.",
      ],
      "Name": ["Nombre"],
      "Address": ["Dirección"],
      "Country": ["País"],
      "Phone verification": ["Verificación del teléfono"],
      "Challenge phone number ownership.": [
        "Verificar la titularidad del número de teléfono.",
      ],
      "Phone": ["Teléfono"],
      "Generic note": ["Nota genérica"],
      "Free-form, generic note": ["Nota genérica de formato libre"],
      "Note / Memorandum": ["Nota / Memorando"],
      "Free-form notes": ["Notas de formato libre"],
      "Supplemental File Upload": ["Carga de archivo adicional"],
      "Optional supplemental information for the establishment of the business relationship with the customer.":
        [
          "Información adicional opcional para el establecimiento de la relación comercial con el cliente.",
        ],
      "Supplemental Files": ["Archivos adicionales"],
      "Description": ["Descripción"],
      "File (PDF)": ["Archivo (PDF)"],
      "Upload multiple documents": ["Subir varios documentos"],
      "Upload multiple documents.": ["Sube varios documentos."],
      "Document identifier": [""],
      "Title": [""],
      "Document upload (%1$s)": ["Carga de documentos (%1$s)"],
      "Simple form": ["Formulario simple"],
      "Full Name": ["Nombre completo"],
      "Birthdate": ["Fecha de nacimiento"],
      "Comment": ["Comentario"],
      "Resolution": ["Resolución"],
      "New state": ["Nuevo estado"],
      "Frozen": ["Congelado"],
      "Pending": ["Pendiente"],
      "Normal": ["Normal"],
      "New threshold": ["Nuevo umbral"],
      "German": ["Alemán"],
      "English": ["Inglés"],
      "Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange (K)":
        [
          "Determinación de la persona con poder de control de entidades jurídicas y sociedades operativas que no cotizan en bolsa (K)",
        ],
      "for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnership that are beneficial owners":
        [
          "para entidades jurídicas y sociedades operativas que sean la parte contratante, así como, de forma análoga, para entidades jurídicas y sociedades operativas que sean los beneficiarios efectivos",
        ],
      "Establishment of the controlling person (submitted by customer)": [
        "Determinación de la persona con poder de control (presentada por el cliente)",
      ],
      "Contracting partner": ["Parte contratante"],
      "Controlling person(s)": ["Persona(s) con poder de control"],
      "Reason for control": ["Motivo del control"],
      "Holding 25% or more": ["Titularidad del 25% o más"],
      "The person(s) listed below is/are holding 25% or more of the contracting partner's shares (capital shares or voting rights)":
        [
          "La(s) persona(s) que se indica(n) a continuación posee(n) el 25% o más de las participaciones de la parte contratante (participaciones de capital o derechos de voto)",
        ],
      "Other way": ["Otra forma"],
      "If the capital shares or voting rights cannot be determined or in case there are no capital shares or voting rights 25% or more, the contracting partner hereby declares that the person(s) listed below is/are controlling the contracting partner in other ways":
        [
          "Si las participaciones de capital o los derechos de voto no pueden determinarse, o en caso de que no existan participaciones de capital o derechos de voto del 25% o más, la parte contratante declara por la presente que la(s) persona(s) que se indica(n) a continuación controla(n) a la parte contratante de otras formas",
        ],
      "Managing director": ["Gerente/director general"],
      "In case this/these person(s) cannot be determined or this/these person(s) does/do not exist, the contracting partner hereby declares that the person(s) listed below is/are the managing director(s)":
        [
          "En caso de que esta(s) persona(s) no pueda(n) determinarse o no exista(n), la parte contratante declara por la presente que la(s) persona(s) que se indica(n) a continuación es/son el/los director(es) general(es)",
        ],
      "Can't be empty": ["No puede estar vacío"],
      "Full name": ["Nombre completo"],
      "Actual address of domicile": ["Dirección real de domicilio"],
      "Fiduciary holding assets": ["Activos en tenencia fiduciaria"],
      "Is a third person the beneficial owner of the assets held in the account/securities account?":
        [
          "¿Es un tercero el beneficiario efectivo de los activos mantenidos en la cuenta/cuenta de valores?",
        ],
      "Signature(s)": ["Firma(s)"],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery)":
        [
          "Proporcionar deliberadamente información falsa en este formulario constituye un delito penal (artículo 251 del Código Penal suizo, falsificación de documentos)",
        ],
      "The contracting partner hereby undertakes to inform automatically of any changes to the information contained herein.":
        [
          "La parte contratante se compromete por la presente a notificar cualquier cambio en la información aquí contenida sin necesidad de que se le solicite.",
        ],
      "Date": ["Fecha"],
      "Establishment of the controlling person (submitted by AML officer)": [
        "Determinación de la persona con poder de control (presentada por el oficial de prevención de blanqueo de capitales)",
      ],
      "Signed Declaration": ["Declaración firmada"],
      "Signed declaration by the customer": [
        "Declaración firmada por el cliente",
      ],
      "The uploaded document must contain the customer's signature on the beneficial owner declaration.":
        [
          "El documento cargado debe contener la firma del cliente en la declaración del beneficiario efectivo.",
        ],
      "Signed Document": ["Documento firmado"],
      "invalid format": ["formato inválido"],
      "it can't be in the future": ["no puede estar en el futuro"],
      "it can't be greater than 120 years": ["no puede ser mayor a 120 años"],
      "Last name(s), first name(s)/entity": [""],
      "Nationality": ["Nacionalidad"],
      "Date of death (if deceased)": [""],
      "Foundations (as well as similar constructs) (S)": [""],
      "Declaration for foundations and similar constructs.": [""],
      "The undersigned hereby declare(s) that as board member of the foundation, or of the highest supervisory body of an underlying company of a foundation, known as:":
        [""],
      "Name of the foundation": [""],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following:":
        [""],
      "Name and information pertaining to the foundation": [""],
      "Type of foundation": [""],
      "Discretionary foundation": [""],
      "Non-discretionary foundation": [""],
      "Revocability": [""],
      "Irrevocable foundation": [""],
      "Information pertaining to the ultimate economic, not fiduciary, founder (individual(s) or entity/entities).":
        [""],
      "Founder(s)": [""],
      "Does the founder have the right to revoke the foundation?": [""],
      "Founders of pre-existing foundations": [""],
      "Complete this section if the foundation results from a restructuring (re-settlement) or merger of pre-existing foundations.":
        [""],
      "Founder(s) of the pre-existing foundation(s)": [""],
      "Beneficiaries determined at the time this form is signed": [""],
      "Does the beneficiary have an actual right to claim distributions?": [""],
      "Known group(s) of beneficiaries": [""],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the founder).":
        [""],
      "Provide at least one beneficiary or group of beneficiaries": [""],
      "Persons entitled to determine or nominate representatives of the foundation when those representatives may dispose of assets or change asset distributions or the nomination of beneficiaries.":
        [""],
      "Is/are there (a) further person(s) with the right to revoke the foundation?":
        [""],
      "Declaration for trusts (T)": [""],
      "Declaration for trusts.": [""],
      "The undersigned hereby declare(s) that as trustee or a member of highest supervisory body of an underlying company of a trust known as:":
        [""],
      "Name of the trust": [""],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following information:":
        [""],
      "Name and information pertaining to the trust": [""],
      "Type of trust": [""],
      "Discretionary trust": [""],
      "Non-discretionary trust": [""],
      "Revocable trust": [""],
      "Irrevocable trust": [""],
      "Information pertaining to the ultimate economic, not fiduciary, settlor of the trust (individual(s) or entity/entities).":
        [""],
      "Settlor(s)": [""],
      "Does the settlor have the right to revoke the trust?": [""],
      "Settlors of pre-existing trusts": [""],
      "Complete this section if the trust results from a restructuring (re-settlement) or merger of pre-existing trusts.":
        [""],
      "Settlor(s) of the pre-existing trust(s)": [""],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the settlor).":
        [""],
      "Protectors": [""],
      "Protector(s)": [""],
      "Does the protector have the right to revoke the trust?": [""],
      "Further persons having the right to appoint the trustee of a trust.": [
        "",
      ],
      "Do any further persons have the right to revoke the trust?": [""],
      "The contracting partner(s) hereby declare(s) to be entitled to open a business relationship for the trust above or its underlying company.":
        [""],
      "The customer is the person with whom the member concludes the contract with regard to the financial service provided (civil law). If the\n  member acts as the director of a domiciliary company, then that domiciliary company is the customer.":
        [
          "El cliente es la persona con quien el miembro celebra el contrato respecto al servicio financiero prestado (derecho civil). Si el\n  miembro actúa como director de una sociedad domiciliaria, entonces esa sociedad domiciliaria es el cliente.",
        ],
      "Identification Form (customer)": [
        "Formulario de identificación (cliente)",
      ],
      "The customer has to be identified on entering into a permanent business relationship or on concluding a cash transaction, which meets the according threshold.":
        [
          "El cliente debe ser identificado al iniciar una relación comercial permanente o al concluir una transacción en efectivo que alcance el umbral correspondiente.",
        ],
      "Correspondence language:": ["Idioma de correspondencia:"],
      "French": ["Francés"],
      "Italian": ["Italiano"],
      "Identification form (basic customer information)": [
        "Formulario de identificación (información básica del cliente)",
      ],
      "Information on customer": ["Información sobre el cliente"],
      "Customer type": ["Tipo de cliente"],
      "Natural person (incl. sole proprietors)": [
        "Persona física (incl. empresarios individuales)",
      ],
      "Legal entity": ["Persona jurídica"],
      "Applicable if customer is a natural person": [
        "Aplicable si el cliente es una persona física",
      ],
      "Residential address in Switzerland": ["Dirección residencial en Suiza"],
      "Telephone": ["Teléfono"],
      "Email": ["Correo electrónico"],
      "Date of birth": ["Fecha de nacimiento"],
      "Copy of identification document": ["Copia del documento de identidad"],
      "Only official government IDs (incl. passports) are accepted. Please scan both sides if applicable.":
        [
          "Solo se aceptan documentos de identidad oficiales del gobierno (incl. pasaportes). Escanea ambos lados si corresponde.",
        ],
      "Sole proprietor": ["Empresario individual"],
      "Information on customer (sole proprietor)": [
        "Información sobre el cliente (empresario individual)",
      ],
      "Applicable only if customer is a sole proprietor": [
        "Aplicable solo si el cliente es un empresario individual",
      ],
      "Company name": ["Nombre de la empresa"],
      "Registered office": ["Domicilio social"],
      "Company identification document": [
        "Documento de identificación de la empresa",
      ],
      "Information on customer (legal entity)": [
        "Información sobre el cliente (persona jurídica)",
      ],
      "Applicable if customer is a legal entity": [
        "Aplicable si el cliente es una persona jurídica",
      ],
      "Domicile": ["Domicilio"],
      "Contact person": ["Persona de contacto"],
      "Copy of identification document (not older than 12 months)": [
        "Copia del documento de identidad (no mayor a 12 meses)",
      ],
      "Company share registry file": [
        "Archivo del registro de accionistas de la empresa",
      ],
      "Correspondence Preferences": ["Preferencias de correspondencia"],
      "Information on the natural persons who establish the business relationship for legal entities and partnerships":
        [
          "Información sobre las personas físicas que establecen la relación comercial para entidades jurídicas y sociedades",
        ],
      "For legal entities and partnerships the identity of the natural persons who establish the business relationship must be verified.":
        [
          "Para entidades jurídicas y sociedades, debe verificarse la identidad de las personas físicas que establecen la relación comercial.",
        ],
      "Persons establishing the legal relationship": [
        "Personas que establecen la relación jurídica",
      ],
      "Residential address": ["Dirección residencial"],
      "Signing authority of the person": ["Facultad de firma de la persona"],
      "Power of attorney arrangements": ["Acuerdos de poder notarial"],
      "Sole signature authority": [""],
      "Collective authority with two signatures": [""],
      "Other (please specify)": [""],
      "Other type of signing authority": ["Otro tipo de facultad de firma"],
      "Evidence of signing authority:": ["Prueba de la facultad de firma:"],
      "Company register extract": ["Extracto del registro mercantil"],
      "Mandate": ["Mandato"],
      "Other": ["Otro"],
      "Specify other way of establishing signing authority:": [
        "Especifica otra forma de establecer la facultad de firma:",
      ],
      "Copy of document that serves as evidence of signing authority:": [
        "Copia del documento que sirve como prueba de la facultad de firma:",
      ],
      "Customer classification": ["Clasificación del cliente"],
      "Classification for the establishment of the beneficial owner of the assets and/or controlling person":
        [
          "Clasificación para la determinación del beneficiario efectivo de los activos y/o de la persona con poder de control",
        ],
      "The customer is:": ["El cliente es:"],
      "A natural person and there are no doubts that this person is the sole beneficial owner of the assets":
        [
          "Una persona física, sin dudas de que esta persona es el único beneficiario efectivo de los activos",
        ],
      "An operational legal entity or partnership": [
        "Una entidad jurídica o sociedad operativa",
      ],
      "A foundation (or a similar construct; incl. underlying companies)": [
        "Una fundación (o una estructura similar; incl. sociedades subyacentes)",
      ],
      "A trust (incl. underlying companies)": [
        "Un fideicomiso (incl. sociedades subyacentes)",
      ],
      "A life insurance policy with separately managed accounts / securities accounts (so-called insurance wrappers)":
        [
          'Una póliza de seguro de vida con cuentas/cuentas de valores administradas por separado (los llamados "insurance wrappers")',
        ],
      "Special Clarifications": ["Aclaraciones especiales"],
      "When a business relationship or transaction is associated with increased risk, appears unusual or evidence exists that the assets are the proceeds of a felony or a qualified tax offence, the member has to perform additional clarifications.":
        [
          "Cuando una relación comercial o transacción está asociada con un riesgo elevado, parece inusual o existen indicios de que los activos son producto de un delito grave o de un delito fiscal calificado, el miembro debe realizar aclaraciones adicionales.",
        ],
      "Customer": ["Cliente"],
      "Reason for special clarifications": [
        "Motivo de las aclaraciones especiales",
      ],
      "Reason": ["Motivo"],
      "Description of the circumstances/transactions, which triggered the special clarifications":
        [
          "Descripción de las circunstancias/transacciones que dieron lugar a las aclaraciones especiales",
        ],
      "can't be empty": ["no puede estar vacío"],
      "Used means of clarification": ["Medios de aclaración utilizados"],
      "Means": ["Medios"],
      "Gathering of information from the customer, beneficial owner of the assets, controlling person":
        [
          "Recopilación de información del cliente, del beneficiario efectivo de los activos, de la persona con poder de control",
        ],
      "Consultation of generally accessible sources and databases": [
        "Consulta de fuentes y bases de datos de acceso general",
      ],
      "Enquiries with trustworthy persons": [
        "Consultas con personas fidedignas",
      ],
      "Other, which?": ["Otro, ¿cuál?"],
      "Other means of clarification:": ["Otros medios de aclaración:"],
      "Optional supplemental information for the special clarifications.": [
        "Información adicional opcional para las aclaraciones especiales.",
      ],
      "Summary and plausibility check of the gathered information": [
        "Resumen y verificación de plausibilidad de la información recopilada",
      ],
      "The results of the clarifications have to be documented and their plausibility has to be checked.":
        [
          "Los resultados de las aclaraciones deben documentarse y su plausibilidad debe verificarse.",
        ],
      "Summary": ["Resumen"],
      "Gathered/Consulted documents": ["Documentos recopilados/consultados"],
      "Result of the special clarification": [
        "Resultado de la aclaración especial",
      ],
      "Result": ["Resultado"],
      "No suspicion": ["Sin sospecha"],
      "The plausibility of the circumstances could be checked, no reasonable suspicion pursuant to Art. 9 AMLA (possibly update of customer profile and/or risk profile)":
        [
          "Se pudo verificar la plausibilidad de las circunstancias, sin sospecha razonable conforme al art. 9 de la AMLA (posiblemente actualización del perfil del cliente y/o del perfil de riesgo)",
        ],
      "Reasonable suspicion": ["Sospecha razonable"],
      "Reasonable suspicion pursuant to Art. 9 AMLA, duty to file a report with MROS":
        [
          "Sospecha razonable conforme al art. 9 de la AMLA, obligación de presentar un informe a la MROS",
        ],
      "Simple suspicion": ["Sospecha simple"],
      "Simple suspicion pursuant to Art. 305ter Para. 2 StGB, right to notify MROS":
        [
          "Sospecha simple conforme al art. 305ter, párr. 2 del StGB, derecho a notificar a la MROS",
        ],
      "Other, what?": ["Otro, ¿qué?"],
      "Result clarification": ["Resultado de la aclaración"],
      "Identification Form (acceptance)": [
        "Formulario de identificación (aceptación)",
      ],
      "Acceptance of business relationship": [
        "Aceptación de la relación comercial",
      ],
      "Date (conclusion of contract):": ["Fecha (celebración del contrato):"],
      "Accepted via:": ["Aceptado mediante:"],
      "Face to face": ["Presencial"],
      "Authenticated copy of identification document": [
        "Copia autenticada del documento de identidad",
      ],
      "Residential address validated": ["Dirección residencial validada"],
      "Further information:": ["Información adicional:"],
      "Evaluation with regard to embargo procedures/terrorism lists on establishing the business relationship":
        [
          "Evaluación respecto a procedimientos de embargo/listas de terrorismo al establecer la relación comercial",
        ],
      "Verification whether the customer, beneficial owners of the assets, controlling persons, authorized representatives or other involved persons are listed on an embargo/terrorism list.":
        [
          "Verificación de si el cliente, los beneficiarios efectivos de los activos, las personas con poder de control, los representantes autorizados u otras personas involucradas figuran en una lista de embargo/terrorismo.",
        ],
      "Embargo/terrorism status:": ["Estado de embargo/terrorismo:"],
      "Not listed on embargo/terrorism list.": [
        "No figura en la lista de embargo/terrorismo.",
      ],
      "Listed on embargo/terrorism list.": [
        "Figura en la lista de embargo/terrorismo.",
      ],
      "Embargo/terrorism information:": [
        "Información sobre embargo/terrorismo:",
      ],
      "Verification date": ["Fecha de verificación"],
      "Supplemental files": ["Archivos adicionales"],
      "Risk Profile AMLA": ["Perfil de riesgo AMLA"],
      "Evaluation of politically exposed persons (PEP-Check)": [
        "Evaluación de personas políticamente expuestas (verificación PEP)",
      ],
      "This evaluation has to be completed by all members for every business relationship.":
        [
          "Todos los miembros deben completar esta evaluación para cada relación comercial.",
        ],
      "Foreign PEP": ["PEP extranjera"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a foreign PEP or closely related to such a person?":
        [
          "¿Es el cliente, el beneficiario efectivo, la persona con poder de control o el representante autorizado una PEP extranjera o está estrechamente relacionado con dicha persona?",
        ],
      "Domestic PEP": ["PEP nacional"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a domestic PEP or closely related to such a person?":
        [
          "¿Es el cliente, el beneficiario efectivo, la persona con poder de control o el representante autorizado una PEP nacional o está estrechamente relacionado con dicha persona?",
        ],
      "PEP of International Organisations": [
        "PEP de organizaciones internacionales",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a PEP in International Organisations or closely related to such a person?":
        [
          "¿Es el cliente, el beneficiario efectivo, la persona con poder de control o el representante autorizado una PEP de organizaciones internacionales o está estrechamente relacionado con dicha persona?",
        ],
      "Acceptance date": ["Fecha de aceptación"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with a PEP was obtained on.":
        [
          "Fecha en la que se obtuvo la decisión del órgano ejecutivo superior sobre la aceptación de una relación de negocios con una PEP.",
        ],
      'Evaluation "high risk" or non-cooperative country': [
        "Evaluación «país de alto riesgo» o no cooperante",
      ],
      "High-risk or non-cooperative country": [
        "País de alto riesgo o no cooperante",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative in a country considered by the FATF as high-risk or non-cooperative and for which FATF requires increased diligence?":
        [
          "¿Se encuentra el cliente, el beneficiario efectivo, la persona con poder de control o el representante autorizado en un país considerado por el GAFI como de alto riesgo o no cooperante y para el cual el GAFI exige diligencia reforzada?",
        ],
      "When the decision of the Senior executive body on the acceptance of such a business relationship was obtained on.":
        [
          "Fecha en la que se obtuvo la decisión del órgano ejecutivo superior sobre la aceptación de dicha relación de negocios.",
        ],
      "Evaluation of business relationship risk": [
        "Evaluación del riesgo de la relación de negocios",
      ],
      "Country risk": ["Riesgo país"],
      "Applicable country risk types": ["Tipos de riesgo país aplicables"],
      "Nationality of the customer": ["Nacionalidad del cliente"],
      "Nationality of the beneficial owner of the assets": [
        "Nacionalidad del beneficiario efectivo de los activos",
      ],
      "Domicile/residential address of the customer": [
        "Domicilio/dirección residencial del cliente",
      ],
      "Domicile/residential address of the beneficial owner of the assets": [
        "Domicilio/dirección residencial del beneficiario efectivo de los activos",
      ],
      "Domicile/residential address of the controlling person": [
        "Domicilio/dirección residencial de la persona con poder de control",
      ],
      "Country risk level (nationality)": [
        "Nivel de riesgo país (nacionalidad)",
      ],
      "Risk category according to VQF country list (VQF doc. no. 902.4.1)": [
        "Categoría de riesgo según la lista de países VQF (doc. VQF n.º 902.4.1)",
      ],
      "Low (Risk 0)": ["Bajo (Riesgo 0)"],
      "Risk 0 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Riesgo 0 según la lista de países VQF (doc. VQF n.º 902.4.1)",
      ],
      "Medium (Risk 1)": ["Medio (Riesgo 1)"],
      "Risk 1 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Riesgo 1 según la lista de países VQF (doc. VQF n.º 902.4.1)",
      ],
      "High (Risk 2)": ["Alto (Riesgo 2)"],
      "Risk 2 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Riesgo 2 según la lista de países VQF (doc. VQF n.º 902.4.1)",
      ],
      "Country risk type (place of business activity)": [
        "Tipo de riesgo país (lugar de la actividad comercial)",
      ],
      "Beneficial owner": ["Beneficiario efectivo"],
      "Country risk level (business activity)": [
        "Nivel de riesgo país (actividad comercial)",
      ],
      "Industry risk": ["Riesgo del sector"],
      "Industry risk source": ["Fuente del riesgo del sector"],
      "Beneficial owner of the assets": [
        "Beneficiario efectivo de los activos",
      ],
      "Industry risk level": ["Nivel de riesgo del sector"],
      "Transparent (Risk Level 0)": [""],
      "Clearly defined, transparent, easily comprehensible business activity well known to the member.":
        [
          "Actividad comercial claramente definida, transparente, fácilmente comprensible y bien conocida por el miembro.",
        ],
      "High cash transactions (Risk Level 1)": [""],
      "Business activity with a high level of cash transactions.": [
        "Actividad comercial con un alto nivel de transacciones en efectivo.",
      ],
      "Not well known (Risk Level 1)": [""],
      "Business activity not well known to the member.": [
        "Actividad comercial no bien conocida por el miembro.",
      ],
      "Trade in munitions/arms, raw gem stones/diamonds, jewellery, international trade in exotic animals, casino and lottery business, trade in erotic wares.":
        [
          "Comercio de municiones/armas, piedras preciosas en bruto/diamantes, joyería, comercio internacional de animales exóticos, negocios de casinos y loterías, comercio de artículos eróticos.",
        ],
      "Member has no personal knowledge of the customer’s industry.": [
        "El miembro no tiene conocimiento personal del sector del cliente.",
      ],
      "Contact risk": ["Riesgo de contacto"],
      "Type of contact to the customer/beneficial owner of the assets.": [
        "Tipo de contacto con el cliente/beneficiario efectivo de los activos.",
      ],
      "Contact risk level": ["Nivel de riesgo de contacto"],
      "Personal acquaintance between member and customer/beneficial owner of the assets over several years (at least 2) prior to entering into the business relationship":
        [
          "Conocimiento personal entre el miembro y el cliente/beneficiario efectivo de los activos durante varios años (al menos 2) antes de establecer la relación de negocios",
        ],
      "The customer/beneficial owner was not personally known to the member for several years (at least 2) prior to entering into the business relationship; however (a) no business was entered into in the absence of the customer/beneficial owner, or (b) the customer was at least introduced/brokered by a trusted third party.":
        [
          "El cliente/beneficiario efectivo no era conocido personalmente por el miembro durante varios años (al menos 2) antes de establecer la relación de negocios; sin embargo, (a) no se estableció ningún negocio en ausencia del cliente/beneficiario efectivo, o (b) el cliente fue al menos presentado/intermediado por un tercero de confianza.",
        ],
      "The customer/beneficial owner was not personally known to the member and business was entered into in the absence of the former (relationship by correspondence) and the customer was not introduced/brokered by a trusted third party.":
        [
          "El cliente/beneficiario efectivo no era conocido personalmente por el miembro y el negocio se estableció en ausencia de este (relación por correspondencia), y el cliente no fue presentado/intermediado por un tercero de confianza.",
        ],
      "Summary evaluation": ["Evaluación resumida"],
      "Justification for risk assessment": [
        "Justificación de la evaluación de riesgo",
      ],
      "Risk classification": ["Clasificación de riesgo"],
      "Conclusion whether the business relationship is with or without increased risk.":
        [
          "Conclusión sobre si la relación de negocios presenta o no un riesgo incrementado.",
        ],
      "No high risk": ["Sin alto riesgo"],
      "High risk": ["Alto riesgo"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with increased risk was obtained on.":
        [
          "Fecha en la que se obtuvo la decisión del órgano ejecutivo superior sobre la aceptación de una relación de negocios con riesgo incrementado.",
        ],
      "Customer Profile": ["Perfil del cliente"],
      "The information below has to refer to the persons from whom the assets originate ultimately (e.g. beneficial owner of the assets, founder/creator of a trust or foundation). Is the customer an operational legal entity or partnership the information may refer to the entity itself (not to the controlling person), unless the entity holds the assets in trust for a third party.":
        [
          "La información a continuación debe referirse a las personas de las que en última instancia proceden los activos (p. ej., el beneficiario efectivo de los activos, el fundador/creador de un fideicomiso o fundación). Si el cliente es una entidad jurídica operativa o una sociedad, la información puede referirse a la propia entidad (y no a la persona con poder de control), a menos que la entidad mantenga los activos en fideicomiso para un tercero.",
        ],
      "Business activity": ["Actividad comercial"],
      "Profession, business activities, etc. (former, current, potentially planned)":
        [
          "Profesión, actividades comerciales, etc. (anteriores, actuales, potencialmente planificadas)",
        ],
      "Financial circumstances": ["Situación financiera"],
      "Income and assets, liabilities (estimated)": [
        "Ingresos y activos, pasivos (estimados)",
      ],
      "Origin of the deposited assets involved": [
        "Origen de los activos depositados involucrados",
      ],
      "Will the customer deposit assets with Taler Operations AG?": [
        "¿Depositará el cliente activos en Taler Operations AG?",
      ],
      "Nature, amount and currency of deposited assets.": [
        "Naturaleza, monto y divisa de los activos depositados.",
      ],
      "Category": ["Categoría"],
      "Savings": ["Ahorros"],
      "Own business operations": ["Operaciones comerciales propias"],
      "Inheritance": ["Herencia"],
      "Category clarification": ["Aclaración de la categoría"],
      "Detailed description of the origins/economic background of the assets involved in the business relationship":
        [
          "Descripción detallada del origen/trasfondo económico de los activos involucrados en la relación de negocios",
        ],
      "Nature and purpose of the business relationship": [
        "Naturaleza y propósito de la relación de negocios",
      ],
      "Purpose of the business relationship": [
        "Propósito de la relación de negocios",
      ],
      "Information on the planned development of the business relationship and the assets":
        [
          "Información sobre el desarrollo previsto de la relación de negocios y de los activos",
        ],
      "Details on usual business volume": [
        "Detalle sobre el volumen de negocio habitual",
      ],
      "Relationship with third parties": ["Relación con terceros"],
      "Relation of the customer to the beneficial owner, controlling persons, authorised signatories and other persons involved in the business relationship":
        [
          "Relación del cliente con el beneficiario efectivo, las personas con poder de control, los firmantes autorizados y otras personas involucradas en la relación de negocios",
        ],
      "Relation to other AMLA-Files": ["Relación con otros expedientes AMLA"],
      "Introducer / agents / references": [
        "Presentador / agentes / referencias",
      ],
      "Further information": ["Información adicional"],
      "Other relevant information": ["Otra información relevante"],
      "The customer completes the declaration directly in the form.": [""],
      "Declaration of identity of the beneficial owner": [
        "Declaración de identidad del beneficiario efectivo",
      ],
      "Beneficial owner details": ["Datos del beneficiario efectivo"],
      "Beneficial owner(s)": ["Beneficiario(s) efectivo(s)"],
      "The person(s) listed below is/are the beneficial owner(s) of the assets involved in the business relationship. If the contracting partner is also the sole beneficial owner of the assets, the contracting partner's detail must be set out below":
        [
          "La(s) persona(s) que figuran a continuación es/son el/los beneficiario(s) efectivo(s) de los activos involucrados en la relación de negocios. Si la contraparte contractual es también el único beneficiario efectivo de los activos, sus datos deben indicarse a continuación",
        ],
      "Domicile address": ["Dirección de domicilio"],
      "The AML officer records the declaration and uploads the customer's signed PDF.":
        [""],
      "January": ["Enero"],
      "February": ["Febrero"],
      "March": ["Marzo"],
      "April": ["Abril"],
      "May": ["Mayo"],
      "June": ["Junio"],
      "July": ["Julio"],
      "August": ["Agosto"],
      "September": ["Septiembre"],
      "October": ["Octubre"],
      "November": ["Noviembre"],
      "December": ["Diciembre"],
      "Previous year": ["Año anterior"],
      "Next year": ["Año siguiente"],
      "Previous month": ["Mes anterior"],
      "Next month": ["Mes siguiente"],
      "Official form language": [""],
      "This form is shown in an official, legally binding language.": [""],
      "Official translation": [""],
      "This form is shown in an official translation, but it is not legally binding. Only the %1$s text is legally binding.":
        [""],
      "Unofficial form translation": [""],
      "This form is not officially supported in the selected language. The translation may be incomplete, and some text may be shown in %1$s. Only the %2$s text is legally binding.":
        [""],
      "Shorten file contents.": [""],
      "List of fields with errors": ["Lista de campos con errores"],
      "Delete this item?": ["¿Eliminar este elemento?"],
      "Keep item": ["Conservar elemento"],
      "Delete item": ["Eliminar elemento"],
      "Cancel": ["Cancelar"],
      "Delete": ["Eliminar"],
      "Add item": ["Añadir elemento"],
      "Save changes": ["Guardar cambios"],
      "Item %1$s": ["Elemento %1$s"],
      "Edit %1$s": ["Editar %1$s"],
      "Edit": ["Editar"],
      "Clear selection": ["Borrar selección"],
      "Toggle choices": ["Mostrar opciones"],
      "No element found": ["No se encontró ningún elemento"],
      "years": ["años"],
      "months": ["meses"],
      "days": ["días"],
      "hours": ["horas"],
      "minutes": ["minutos"],
      "seconds": ["segundos"],
      "No expiration": ["Sin vencimiento"],
      "Forever": ["Para siempre"],
      "The selected file is too large.": [
        "El archivo seleccionado es demasiado grande.",
      ],
      "The selected file could not be read.": [
        "No se pudo leer el archivo seleccionado.",
      ],
      "Upload a file": ["Subir un archivo"],
      "Clear": ["Borrar"],
      "Download a copy.": ["Descargar una copia."],
      "The maximum number of selections has been reached.": [""],
      "Simple comment": ["Comentario simple"],
      "Terms URL": [""],
      "Provider name": [""],
      "Only show the external link": [""],
      "Name and birthdate": ["Nombre y fecha de nacimiento"],
      "Select an example from the list on the left.": [""],
      "Example not found.": [""],
      "An error occurred while rendering the example.": [""],
      "Group": [""],
      "Component": [""],
      "Example": [""],
      "Arguments": [""],
      "Dataset": [""],
      "Dataset %1$s of %2$s": [""],
      "Select a story": [""],
      "Open stories navigation": [""],
      "Stories navigation": [""],
      "Stories": [""],
      "Close stories navigation": [""],
      "%1$s": ["%1$s"],
      "Free-form message": ["Mensaje libre"],
      "Are you a cross-border truck driver?": [
        "¿Es usted conductor de camión transfronterizo?",
      ],
      "How much cash are you carrying?": ["¿Cuánto efectivo lleva consigo?"],
      "Germany": ["Alemania"],
      "Switzerland": ["Suiza"],
      "Sign-in failed": ["Error al iniciar sesión"],
      "Check your password.": ["Comprueba tu contraseña."],
      "Try again in a moment.": ["Inténtalo de nuevo en un momento."],
      "First error": ["Primer error"],
      "First description": ["Primera descripción"],
      "Second error": ["Segundo error"],
      "Second description": ["Segunda descripción"],
      "Saved": ["Guardado"],
      "Request failed": ["La solicitud falló"],
      "Try again.": ["Inténtalo de nuevo."],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "es_AR",
  completeness: 87,
};

strings["de"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "required": ["erforderlich"],
      "Validation failed unexpectedly. Please contact the developers: %1$s": [
        "Die Validierung ist unerwartet fehlgeschlagen. Bitte kontaktieren Sie die Entwickler: %1$s",
      ],
      "Terms of service": ["Allgemeine Geschäftsbedingungen"],
      "Read the terms of service before continuing.": [
        "Lesen Sie die Allgemeinen Geschäftsbedingungen, bevor Sie fortfahren.",
      ],
      "Terms acceptance": ["Zustimmung zu den Bedingungen"],
      "Accept the terms of service before continuing.": [
        "Akzeptieren Sie die Allgemeinen Geschäftsbedingungen, bevor Sie fortfahren.",
      ],
      "Looks like the JSON in the request was malformed.": [
        "Es scheint, dass das JSON in der Anfrage fehlerhaft war.",
      ],
      "The request timed out. Check your connection.": [
        "Zeitüberschreitung bei der Anfrage. Überprüfen Sie Ihre Verbindung.",
      ],
      "The %1$s request to %2$s failed after %3$s seconds.": [
        "Die %1$s-Anfrage an %2$s ist nach %3$s Sekunden fehlgeschlagen.",
      ],
      "The last request time is %1$s": ["Die letzte Anfragezeit ist %1$s"],
      "The request was cancelled.": ["Die Anfrage wurde abgebrochen."],
      "The %1$s request %2$s failed with code %3$s.": [
        "Die %1$s-Anfrage %2$s ist mit Code %3$s fehlgeschlagen.",
      ],
      "The request was made at %1$s": ["Die Anfrage wurde um %1$s gestellt"],
      "Too many requests were made to the server and this action was throttled.":
        [
          "Es wurden zu viele Anfragen an den Server gestellt, und diese Aktion wurde gedrosselt.",
        ],
      'The request "%1$s %2$s" failed with code %3$s': [
        "Die Anfrage „%1$s %2$s“ ist mit Code %3$s fehlgeschlagen",
      ],
      "The server's response was malformed.": [
        "Die Antwort des Servers war fehlerhaft.",
      ],
      'The response to "%1$s %2$s" failed with code %3$s': [
        "Die Antwort auf „%1$s %2$s“ ist mit Code %3$s fehlgeschlagen",
      ],
      "The content type is %1$s": ["Der Inhaltstyp ist %1$s"],
      'The validation error is "%1$s"': ["Der Validierungsfehler ist „%1$s“"],
      "Due to a network problem the request could not be finished.": [
        "Aufgrund eines Netzwerkproblems konnte die Anfrage nicht abgeschlossen werden.",
      ],
      "The %1$s request to %2$s failed.": [
        "Die %1$s-Anfrage an %2$s ist fehlgeschlagen.",
      ],
      "The server's response was unexpected. This means the client and the server are not in sync about the protocol.":
        [
          "Die Antwort des Servers war unerwartet. Das bedeutet, dass Client und Server hinsichtlich des Protokolls nicht synchron sind.",
        ],
      "The %1$s request to %2$s failed with code %3$s": [
        "Die %1$s-Anfrage an %2$s ist mit Code %3$s fehlgeschlagen",
      ],
      'And the server says: "%1$s"': ["Und der Server sagt: „%1$s“"],
      "Unexpected error": ["Unerwarteter Fehler"],
      "An unexpected error occurred and was not handled properly. To report it, copy the details and create an issue at https://bugs.taler.net.":
        [
          "Ein unerwarteter Fehler ist aufgetreten und wurde nicht ordnungsgemäß behandelt. Um ihn zu melden, kopieren Sie die Details und erstellen Sie unter https://bugs.taler.net einen Fehlerbericht.",
        ],
      "Render error.": ["Darstellungsfehler."],
      "The operation failed.": ["Der Vorgang ist fehlgeschlagen."],
      "The server rejected the operation without a specific error message.": [
        "Der Server hat den Vorgang ohne konkrete Fehlermeldung abgelehnt.",
      ],
      "Unexpected error.": ["Unerwarteter Fehler."],
      "The runtime threw an Error which was not properly handled. Please report this at https://bugs.taler.net.":
        [
          "Die Laufzeitumgebung hat einen Fehler ausgelöst, der nicht ordnungsgemäß behandelt wurde. Bitte melden Sie ihn unter https://bugs.taler.net.",
        ],
      "Copy details": ["Details kopieren"],
      "Dismiss notification": ["Benachrichtigung schließen"],
      "Copy this text manually:": ["Kopieren Sie diesen Text manuell:"],
      "Technical details": ["Technische Details"],
      "Select language": ["Sprache auswählen"],
      "Languages": ["Sprachen"],
      "Loading": ["Wird geladen"],
      "Show notifications": ["Benachrichtigungen anzeigen"],
      "Open profile": ["Profil öffnen"],
      "Open settings": ["Einstellungen öffnen"],
      "Close panel": ["Panel schließen"],
      "Menu": ["Menü"],
      "Sidebar": ["Seitenleiste"],
      "Log out": ["Abmelden"],
      "Sites": ["Websites"],
      "Copyright": ["Urheberrecht"],
      "Version %1$s (%2$s)": ["Version %1$s (%2$s)"],
      "Testing with %1$s": ["Test mit %1$s"],
      "stop testing": ["Test beenden"],
      "Learn more about %1$s": ["Mehr über %1$s erfahren"],
      "Hide details": ["Details ausblenden"],
      "Show details": ["Details anzeigen"],
      "Show more info": ["Mehr Informationen anzeigen"],
      "never": ["nie"],
      "in %1$s": ["in %1$s"],
      "%1$s ago": ["vor %1$s"],
      "Pagination": ["Seitennavigation"],
      "Page %1$s": ["Seite %1$s"],
      "First page": ["Erste Seite"],
      "Previous": ["Zurück"],
      "Next": ["Weiter"],
      "Checking compatibility of this webapp with backend service...": [
        "Kompatibilität dieser Webanwendung mit dem Backend-Dienst wird geprüft …",
      ],
      "There was an error trying to contact the backend service.": [
        "Beim Kontaktieren des Backend-Dienstes ist ein Fehler aufgetreten.",
      ],
      'The server version is not supported. Supported version "%1$s", server version "%2$s"':
        [
          "Die Serverversion wird nicht unterstützt. Unterstützte Version „%1$s“, Serverversion „%2$s“",
        ],
      "Retry": ["Erneut versuchen"],
      'The server version is not supported. Supported version "%1$s".': [
        "Die Serverversion wird nicht unterstützt. Unterstützte Version „%1$s“.",
      ],
      "Not recorded": ["Nicht erfasst"],
      "Provider": ["Anbieter"],
      "Acceptance status": ["Annahmestatus"],
      "Accepted": ["Angenommen"],
      "Accepted terms version": ["Angenommene Version der Bedingungen"],
      "Terms opened or downloaded": [
        "Bedingungen geöffnet oder heruntergeladen",
      ],
      "Yes": ["Ja"],
      "No": ["Nein"],
      "Try again": ["Erneut versuchen"],
      "Downloading PDF…": ["PDF wird heruntergeladen …"],
      "Download PDF": ["PDF herunterladen"],
      "Done": ["Fertig"],
      "The terms are not available as Markdown or plain text.": [
        "Die Bedingungen sind weder als Markdown noch als Klartext verfügbar.",
      ],
      "These terms are too large to display safely.": [
        "Diese Bedingungen sind zu umfangreich, um sie sicher anzuzeigen.",
      ],
      "The terms of service could not be loaded.": [
        "Die Allgemeinen Geschäftsbedingungen konnten nicht geladen werden.",
      ],
      "Close terms of service": ["Allgemeine Geschäftsbedingungen schließen"],
      "Loading terms of service…": [
        "Allgemeine Geschäftsbedingungen werden geladen …",
      ],
      "The PDF could not be downloaded.": [
        "Die PDF-Datei konnte nicht heruntergeladen werden.",
      ],
      "Read the terms provided by %1$s before recording your acceptance.": [
        "Lesen Sie die von %1$s bereitgestellten Bedingungen, bevor Sie Ihre Zustimmung bestätigen.",
      ],
      "Read terms again": ["Bedingungen erneut lesen"],
      "Read terms": ["Bedingungen lesen"],
      "Your acceptance applies to the version shown above.": [
        "Ihre Zustimmung gilt für die oben angezeigte Version.",
      ],
      "Review the terms of service": ["Allgemeine Geschäftsbedingungen prüfen"],
      "Read the terms before recording your acceptance.": [
        "Lesen Sie die Bedingungen, bevor Sie Ihre Zustimmung bestätigen.",
      ],
      "Accept the terms of service": [
        "Allgemeine Geschäftsbedingungen akzeptieren",
      ],
      "I have read and accept the terms of service": [
        "Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie",
      ],
      "Open the terms before accepting them.": [
        "Öffnen Sie die Bedingungen, bevor Sie sie akzeptieren.",
      ],
      "Email verification": ["E-Mail-Verifizierung"],
      "Challenge email ownership.": [
        "Bestätigung des Besitzes der E-Mail-Adresse.",
      ],
      "E-Mail": ["E-Mail"],
      "Postal verification": ["Postanschrift-Verifizierung"],
      "Challenge address ownership.": ["Bestätigung des Besitzes der Adresse."],
      "Name": ["Name"],
      "Address": ["Adresse"],
      "Country": ["Land"],
      "Phone verification": ["Telefon-Verifizierung"],
      "Challenge phone number ownership.": [
        "Bestätigung des Besitzes der Telefonnummer.",
      ],
      "Phone": ["Telefon"],
      "Generic note": ["Allgemeine Notiz"],
      "Free-form, generic note": ["Freiformulierte, allgemeine Notiz"],
      "Note / Memorandum": ["Notiz / Vermerk"],
      "Free-form notes": ["Freiformulierte Notizen"],
      "Supplemental File Upload": ["Hochladen zusätzlicher Dokumente"],
      "Optional supplemental information for the establishment of the business relationship with the customer.":
        [
          "Optionale zusätzliche Informationen zur Begründung der Geschäftsbeziehung mit dem Kunden.",
        ],
      "Supplemental Files": ["Zusätzliche Dokumente"],
      "Description": ["Beschreibung"],
      "File (PDF)": ["Datei (PDF)"],
      "Upload multiple documents": ["Mehrere Dokumente hochladen"],
      "Upload multiple documents.": ["Mehrere Dokumente hochladen."],
      "Requested documents": ["Angeforderte Dokumente"],
      "Document identifier": ["Dokumentenkennung"],
      "Title": ["Titel"],
      "Required": ["Erforderlich"],
      "Document upload (%1$s)": ["Dokument-Upload (%1$s)"],
      "Simple form": ["Einfaches Formular"],
      "Full Name": ["Vollständiger Name"],
      "Birthdate": ["Geburtsdatum"],
      "Comment": ["Kommentar"],
      "Resolution": ["Entscheidung"],
      "New state": ["Neuer Status"],
      "Frozen": ["Gesperrt"],
      "Pending": ["Ausstehend"],
      "Normal": ["Normal"],
      "New threshold": ["Neuer Schwellenwert"],
      "German": ["Deutsch"],
      "English": ["Englisch"],
      "Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange (K)":
        [
          "Feststellung des Kontrollinhabers an nicht börsenkotierten, operativ tätigen juristischen Personen und Personengesellschaften (K)",
        ],
      "for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnership that are beneficial owners":
        [
          "bei operativ tätigen juristischen Personen und Personengesellschaften als Vertragspartner sowie sinngemäss bei operativ tätigen juristischen Personen und Personengesellschaften als wirtschaftlich Berechtigte",
        ],
      "Establishment of the controlling person (submitted by customer)": [
        "Feststellung des Kontrollinhabers (durch den Kunden eingereicht)",
      ],
      "Identity of the contracting partner": ["Identität des Vertragspartners"],
      "Name and address": ["Name und Adresse"],
      "Contracting partner": ["Vertragspartner"],
      "Controlling person(s)": ["Kontrollinhaber"],
      "Reason for control": ["Grund der Kontrolle"],
      "Holding 25% or more": ["Halten von 25% oder mehr"],
      "The person(s) listed below is/are holding 25% or more of the contracting partner's shares (capital shares or voting rights)":
        [
          "Die nachfolgend aufgeführte(n) Person(en) hält/halten am Vertragspartner Anteile (Kapital- oder Stimmrechtsanteile) von 25% oder mehr",
        ],
      "Other way": ["Andere Art"],
      "If the capital shares or voting rights cannot be determined or in case there are no capital shares or voting rights 25% or more, the contracting partner hereby declares that the person(s) listed below is/are controlling the contracting partner in other ways":
        [
          "Falls die Kapital- oder Stimmrechtsanteile nicht festgestellt werden können oder falls keine Kapital- oder Stimmrechtsanteile von 25% oder mehr bestehen, erklärt der Vertragspartner hiermit, dass die nachfolgend aufgeführte(n) Person(en) auf andere Weise die Kontrolle über den Vertragspartner ausübt/ausüben",
        ],
      "Managing director": ["Geschäftsführer"],
      "In case this/these person(s) cannot be determined or this/these person(s) does/do not exist, the contracting partner hereby declares that the person(s) listed below is/are the managing director(s)":
        [
          "Falls auch diese Person(en) nicht festgestellt werden kann/können oder diese Person(en) nicht besteht/bestehen, erklärt der Vertragspartner hiermit, dass die nachfolgend aufgeführte(n) Person(en) die Geschäftsführung ausübt/ausüben",
        ],
      "Can't be empty": ["Darf nicht leer sein"],
      "Full name": ["Vollständiger Name"],
      "Actual address of domicile": ["Effektive Wohnsitzadresse"],
      "Fiduciary holding assets": [
        "Treuhänderisches Halten von Vermögenswerten",
      ],
      "Is a third person the beneficial owner of the assets held in the account/securities account?":
        [
          "Ist eine Drittperson an den auf dem Konto/Depot liegenden Vermögenswerten wirtschaftlich berechtigt?",
        ],
      "Signature(s)": ["Unterschrift(en)"],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery)":
        [
          "Die vorsätzliche Angabe falscher Informationen in diesem Formular ist eine strafbare Handlung (Urkundenfälschung gemäss Artikel 251 des Schweizerischen Strafgesetzbuchs).",
        ],
      "The contracting partner hereby undertakes to inform automatically of any changes to the information contained herein.":
        [
          "Der Vertragspartner verpflichtet sich, Änderungen jeweils unaufgefordert mitzuteilen.",
        ],
      "Date": ["Datum"],
      "Establishment of the controlling person (submitted by AML officer)": [
        "Feststellung des Kontrollinhabers (durch den AML-Beauftragten eingereicht)",
      ],
      "Signed Declaration": ["Unterzeichnete Erklärung"],
      "Signed declaration by the customer": [
        "Vom Kunden unterzeichnete Erklärung",
      ],
      "The uploaded document must contain the customer's signature on the beneficial owner declaration.":
        [
          "Das hochgeladene Dokument muss die Unterschrift des Kunden auf der Erklärung zum wirtschaftlich Berechtigten enthalten.",
        ],
      "Signed Document": ["Unterzeichnetes Dokument"],
      "invalid format": ["ungültiges Format"],
      "it can't be in the future": ["darf nicht in der Zukunft liegen"],
      "it can't be greater than 120 years": [
        "darf nicht größer als 120 Jahre sein",
      ],
      "Last name(s), first name(s)/entity": ["Name(n), Vorname(n)/Firma"],
      "Actual address of domicile/registered office": [
        "Effektive Wohnsitzadresse/Sitzadresse",
      ],
      "Date(s) of birth": ["Geburtsdatum/-daten"],
      "Nationality": ["Nationalität"],
      "Date of death (if deceased)": ["Todesfall (falls verstorben)"],
      "Foundations (as well as similar constructs) (S)": [
        "Stiftungen (sowie ähnliche Konstrukte) (S)",
      ],
      "Declaration for foundations and similar constructs.": [
        "Erklärung über Stiftungen und ähnliche Konstrukte.",
      ],
      "Contracting partner and foundation": ["Vertragspartner und Stiftung"],
      "The undersigned hereby declare(s) that as board member of the foundation, or of the highest supervisory body of an underlying company of a foundation, known as:":
        [
          "Der/die Unterzeichnete(n) erklärt/erklären hiermit, dass er/sie Mitglied des Stiftungsrates oder des obersten Aufsichtsorgans einer unterliegenden Gesellschaft einer Stiftung, mit dem Namen/der Firma:",
        ],
      "Name of the foundation": ["Name/Firma der Stiftung"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following:":
        [
          "ist/sind und in dieser Funktion nach seinem/ihrem besten Wissen die folgenden Informationen übermittelt/übermitteln:",
        ],
      "Name and information pertaining to the foundation": [
        "Namen und Angaben zur Stiftung",
      ],
      "Type of foundation": ["Art der Stiftung"],
      "Discretionary foundation": ["Diskretionäre Stiftung"],
      "Non-discretionary foundation": ["Nicht-diskretionäre Stiftung"],
      "Revocability": ["Widerrufbarkeit"],
      "Revocable foundation": ["Widerrufbare Stiftung"],
      "Irrevocable foundation": ["Nicht-widerrufbare Stiftung"],
      "Information pertaining to the founder": [
        "Angaben zum Errichter/Stifter",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, founder (individual(s) or entity/entities).":
        [
          "Angaben zum tatsächlichen, nicht treuhänderischen Errichter/Stifter (Einzelperson/en oder Gesellschaft/en).",
        ],
      "Founder(s)": ["Errichter/Stifter"],
      "Does the founder have the right to revoke the foundation?": [
        "Hat der Stifter das Recht, die Stiftung zu widerrufen?",
      ],
      "Founders of pre-existing foundations": [
        "Errichter/Stifter vorbestehender Stiftungen",
      ],
      "Complete this section if the foundation results from a restructuring (re-settlement) or merger of pre-existing foundations.":
        [
          "Auszufüllen, wenn die Stiftung aus einer Restrukturierung (Re-Settlement) oder Zusammenlegung (Merger) vorbestehender Stiftungen entstanden ist.",
        ],
      "Founder(s) of the pre-existing foundation(s)": [
        "Errichter/Stifter der vorbestehenden Stiftung(en)",
      ],
      "Beneficiaries": ["Angaben zu Begünstigten"],
      "Beneficiaries determined at the time this form is signed": [
        "Im Zeitpunkt der Unterzeichnung bestimmte Begünstigte",
      ],
      "Does the beneficiary have an actual right to claim distributions?": [
        "Hat der Begünstigte einen festen Anspruch auf Ausschüttungen?",
      ],
      "Known group(s) of beneficiaries": ["Bekannte Begünstigtengruppe(n)"],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the founder).":
        [
          "Zusätzlich zu bestimmten Begünstigten oder falls keine bestimmten Begünstigten festgelegt wurden (z.B. Nachkommen des Errichters/Stifters).",
        ],
      "Provide at least one beneficiary or group of beneficiaries": [
        "Bitte geben Sie mindestens einen Begünstigten oder eine Begünstigtengruppe an.",
      ],
      "Further persons": ["Weitere Personen"],
      "Persons entitled to determine or nominate representatives of the foundation when those representatives may dispose of assets or change asset distributions or the nomination of beneficiaries.":
        [
          "Personen, welche Vertreter der Stiftung bestimmen oder ernennen können, sofern diese Vertreter über Vermögenswerte verfügen oder die Vermögenszuteilung beziehungsweise Ernennung von Begünstigten ändern können.",
        ],
      "Further person(s)": ["Weitere Person(en)"],
      "Is/are there (a) further person(s) with the right to revoke the foundation?":
        [
          "Hat/Haben diese weitere(n) Person(en) das Recht, die Stiftung zu widerrufen?",
        ],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery).":
        [
          "Die vorsätzliche Angabe falscher Informationen in diesem Formular ist eine strafbare Handlung (Urkundenfälschung gemäss Artikel 251 des Schweizerischen Strafgesetzbuchs).",
        ],
      "The contracting partner(s) undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Der/die Vertragspartner verpflichtet/verpflichten sich, allfällige Änderungen an den hier gemachten Angaben unverzüglich mitzuteilen.",
        ],
      "Declaration for trusts (T)": ["Erklärung für Trusts (T)"],
      "Declaration for trusts.": ["Erklärung über Trusts."],
      "Contracting partner and trust": ["Vertragspartner und Trust"],
      "The undersigned hereby declare(s) that as trustee or a member of highest supervisory body of an underlying company of a trust known as:":
        [
          "Der/die Unterzeichnete(n) erklärt/erklären hiermit, dass er/sie Trustee oder Mitglied des obersten Aufsichtsorgans einer unterliegenden Gesellschaft eines Trusts usw. mit dem Namen/der Firma:",
        ],
      "Name of the trust": ["Name/Firma des Trusts"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following information:":
        [
          "ist/sind und in dieser Funktion nach seinem/ihrem besten Wissen die folgenden Informationen übermittelt/übermitteln:",
        ],
      "Name and information pertaining to the trust": [
        "Namen und Angaben zum Trust",
      ],
      "Type of trust": ["Art des Trusts"],
      "Discretionary trust": ["Discretionary Trust"],
      "Non-discretionary trust": ["Non-discretionary Trust"],
      "Revocable trust": ["Revocable Trust"],
      "Irrevocable trust": ["Irrevocable Trust"],
      "Information pertaining to the settlor": ["Angaben zum Settlor"],
      "Information pertaining to the ultimate economic, not fiduciary, settlor of the trust (individual(s) or entity/entities).":
        [
          "Angaben zum tatsächlichen, nicht treuhänderischen Settlor des Trusts (Einzelperson/en oder Gesellschaft/en).",
        ],
      "Settlor(s)": ["Settlor"],
      "Does the settlor have the right to revoke the trust?": [
        "Hat der Settlor das Recht, den Trust zu widerrufen?",
      ],
      "Settlors of pre-existing trusts": ["Settlor(s) vorbestehender Trusts"],
      "Complete this section if the trust results from a restructuring (re-settlement) or merger of pre-existing trusts.":
        [
          "Auszufüllen, wenn der Trust aus einer Restrukturierung (Re-Settlement) oder Zusammenlegung (Merger) vorbestehender Trusts entstanden ist.",
        ],
      "Settlor(s) of the pre-existing trust(s)": [
        "Settlor(s) des/der vorbestehenden Trusts",
      ],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the settlor).":
        [
          "Zusätzlich zu bestimmten Begünstigten oder falls keine bestimmten Begünstigten festgelegt wurden (z.B. Nachkommen des Settlors).",
        ],
      "Protectors": ["Protektoren"],
      "Protector(s)": ["Protektor(en)"],
      "Does the protector have the right to revoke the trust?": [
        "Hat der Protektor das Recht, den Trust zu widerrufen?",
      ],
      "Further persons having the right to appoint the trustee of a trust.": [
        "Weitere Personen, welche das Recht haben, den Trustee eines Trusts zu bestimmen.",
      ],
      "Do any further persons have the right to revoke the trust?": [
        "Hat/Haben diese weitere(n) Person(en) das Recht, den Trust zu widerrufen?",
      ],
      "The contracting partner(s) hereby declare(s) to be entitled to open a business relationship for the trust above or its underlying company.":
        [
          "Der/die Vertragspartner bestätigt/bestätigen, dass er/sie zur Aufnahme der Geschäftsbeziehung für den oben genannten Trust oder dessen unterliegender Gesellschaft berechtigt ist/sind.",
        ],
      "The contracting partner(s) hereby undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Der/die Vertragspartner verpflichtet/verpflichten sich, allfällige Änderungen an den hier gemachten Angaben unverzüglich mitzuteilen.",
        ],
      "The customer is the person with whom the member concludes the contract with regard to the financial service provided (civil law). If the\n  member acts as the director of a domiciliary company, then that domiciliary company is the customer.":
        [
          "Kunde ist die Person, mit welcher das Mitglied den Vertrag über die erbrachte Finanzdienstleistung abschliesst (Zivilrecht). Handelt das\n  Mitglied als Organ einer Sitzgesellschaft, so ist diese Sitzgesellschaft der Kunde.",
        ],
      "Identification Form (customer)": ["Identifikationsformular (Kunde)"],
      "The customer has to be identified on entering into a permanent business relationship or on concluding a cash transaction, which meets the according threshold.":
        [
          "Die Vertragspartei muss identifiziert werden bei allen dauernden Geschäftsbeziehungen sowie bei Kassageschäften, bei welchen der entsprechende Schwellenwert erreicht wird.",
        ],
      "Correspondence language:": ["Korrespondenzsprache:"],
      "French": ["Französisch"],
      "Italian": ["Italienisch"],
      "Identification form (basic customer information)": [
        "Identifikationsformular (Basisangaben zum Kunden)",
      ],
      "Information on customer": ["Angaben zum Kunden"],
      "Customer type": ["Kundentyp"],
      "Natural person (incl. sole proprietors)": [
        "Natürliche Person (inkl. Einzelunternehmen)",
      ],
      "Legal entity": ["Juristische Person"],
      "Applicable if customer is a natural person": [
        "Anwendbar, wenn der Kunde eine natürliche Person ist",
      ],
      "Residential address in Switzerland": ["Wohnsitzadresse in der Schweiz"],
      "Telephone": ["Telefon"],
      "Email": ["E-Mail"],
      "Date of birth": ["Geburtsdatum"],
      "Copy of identification document": ["Kopie des Ausweisdokuments"],
      "Only official government IDs (incl. passports) are accepted. Please scan both sides if applicable.":
        [
          "Es werden nur amtliche Ausweise (inkl. Pässe) akzeptiert. Bitte scannen Sie gegebenenfalls beide Seiten.",
        ],
      "Sole proprietor": ["Einzelunternehmen"],
      "Information on customer (sole proprietor)": [
        "Angaben zum Kunden (Einzelunternehmen)",
      ],
      "Applicable only if customer is a sole proprietor": [
        "Nur anwendbar, wenn der Kunde ein Einzelunternehmen ist",
      ],
      "Company name": ["Firmenname"],
      "Registered office": ["Sitz"],
      "Company identification document": [
        "Identifikationsdokument des Unternehmens",
      ],
      "Information on customer (legal entity)": [
        "Angaben zum Kunden (juristische Person)",
      ],
      "Applicable if customer is a legal entity": [
        "Anwendbar, wenn der Kunde eine juristische Person ist",
      ],
      "Domicile": ["Sitz"],
      "Contact person": ["Kontaktperson"],
      "Copy of identification document (not older than 12 months)": [
        "Kopie des Ausweisdokuments (nicht älter als 12 Monate)",
      ],
      "Company share registry file": ["Aktienbuchauszug"],
      "Correspondence Preferences": ["Korrespondenzpräferenzen"],
      "Information on the natural persons who establish the business relationship for legal entities and partnerships":
        [
          "Angaben zu den natürlichen Personen, die für juristische Personen und Personengesellschaften die Geschäftsbeziehung eröffnen (Eröffner)",
        ],
      "For legal entities and partnerships the identity of the natural persons who establish the business relationship must be verified.":
        [
          "Bei juristischen Personen und Personengesellschaften ist die Identität der natürlichen Personen, welche die Geschäftsbeziehung eröffnen, zu überprüfen.",
        ],
      "Persons establishing the legal relationship": [
        "Personen, welche die Geschäftsbeziehung begründen",
      ],
      "Residential address": ["Wohnsitzadresse"],
      "Signing authority of the person": ["Zeichnungsberechtigung der Person"],
      "Power of attorney arrangements": ["Vollmachtregelung"],
      "Sole signature authority": ["Einzelzeichnungsberechtigung"],
      "Collective authority with two signatures": [
        "Kollektivzeichnungsberechtigung zu zweien",
      ],
      "Other (please specify)": ["Andere (bitte angeben)"],
      "Other type of signing authority": [
        "Andere Art der Zeichnungsberechtigung",
      ],
      "Evidence of signing authority:": [
        "Nachweis der Zeichnungsberechtigung:",
      ],
      "Company register extract": ["Handelsregisterauszug"],
      "Mandate": ["Mandat"],
      "Other": ["Andere"],
      "Specify other way of establishing signing authority:": [
        "Andere Art des Nachweises der Zeichnungsberechtigung angeben:",
      ],
      "Copy of document that serves as evidence of signing authority:": [
        "Kopie des Dokuments, das als Nachweis der Zeichnungsberechtigung dient:",
      ],
      "Customer classification": ["Kundenklassifizierung"],
      "Classification for the establishment of the beneficial owner of the assets and/or controlling person":
        [
          "Klassifizierung zur Feststellung des wirtschaftlich Berechtigten der Vermögenswerte und/oder des Kontrollinhabers",
        ],
      "The customer is:": ["Der Kunde ist:"],
      "A natural person and there are no doubts that this person is the sole beneficial owner of the assets":
        [
          "Eine natürliche Person und es bestehen keine Zweifel, dass diese selber an den Vermögenswerten wirtschaftlich berechtigt ist",
        ],
      "An operational legal entity or partnership": [
        "Eine operative juristische Person oder Personengesellschaft",
      ],
      "A foundation (or a similar construct; incl. underlying companies)": [
        "Eine Stiftung (oder ein ähnliches Konstrukt; inkl. Underlying Companies)",
      ],
      "A trust (incl. underlying companies)": [
        "Ein Trust (inkl. Underlying Companies)",
      ],
      "A life insurance policy with separately managed accounts / securities accounts (so-called insurance wrappers)":
        [
          "Eine Lebensversicherung mit separater Konto-/Depotführung (sog. Insurance Wrapper)",
        ],
      "Special Clarifications": ["Besondere Abklärungen"],
      "When a business relationship or transaction is associated with increased risk, appears unusual or evidence exists that the assets are the proceeds of a felony or a qualified tax offence, the member has to perform additional clarifications.":
        [
          "Wenn eine Geschäftsbeziehung oder Transaktion mit einem erhöhten Risiko verbunden ist, ungewöhnlich erscheint oder Anhaltspunkte dafür bestehen, dass die Vermögenswerte aus einem Verbrechen oder einem qualifizierten Steuervergehen stammen, hat das Mitglied zusätzliche Abklärungen durchzuführen.",
        ],
      "Customer": ["Kunde"],
      "Reason for special clarifications": ["Grund für besondere Abklärungen"],
      "Reason": ["Grund"],
      "Description of the circumstances/transactions, which triggered the special clarifications":
        [
          "Beschreibung der Umstände/Transaktionen, welche die besonderen Abklärungen ausgelöst haben",
        ],
      "can't be empty": ["darf nicht leer sein"],
      "Used means of clarification": ["Verwendete Abklärungsmittel"],
      "Means": ["Mittel"],
      "Gathering of information from the customer, beneficial owner of the assets, controlling person":
        [
          "Einholung von Informationen beim Kunden, wirtschaftlich Berechtigten der Vermögenswerte, dem Kontrollinhaber",
        ],
      "Consultation of generally accessible sources and databases": [
        "Konsultation allgemein zugänglicher Quellen und Datenbanken",
      ],
      "Enquiries with trustworthy persons": [
        "Erkundigungen bei vertrauenswürdigen Personen",
      ],
      "Other, which?": ["Andere, welche?"],
      "Other means of clarification:": ["Andere Abklärungsmittel:"],
      "Optional supplemental information for the special clarifications.": [
        "Optionale ergänzende Angaben zu den besonderen Abklärungen.",
      ],
      "Summary and plausibility check of the gathered information": [
        "Zusammenfassung und Plausibilitätsprüfung der eingeholten Informationen",
      ],
      "The results of the clarifications have to be documented and their plausibility has to be checked.":
        [
          "Die Ergebnisse der Abklärungen sind zu dokumentieren und auf ihre Plausibilität zu prüfen.",
        ],
      "Summary": ["Zusammenfassung"],
      "Gathered/Consulted documents": ["Eingeholte/konsultierte Dokumente"],
      "Result of the special clarification": [
        "Ergebnis der besonderen Abklärung",
      ],
      "Result": ["Ergebnis"],
      "No suspicion": ["Kein Verdacht"],
      "The plausibility of the circumstances could be checked, no reasonable suspicion pursuant to Art. 9 AMLA (possibly update of customer profile and/or risk profile)":
        [
          "Die Plausibilität der Umstände konnte überprüft werden, kein begründeter Verdacht gemäss Art. 9 GwG (gegebenenfalls Aktualisierung des Kundenprofils und/oder Risikoprofils)",
        ],
      "Reasonable suspicion": ["Begründeter Verdacht"],
      "Reasonable suspicion pursuant to Art. 9 AMLA, duty to file a report with MROS":
        ["Begründeter Verdacht gemäss Art. 9 GwG, Meldepflicht bei der MROS"],
      "Simple suspicion": ["Einfacher Verdacht"],
      "Simple suspicion pursuant to Art. 305ter Para. 2 StGB, right to notify MROS":
        [
          "Einfacher Verdacht gemäss Art. 305ter Abs. 2 StGB, Melderecht gegenüber der MROS",
        ],
      "Other, what?": ["Andere, was?"],
      "Result clarification": ["Erläuterung des Ergebnisses"],
      "Identification Form (acceptance)": ["Identifikationsformular (Annahme)"],
      "Acceptance of business relationship": ["Annahme der Geschäftsbeziehung"],
      "Date (conclusion of contract):": ["Datum (Vertragsabschluss):"],
      "Accepted via:": ["Angenommen über:"],
      "Face to face": ["Persönlich"],
      "Authenticated copy of identification document": [
        "Beglaubigte Kopie des Ausweisdokuments",
      ],
      "Residential address validated": ["Wohnsitzadresse überprüft"],
      "Further information:": ["Weitere Angaben:"],
      "Evaluation with regard to embargo procedures/terrorism lists on establishing the business relationship":
        [
          "Prüfung im Hinblick auf Embargomassnahmen/Terrorlisten bei Aufnahme der Geschäftsbeziehung",
        ],
      "Verification whether the customer, beneficial owners of the assets, controlling persons, authorized representatives or other involved persons are listed on an embargo/terrorism list.":
        [
          "Überprüfung, ob der Kunde, die wirtschaftlich Berechtigten der Vermögenswerte, die Kontrollinhaber, bevollmächtigten Vertreter oder andere beteiligte Personen auf einer Embargo-/Terrorliste aufgeführt sind.",
        ],
      "Embargo/terrorism status:": ["Embargo-/Terror-Status:"],
      "Not listed on embargo/terrorism list.": [
        "Nicht auf einer Embargo-/Terrorliste aufgeführt.",
      ],
      "Listed on embargo/terrorism list.": [
        "Auf einer Embargo-/Terrorliste aufgeführt.",
      ],
      "Embargo/terrorism information:": ["Embargo-/Terror-Angaben:"],
      "Verification date": ["Datum der Überprüfung"],
      "Supplemental files": ["Ergänzende Dokumente"],
      "Risk Profile AMLA": ["Risikoprofil GwG"],
      "Evaluation of politically exposed persons (PEP-Check)": [
        "Beurteilung politisch exponierter Personen (PEP-Check)",
      ],
      "This evaluation has to be completed by all members for every business relationship.":
        [
          "Diese Beurteilung ist von allen Mitgliedern für jede Geschäftsbeziehung durchzuführen.",
        ],
      "Foreign PEP": ["Ausländische PEP"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a foreign PEP or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine ausländische PEP oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "Domestic PEP": ["Inländische PEP"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a domestic PEP or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine inländische PEP oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "PEP of International Organisations": [
        "PEP internationaler Organisationen",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a PEP in International Organisations or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine PEP einer internationalen Organisation oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "Acceptance date": ["Datum der Annahme"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with a PEP was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer Geschäftsbeziehung mit einer PEP eingeholt wurde.",
        ],
      'Evaluation "high risk" or non-cooperative country': [
        "Beurteilung „Hochrisikoland“ oder nicht kooperatives Land",
      ],
      "High-risk or non-cooperative country": [
        "Hochrisikoland oder nicht kooperatives Land",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative in a country considered by the FATF as high-risk or non-cooperative and for which FATF requires increased diligence?":
        [
          "Befindet sich der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter in einem Land, das von der FATF als Hochrisikoland oder nicht kooperatives Land eingestuft wird und für welches die FATF erhöhte Sorgfaltspflichten verlangt?",
        ],
      "When the decision of the Senior executive body on the acceptance of such a business relationship was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer solchen Geschäftsbeziehung eingeholt wurde.",
        ],
      "Evaluation of business relationship risk": [
        "Beurteilung des Risikos der Geschäftsbeziehung",
      ],
      "Country risk": ["Länderrisiko"],
      "Applicable country risk types": ["Anwendbare Arten von Länderrisiken"],
      "Nationality of the customer": ["Staatsangehörigkeit des Kunden"],
      "Nationality of the beneficial owner of the assets": [
        "Staatsangehörigkeit des wirtschaftlich Berechtigten der Vermögenswerte",
      ],
      "Domicile/residential address of the customer": [
        "Sitz/Wohnsitzadresse des Kunden",
      ],
      "Domicile/residential address of the beneficial owner of the assets": [
        "Sitz/Wohnsitzadresse des wirtschaftlich Berechtigten der Vermögenswerte",
      ],
      "Domicile/residential address of the controlling person": [
        "Sitz/Wohnsitzadresse des Kontrollinhabers",
      ],
      "Country risk level (nationality)": [
        "Länderrisikostufe (Staatsangehörigkeit)",
      ],
      "Risk category according to VQF country list (VQF doc. no. 902.4.1)": [
        "Risikokategorie gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Low (Risk 0)": ["Niedrig (Risiko 0)"],
      "Risk 0 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 0 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Medium (Risk 1)": ["Mittel (Risiko 1)"],
      "Risk 1 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 1 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "High (Risk 2)": ["Hoch (Risiko 2)"],
      "Risk 2 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 2 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Country risk type (place of business activity)": [
        "Art des Länderrisikos (Ort der Geschäftstätigkeit)",
      ],
      "Beneficial owner": ["Wirtschaftlich Berechtigte(r)"],
      "Country risk level (business activity)": [
        "Länderrisikostufe (Geschäftstätigkeit)",
      ],
      "Industry risk": ["Branchenrisiko"],
      "Industry risk source": ["Quelle des Branchenrisikos"],
      "Beneficial owner of the assets": [
        "Wirtschaftlich Berechtigter der Vermögenswerte",
      ],
      "Industry risk level": ["Branchenrisikostufe"],
      "Transparent (Risk Level 0)": ["Transparent (Risikostufe 0)"],
      "Clearly defined, transparent, easily comprehensible business activity well known to the member.":
        [
          "Klar definierte, transparente, leicht nachvollziehbare Geschäftstätigkeit, die dem Mitglied gut bekannt ist.",
        ],
      "High cash transactions (Risk Level 1)": [
        "Hoher Anteil an Bargeldtransaktionen (Risikostufe 1)",
      ],
      "Business activity with a high level of cash transactions.": [
        "Geschäftstätigkeit mit einem hohen Anteil an Bartransaktionen.",
      ],
      "Not well known (Risk Level 1)": ["Nicht gut bekannt (Risikostufe 1)"],
      "Business activity not well known to the member.": [
        "Geschäftstätigkeit, die dem Mitglied nicht gut bekannt ist.",
      ],
      "High-risk trade (Risk Level 2)": [
        "Handel mit hohem Risiko (Risikostufe 2)",
      ],
      "Trade in munitions/arms, raw gem stones/diamonds, jewellery, international trade in exotic animals, casino and lottery business, trade in erotic wares.":
        [
          "Handel mit Munition/Waffen, Rohedelsteinen/Diamanten, Schmuck, internationaler Handel mit exotischen Tieren, Casino- und Lotteriegeschäft, Handel mit Erotikartikeln.",
        ],
      "Unknown industry (Risk Level 2)": ["Unbekannte Branche (Risikostufe 2)"],
      "Member has no personal knowledge of the customer’s industry.": [
        "Das Mitglied verfügt über keine persönliche Kenntnis der Branche des Kunden.",
      ],
      "Contact risk": ["Kontaktrisiko"],
      "Type of contact to the customer/beneficial owner of the assets.": [
        "Art des Kontakts zum Kunden/wirtschaftlich Berechtigten der Vermögenswerte.",
      ],
      "Contact risk level": ["Kontaktrisikostufe"],
      "Low contact risk": ["Tiefes Kontaktrisiko"],
      "Personal acquaintance between member and customer/beneficial owner of the assets over several years (at least 2) prior to entering into the business relationship":
        [
          "Persönliche Bekanntschaft zwischen Mitglied und Kunde/wirtschaftlich Berechtigtem der Vermögenswerte über mehrere Jahre (mindestens 2) vor Aufnahme der Geschäftsbeziehung",
        ],
      "Medium contact risk": ["Mittleres Kontaktrisiko"],
      "The customer/beneficial owner was not personally known to the member for several years (at least 2) prior to entering into the business relationship; however (a) no business was entered into in the absence of the customer/beneficial owner, or (b) the customer was at least introduced/brokered by a trusted third party.":
        [
          "Der Kunde/wirtschaftlich Berechtigte war dem Mitglied nicht während mehrerer Jahre (mindestens 2) vor Aufnahme der Geschäftsbeziehung persönlich bekannt; jedoch wurde (a) keine Geschäftsbeziehung in Abwesenheit des Kunden/wirtschaftlich Berechtigten eingegangen, oder (b) der Kunde wurde zumindest von einem vertrauenswürdigen Dritten eingeführt/vermittelt.",
        ],
      "High contact risk": ["Hohes Kontaktrisiko"],
      "The customer/beneficial owner was not personally known to the member and business was entered into in the absence of the former (relationship by correspondence) and the customer was not introduced/brokered by a trusted third party.":
        [
          "Der Kunde/wirtschaftlich Berechtigte war dem Mitglied nicht persönlich bekannt, und die Geschäftsbeziehung wurde in dessen Abwesenheit eingegangen (Korrespondenzbeziehung), wobei der Kunde nicht von einem vertrauenswürdigen Dritten eingeführt/vermittelt wurde.",
        ],
      "Summary evaluation": ["Zusammenfassende Beurteilung"],
      "Justification for risk assessment": ["Begründung der Risikobeurteilung"],
      "Risk classification": ["Risikoklassifizierung"],
      "Conclusion whether the business relationship is with or without increased risk.":
        [
          "Schlussfolgerung, ob die Geschäftsbeziehung mit oder ohne erhöhtes Risiko verbunden ist.",
        ],
      "No high risk": ["Kein hohes Risiko"],
      "High risk": ["Hohes Risiko"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with increased risk was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer Geschäftsbeziehung mit erhöhtem Risiko eingeholt wurde.",
        ],
      "Customer Profile": ["Kundenprofil"],
      "The information below has to refer to the persons from whom the assets originate ultimately (e.g. beneficial owner of the assets, founder/creator of a trust or foundation). Is the customer an operational legal entity or partnership the information may refer to the entity itself (not to the controlling person), unless the entity holds the assets in trust for a third party.":
        [
          "Die nachstehenden Angaben müssen sich auf die Personen beziehen, von denen die Vermögenswerte letztlich stammen (z. B. wirtschaftlich Berechtigter der Vermögenswerte, Gründer/Errichter eines Trusts oder einer Stiftung). Ist der Kunde eine operativ tätige juristische Person oder Personengesellschaft, können sich die Angaben auf die Gesellschaft selbst (nicht auf den Kontrollinhaber) beziehen, sofern die Gesellschaft die Vermögenswerte nicht treuhänderisch für einen Dritten hält.",
        ],
      "Business activity": ["Geschäftstätigkeit"],
      "Profession, business activities, etc. (former, current, potentially planned)":
        [
          "Beruf, Geschäftstätigkeiten usw. (frühere, aktuelle, allenfalls geplante)",
        ],
      "Financial circumstances": ["Finanzielle Verhältnisse"],
      "Income and assets, liabilities (estimated)": [
        "Einkommen und Vermögen, Verbindlichkeiten (geschätzt)",
      ],
      "Origin of the deposited assets involved": [
        "Herkunft der betroffenen eingebrachten Vermögenswerte",
      ],
      "Will the customer deposit assets with Taler Operations AG?": [
        "Wird der Kunde Vermögenswerte bei der Taler Operations AG einbringen?",
      ],
      "Nature, amount and currency of deposited assets.": [
        "Art, Betrag und Währung der eingebrachten Vermögenswerte.",
      ],
      "Category": ["Kategorie"],
      "Savings": ["Ersparnisse"],
      "Own business operations": ["Eigene Geschäftstätigkeit"],
      "Inheritance": ["Erbschaft"],
      "Category clarification": ["Erläuterung der Kategorie"],
      "Detailed description of the origins/economic background of the assets involved in the business relationship":
        [
          "Detaillierte Beschreibung der Herkunft/des wirtschaftlichen Hintergrunds der in die Geschäftsbeziehung eingebrachten Vermögenswerte",
        ],
      "Nature and purpose of the business relationship": [
        "Art und Zweck der Geschäftsbeziehung",
      ],
      "Purpose of the business relationship": ["Zweck der Geschäftsbeziehung"],
      "Information on the planned development of the business relationship and the assets":
        [
          "Angaben zur geplanten Entwicklung der Geschäftsbeziehung und der Vermögenswerte",
        ],
      "Details on usual business volume": [
        "Angaben zum üblichen Geschäftsvolumen",
      ],
      "Relationship with third parties": ["Beziehung zu Dritten"],
      "Relation of the customer to the beneficial owner, controlling persons, authorised signatories and other persons involved in the business relationship":
        [
          "Beziehung des Kunden zum wirtschaftlich Berechtigten, den Kontrollinhabern, den Zeichnungsberechtigten und anderen an der Geschäftsbeziehung beteiligten Personen",
        ],
      "Relation to other AMLA-Files": ["Bezug zu anderen GwG-Dossiers"],
      "Introducer / agents / references": [
        "Vermittler / Beauftragte / Referenzen",
      ],
      "Further information": ["Weitere Angaben"],
      "Other relevant information": ["Weitere relevante Angaben"],
      "Declaration of identity of the beneficial owner (A) — customer": [
        "Feststellung des wirtschaftlich Berechtigten (A) — Kunde",
      ],
      "The customer completes the declaration directly in the form.": [
        "Der Kunde füllt die Erklärung direkt im Formular aus.",
      ],
      "Declaration of identity of the beneficial owner": [
        "Feststellung des wirtschaftlich Berechtigten",
      ],
      "Beneficial owner details": ["Angaben zum wirtschaftlich Berechtigten"],
      "Beneficial owner(s)": ["Wirtschaftlich Berechtigte(r)"],
      "The person(s) listed below is/are the beneficial owner(s) of the assets involved in the business relationship. If the contracting partner is also the sole beneficial owner of the assets, the contracting partner's detail must be set out below":
        [
          "Die nachfolgend aufgeführte(n) Person(en) ist/sind an den in die Geschäftsbeziehung eingebrachten Vermögenswerten wirtschaftlich berechtigt. Ist der Vertragspartner selber allein an diesen Vermögenswerten wirtschaftlich berechtigt, so sind nachstehend seine Personalien festzuhalten",
        ],
      "Domicile address": ["Sitzadresse"],
      "Declaration of identity of the beneficial owner (A) — AML officer": [
        "Feststellung des wirtschaftlich Berechtigten (A) — GwG-Beauftragter",
      ],
      "The AML officer records the declaration and uploads the customer's signed PDF.":
        [
          "Der GwG-Beauftragte erfasst die Erklärung und lädt das vom Kunden unterzeichnete PDF hoch.",
        ],
      "January": ["Januar"],
      "February": ["Februar"],
      "March": ["März"],
      "April": ["April"],
      "May": ["Mai"],
      "June": ["Juni"],
      "July": ["Juli"],
      "August": ["August"],
      "September": ["September"],
      "October": ["Oktober"],
      "November": ["November"],
      "December": ["Dezember"],
      "Previous year": ["Vorheriges Jahr"],
      "Next year": ["Nächstes Jahr"],
      "Previous month": ["Vorheriger Monat"],
      "Next month": ["Nächster Monat"],
      "Close dialog": ["Dialog schließen"],
      "Official form language": ["Offizielle Formularsprache"],
      "This form is shown in an official, legally binding language.": [
        "Dieses Formular wird in einer offiziellen, rechtsverbindlichen Sprache angezeigt.",
      ],
      "Official translation": ["Offizielle Übersetzung"],
      "This form is shown in an official translation, but it is not legally binding. Only the %1$s text is legally binding.":
        [
          "Dieses Formular wird in einer offiziellen Übersetzung angezeigt, die jedoch nicht rechtsverbindlich ist. Nur der Text in %1$s ist rechtsverbindlich.",
        ],
      "Unofficial form translation": ["Inoffizielle Formularübersetzung"],
      "This form is not officially supported in the selected language. The translation may be incomplete, and some text may be shown in %1$s. Only the %2$s text is legally binding.":
        [
          "Dieses Formular wird in der ausgewählten Sprache nicht offiziell unterstützt. Die Übersetzung kann unvollständig sein, und Teile des Textes können in %1$s angezeigt werden. Nur der Text in %2$s ist rechtsverbindlich.",
        ],
      "Shorten file contents.": ["Dateiinhalte kürzen."],
      "Result JSON:": ["JSON-Ergebnis:"],
      "List of fields with errors": ["Liste der Felder mit Fehlern"],
      "Delete this item?": ["Diesen Eintrag löschen?"],
      "Keep item": ["Eintrag behalten"],
      "Delete item": ["Eintrag löschen"],
      "Cancel": ["Abbrechen"],
      "Delete": ["Löschen"],
      "Add item": ["Eintrag hinzufügen"],
      "Save changes": ["Änderungen speichern"],
      "Item %1$s": ["Eintrag %1$s"],
      "Edit %1$s": ["%1$s bearbeiten"],
      "Edit": ["Bearbeiten"],
      "Clear selection": ["Auswahl löschen"],
      "Toggle choices": ["Auswahlmöglichkeiten anzeigen"],
      "No element found": ["Kein Element gefunden"],
      "years": ["Jahre"],
      "months": ["Monate"],
      "days": ["Tage"],
      "hours": ["Stunden"],
      "minutes": ["Minuten"],
      "seconds": ["Sekunden"],
      "No expiration": ["Keine Ablaufzeit"],
      "Forever": ["Für immer"],
      "The selected file is too large.": ["Die ausgewählte Datei ist zu groß."],
      "The selected file could not be read.": [
        "Die ausgewählte Datei konnte nicht gelesen werden.",
      ],
      "Upload a file": ["Eine Datei hochladen"],
      "Clear": ["Leeren"],
      "Download a copy.": ["Eine Kopie herunterladen."],
      "This option is not available.": ["Diese Option ist nicht verfügbar."],
      "The maximum number of selections has been reached.": [
        "Die maximale Anzahl von Auswahlmöglichkeiten wurde erreicht.",
      ],
      "Remove %1$s": ["%1$s entfernen"],
      "Simple comment": ["Einfacher Kommentar"],
      "Terms URL": ["URL der Bedingungen"],
      "Terms version": ["Version der Bedingungen"],
      "Provider name": ["Name des Anbieters"],
      "Only show the external link": ["Nur den externen Link anzeigen"],
      "Name and birthdate": ["Name und Geburtsdatum"],
      "Select an example from the list on the left.": [
        "Wählen Sie links in der Liste ein Beispiel aus.",
      ],
      "Example not found.": ["Beispiel nicht gefunden."],
      "An error occurred while rendering the example.": [
        "Beim Anzeigen des Beispiels ist ein Fehler aufgetreten.",
      ],
      "Group": ["Gruppe"],
      "Component": ["Komponente"],
      "Example": ["Beispiel"],
      "Arguments": ["Argumente"],
      "Dataset": ["Datensatz"],
      "Dataset %1$s of %2$s": ["Datensatz %1$s von %2$s"],
      "Select a story": ["Beispiel auswählen"],
      "Open stories navigation": ["Beispielnavigation öffnen"],
      "Stories navigation": ["Beispielnavigation"],
      "Stories": ["Beispiele"],
      "Close stories navigation": ["Beispielnavigation schließen"],
      "Language": ["Sprache"],
      "%1$s": ["%1$s"],
      "Free-form message": ["Freitext-Nachricht"],
      "Are you a cross-border truck driver?": [
        "Sind Sie ein grenzüberschreitend tätiger Lkw-Fahrer?",
      ],
      "How much cash are you carrying?": [
        "Wie viel Bargeld führen Sie mit sich?",
      ],
      "Germany": ["Deutschland"],
      "Switzerland": ["Schweiz"],
      "Sign-in failed": ["Anmeldung fehlgeschlagen"],
      "Check your password.": ["Überprüfen Sie Ihr Passwort."],
      "Try again in a moment.": ["Versuchen Sie es gleich noch einmal."],
      "First error": ["Erster Fehler"],
      "First description": ["Erste Beschreibung"],
      "Second error": ["Zweiter Fehler"],
      "Second description": ["Zweite Beschreibung"],
      "Saved": ["Gespeichert"],
      "Request failed": ["Anfrage fehlgeschlagen"],
      "Try again.": ["Versuchen Sie es erneut."],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "de",
  completeness: 100,
};

strings["de-CH"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de-CH",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "required": ["erforderlich"],
      "Validation failed unexpectedly. Please contact the developers: %1$s": [
        "Die Validierung ist unerwartet fehlgeschlagen. Bitte kontaktieren Sie die Entwickler: %1$s",
      ],
      "Terms of service": ["Allgemeine Geschäftsbedingungen"],
      "Read the terms of service before continuing.": [
        "Lesen Sie die Allgemeinen Geschäftsbedingungen, bevor Sie fortfahren.",
      ],
      "Terms acceptance": ["Zustimmung zu den Bedingungen"],
      "Accept the terms of service before continuing.": [
        "Akzeptieren Sie die Allgemeinen Geschäftsbedingungen, bevor Sie fortfahren.",
      ],
      "Looks like the JSON in the request was malformed.": [
        "Es scheint, dass das JSON in der Anfrage fehlerhaft war.",
      ],
      "The request timed out. Check your connection.": [
        "Zeitüberschreitung bei der Anfrage. Überprüfen Sie Ihre Verbindung.",
      ],
      "The %1$s request to %2$s failed after %3$s seconds.": [
        "Die %1$s-Anfrage an %2$s ist nach %3$s Sekunden fehlgeschlagen.",
      ],
      "The last request time is %1$s": ["Die letzte Anfragezeit ist %1$s"],
      "The request was cancelled.": ["Die Anfrage wurde abgebrochen."],
      "The %1$s request %2$s failed with code %3$s.": [
        "Die %1$s-Anfrage %2$s ist mit Code %3$s fehlgeschlagen.",
      ],
      "The request was made at %1$s": ["Die Anfrage wurde um %1$s gestellt"],
      "Too many requests were made to the server and this action was throttled.":
        [
          "Es wurden zu viele Anfragen an den Server gestellt, und diese Aktion wurde gedrosselt.",
        ],
      'The request "%1$s %2$s" failed with code %3$s': [
        "Die Anfrage „%1$s %2$s“ ist mit Code %3$s fehlgeschlagen",
      ],
      "The server's response was malformed.": [
        "Die Antwort des Servers war fehlerhaft.",
      ],
      'The response to "%1$s %2$s" failed with code %3$s': [
        "Die Antwort auf „%1$s %2$s“ ist mit Code %3$s fehlgeschlagen",
      ],
      "The content type is %1$s": ["Der Inhaltstyp ist %1$s"],
      'The validation error is "%1$s"': ["Der Validierungsfehler ist „%1$s“"],
      "Due to a network problem the request could not be finished.": [
        "Aufgrund eines Netzwerkproblems konnte die Anfrage nicht abgeschlossen werden.",
      ],
      "The %1$s request to %2$s failed.": [
        "Die %1$s-Anfrage an %2$s ist fehlgeschlagen.",
      ],
      "The server's response was unexpected. This means the client and the server are not in sync about the protocol.":
        [
          "Die Antwort des Servers war unerwartet. Das bedeutet, dass Client und Server hinsichtlich des Protokolls nicht synchron sind.",
        ],
      "The %1$s request to %2$s failed with code %3$s": [
        "Die %1$s-Anfrage an %2$s ist mit Code %3$s fehlgeschlagen",
      ],
      'And the server says: "%1$s"': ["Und der Server sagt: „%1$s“"],
      "Unexpected error": ["Unerwarteter Fehler"],
      "An unexpected error occurred and was not handled properly. To report it, copy the details and create an issue at https://bugs.taler.net.":
        [
          "Ein unerwarteter Fehler ist aufgetreten und wurde nicht ordnungsgemäss behandelt. Um ihn zu melden, kopieren Sie die Details und erstellen Sie unter https://bugs.taler.net einen Fehlerbericht.",
        ],
      "Render error.": ["Darstellungsfehler."],
      "The operation failed.": ["Der Vorgang ist fehlgeschlagen."],
      "The server rejected the operation without a specific error message.": [
        "Der Server hat den Vorgang ohne konkrete Fehlermeldung abgelehnt.",
      ],
      "Unexpected error.": ["Unerwarteter Fehler."],
      "The runtime threw an Error which was not properly handled. Please report this at https://bugs.taler.net.":
        [
          "Die Laufzeitumgebung hat einen Fehler ausgelöst, der nicht ordnungsgemäss behandelt wurde. Bitte melden Sie ihn unter https://bugs.taler.net.",
        ],
      "Copy details": ["Details kopieren"],
      "Dismiss notification": ["Benachrichtigung schliessen"],
      "Copy this text manually:": ["Kopieren Sie diesen Text manuell:"],
      "Technical details": ["Technische Details"],
      "Select language": ["Sprache auswählen"],
      "Languages": ["Sprachen"],
      "Loading": ["Wird geladen"],
      "Show notifications": ["Benachrichtigungen anzeigen"],
      "Open profile": ["Profil öffnen"],
      "Open settings": ["Einstellungen öffnen"],
      "Close panel": ["Panel schliessen"],
      "Menu": ["Menü"],
      "Sidebar": ["Seitenleiste"],
      "Log out": ["Abmelden"],
      "Sites": ["Websites"],
      "Copyright": ["Urheberrecht"],
      "Version %1$s (%2$s)": ["Version %1$s (%2$s)"],
      "Testing with %1$s": ["Test mit %1$s"],
      "stop testing": ["Test beenden"],
      "Learn more about %1$s": ["Mehr über %1$s erfahren"],
      "Hide details": ["Details ausblenden"],
      "Show details": ["Details anzeigen"],
      "Show more info": ["Mehr Informationen anzeigen"],
      "never": ["nie"],
      "in %1$s": ["in %1$s"],
      "%1$s ago": ["vor %1$s"],
      "Pagination": ["Seitennavigation"],
      "Page %1$s": ["Seite %1$s"],
      "First page": ["Erste Seite"],
      "Previous": ["Zurück"],
      "Next": ["Weiter"],
      "Checking compatibility of this webapp with backend service...": [
        "Kompatibilität dieser Webanwendung mit dem Backend-Dienst wird geprüft …",
      ],
      "There was an error trying to contact the backend service.": [
        "Beim Kontaktieren des Backend-Dienstes ist ein Fehler aufgetreten.",
      ],
      'The server version is not supported. Supported version "%1$s", server version "%2$s"':
        [
          "Die Serverversion wird nicht unterstützt. Unterstützte Version „%1$s“, Serverversion „%2$s“",
        ],
      "Retry": ["Erneut versuchen"],
      'The server version is not supported. Supported version "%1$s".': [
        "Die Serverversion wird nicht unterstützt. Unterstützte Version „%1$s“.",
      ],
      "Not recorded": ["Nicht erfasst"],
      "Provider": ["Anbieter"],
      "Acceptance status": ["Annahmestatus"],
      "Accepted": ["Angenommen"],
      "Accepted terms version": ["Angenommene Version der Bedingungen"],
      "Terms opened or downloaded": [
        "Bedingungen geöffnet oder heruntergeladen",
      ],
      "Yes": ["Ja"],
      "No": ["Nein"],
      "Try again": ["Erneut versuchen"],
      "Downloading PDF…": ["PDF wird heruntergeladen …"],
      "Download PDF": ["PDF herunterladen"],
      "Done": ["Fertig"],
      "The terms are not available as Markdown or plain text.": [
        "Die Bedingungen sind weder als Markdown noch als Klartext verfügbar.",
      ],
      "These terms are too large to display safely.": [
        "Diese Bedingungen sind zu umfangreich, um sie sicher anzuzeigen.",
      ],
      "The terms of service could not be loaded.": [
        "Die Allgemeinen Geschäftsbedingungen konnten nicht geladen werden.",
      ],
      "Close terms of service": ["Allgemeine Geschäftsbedingungen schliessen"],
      "Loading terms of service…": [
        "Allgemeine Geschäftsbedingungen werden geladen …",
      ],
      "The PDF could not be downloaded.": [
        "Die PDF-Datei konnte nicht heruntergeladen werden.",
      ],
      "Read the terms provided by %1$s before recording your acceptance.": [
        "Lesen Sie die von %1$s bereitgestellten Bedingungen, bevor Sie Ihre Zustimmung bestätigen.",
      ],
      "Read terms again": ["Bedingungen erneut lesen"],
      "Read terms": ["Bedingungen lesen"],
      "Your acceptance applies to the version shown above.": [
        "Ihre Zustimmung gilt für die oben angezeigte Version.",
      ],
      "Review the terms of service": ["Allgemeine Geschäftsbedingungen prüfen"],
      "Read the terms before recording your acceptance.": [
        "Lesen Sie die Bedingungen, bevor Sie Ihre Zustimmung bestätigen.",
      ],
      "Accept the terms of service": [
        "Allgemeine Geschäftsbedingungen akzeptieren",
      ],
      "I have read and accept the terms of service": [
        "Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie",
      ],
      "Open the terms before accepting them.": [
        "Öffnen Sie die Bedingungen, bevor Sie sie akzeptieren.",
      ],
      "Email verification": ["E-Mail-Verifizierung"],
      "Challenge email ownership.": [
        "Bestätigung des Besitzes der E-Mail-Adresse.",
      ],
      "E-Mail": ["E-Mail"],
      "Postal verification": ["Postanschrift-Verifizierung"],
      "Challenge address ownership.": ["Bestätigung des Besitzes der Adresse."],
      "Name": ["Name"],
      "Address": ["Adresse"],
      "Country": ["Land"],
      "Phone verification": ["Telefon-Verifizierung"],
      "Challenge phone number ownership.": [
        "Bestätigung des Besitzes der Telefonnummer.",
      ],
      "Phone": ["Telefon"],
      "Generic note": ["Allgemeine Notiz"],
      "Free-form, generic note": ["Freiformulierte, allgemeine Notiz"],
      "Note / Memorandum": ["Notiz / Vermerk"],
      "Free-form notes": ["Freiformulierte Notizen"],
      "Supplemental File Upload": ["Hochladen zusätzlicher Dokumente"],
      "Optional supplemental information for the establishment of the business relationship with the customer.":
        [
          "Optionale zusätzliche Informationen zur Begründung der Geschäftsbeziehung mit dem Kunden.",
        ],
      "Supplemental Files": ["Zusätzliche Dokumente"],
      "Description": ["Beschreibung"],
      "File (PDF)": ["Datei (PDF)"],
      "Upload multiple documents": ["Mehrere Dokumente hochladen"],
      "Upload multiple documents.": ["Mehrere Dokumente hochladen."],
      "Requested documents": ["Angeforderte Dokumente"],
      "Document identifier": ["Dokumentenkennung"],
      "Title": ["Titel"],
      "Required": ["Erforderlich"],
      "Document upload (%1$s)": ["Dokument-Upload (%1$s)"],
      "Simple form": ["Einfaches Formular"],
      "Full Name": ["Vollständiger Name"],
      "Birthdate": ["Geburtsdatum"],
      "Comment": ["Kommentar"],
      "Resolution": ["Entscheidung"],
      "New state": ["Neuer Status"],
      "Frozen": ["Gesperrt"],
      "Pending": ["Ausstehend"],
      "Normal": ["Normal"],
      "New threshold": ["Neuer Schwellenwert"],
      "German": ["Deutsch"],
      "English": ["Englisch"],
      "Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange (K)":
        [
          "Feststellung des Kontrollinhabers an nicht börsenkotierten, operativ tätigen juristischen Personen und Personengesellschaften (K)",
        ],
      "for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnership that are beneficial owners":
        [
          "bei operativ tätigen juristischen Personen und Personengesellschaften als Vertragspartner sowie sinngemäss bei operativ tätigen juristischen Personen und Personengesellschaften als wirtschaftlich Berechtigte",
        ],
      "Establishment of the controlling person (submitted by customer)": [
        "Feststellung des Kontrollinhabers (durch den Kunden eingereicht)",
      ],
      "Identity of the contracting partner": ["Identität des Vertragspartners"],
      "Name and address": ["Name und Adresse"],
      "Contracting partner": ["Vertragspartner"],
      "Controlling person(s)": ["Kontrollinhaber"],
      "Reason for control": ["Grund der Kontrolle"],
      "Holding 25% or more": ["Halten von 25% oder mehr"],
      "The person(s) listed below is/are holding 25% or more of the contracting partner's shares (capital shares or voting rights)":
        [
          "Die nachfolgend aufgeführte(n) Person(en) hält/halten am Vertragspartner Anteile (Kapital- oder Stimmrechtsanteile) von 25% oder mehr",
        ],
      "Other way": ["Andere Art"],
      "If the capital shares or voting rights cannot be determined or in case there are no capital shares or voting rights 25% or more, the contracting partner hereby declares that the person(s) listed below is/are controlling the contracting partner in other ways":
        [
          "Falls die Kapital- oder Stimmrechtsanteile nicht festgestellt werden können oder falls keine Kapital- oder Stimmrechtsanteile von 25% oder mehr bestehen, erklärt der Vertragspartner hiermit, dass die nachfolgend aufgeführte(n) Person(en) auf andere Weise die Kontrolle über den Vertragspartner ausübt/ausüben",
        ],
      "Managing director": ["Geschäftsführer"],
      "In case this/these person(s) cannot be determined or this/these person(s) does/do not exist, the contracting partner hereby declares that the person(s) listed below is/are the managing director(s)":
        [
          "Falls auch diese Person(en) nicht festgestellt werden kann/können oder diese Person(en) nicht besteht/bestehen, erklärt der Vertragspartner hiermit, dass die nachfolgend aufgeführte(n) Person(en) die Geschäftsführung ausübt/ausüben",
        ],
      "Can't be empty": ["Darf nicht leer sein"],
      "Full name": ["Vollständiger Name"],
      "Actual address of domicile": ["Effektive Wohnsitzadresse"],
      "Fiduciary holding assets": [
        "Treuhänderisches Halten von Vermögenswerten",
      ],
      "Is a third person the beneficial owner of the assets held in the account/securities account?":
        [
          "Ist eine Drittperson an den auf dem Konto/Depot liegenden Vermögenswerten wirtschaftlich berechtigt?",
        ],
      "Signature(s)": ["Unterschrift(en)"],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery)":
        [
          "Die vorsätzliche Angabe falscher Informationen in diesem Formular ist eine strafbare Handlung (Urkundenfälschung gemäss Artikel 251 des Schweizerischen Strafgesetzbuchs).",
        ],
      "The contracting partner hereby undertakes to inform automatically of any changes to the information contained herein.":
        [
          "Der Vertragspartner verpflichtet sich, Änderungen jeweils unaufgefordert mitzuteilen.",
        ],
      "Date": ["Datum"],
      "Establishment of the controlling person (submitted by AML officer)": [
        "Feststellung des Kontrollinhabers (durch den AML-Beauftragten eingereicht)",
      ],
      "Signed Declaration": ["Unterzeichnete Erklärung"],
      "Signed declaration by the customer": [
        "Vom Kunden unterzeichnete Erklärung",
      ],
      "The uploaded document must contain the customer's signature on the beneficial owner declaration.":
        [
          "Das hochgeladene Dokument muss die Unterschrift des Kunden auf der Erklärung zum wirtschaftlich Berechtigten enthalten.",
        ],
      "Signed Document": ["Unterzeichnetes Dokument"],
      "invalid format": ["ungültiges Format"],
      "it can't be in the future": ["darf nicht in der Zukunft liegen"],
      "it can't be greater than 120 years": [
        "darf nicht grösser als 120 Jahre sein",
      ],
      "Last name(s), first name(s)/entity": ["Name(n), Vorname(n)/Firma"],
      "Actual address of domicile/registered office": [
        "Effektive Wohnsitzadresse/Sitzadresse",
      ],
      "Date(s) of birth": ["Geburtsdatum/-daten"],
      "Nationality": ["Nationalität"],
      "Date of death (if deceased)": ["Todesfall (falls verstorben)"],
      "Foundations (as well as similar constructs) (S)": [
        "Stiftungen (sowie ähnliche Konstrukte) (S)",
      ],
      "Declaration for foundations and similar constructs.": [
        "Erklärung über Stiftungen und ähnliche Konstrukte.",
      ],
      "Contracting partner and foundation": ["Vertragspartner und Stiftung"],
      "The undersigned hereby declare(s) that as board member of the foundation, or of the highest supervisory body of an underlying company of a foundation, known as:":
        [
          "Der/die Unterzeichnete(n) erklärt/erklären hiermit, dass er/sie Mitglied des Stiftungsrates oder des obersten Aufsichtsorgans einer unterliegenden Gesellschaft einer Stiftung, mit dem Namen/der Firma:",
        ],
      "Name of the foundation": ["Name/Firma der Stiftung"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following:":
        [
          "ist/sind und in dieser Funktion nach seinem/ihrem besten Wissen die folgenden Informationen übermittelt/übermitteln:",
        ],
      "Name and information pertaining to the foundation": [
        "Namen und Angaben zur Stiftung",
      ],
      "Type of foundation": ["Art der Stiftung"],
      "Discretionary foundation": ["Diskretionäre Stiftung"],
      "Non-discretionary foundation": ["Nicht-diskretionäre Stiftung"],
      "Revocability": ["Widerrufbarkeit"],
      "Revocable foundation": ["Widerrufbare Stiftung"],
      "Irrevocable foundation": ["Nicht-widerrufbare Stiftung"],
      "Information pertaining to the founder": [
        "Angaben zum Errichter/Stifter",
      ],
      "Information pertaining to the ultimate economic, not fiduciary, founder (individual(s) or entity/entities).":
        [
          "Angaben zum tatsächlichen, nicht treuhänderischen Errichter/Stifter (Einzelperson/en oder Gesellschaft/en).",
        ],
      "Founder(s)": ["Errichter/Stifter"],
      "Does the founder have the right to revoke the foundation?": [
        "Hat der Stifter das Recht, die Stiftung zu widerrufen?",
      ],
      "Founders of pre-existing foundations": [
        "Errichter/Stifter vorbestehender Stiftungen",
      ],
      "Complete this section if the foundation results from a restructuring (re-settlement) or merger of pre-existing foundations.":
        [
          "Auszufüllen, wenn die Stiftung aus einer Restrukturierung (Re-Settlement) oder Zusammenlegung (Merger) vorbestehender Stiftungen entstanden ist.",
        ],
      "Founder(s) of the pre-existing foundation(s)": [
        "Errichter/Stifter der vorbestehenden Stiftung(en)",
      ],
      "Beneficiaries": ["Angaben zu Begünstigten"],
      "Beneficiaries determined at the time this form is signed": [
        "Im Zeitpunkt der Unterzeichnung bestimmte Begünstigte",
      ],
      "Does the beneficiary have an actual right to claim distributions?": [
        "Hat der Begünstigte einen festen Anspruch auf Ausschüttungen?",
      ],
      "Known group(s) of beneficiaries": ["Bekannte Begünstigtengruppe(n)"],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the founder).":
        [
          "Zusätzlich zu bestimmten Begünstigten oder falls keine bestimmten Begünstigten festgelegt wurden (z.B. Nachkommen des Errichters/Stifters).",
        ],
      "Provide at least one beneficiary or group of beneficiaries": [
        "Bitte geben Sie mindestens einen Begünstigten oder eine Begünstigtengruppe an.",
      ],
      "Further persons": ["Weitere Personen"],
      "Persons entitled to determine or nominate representatives of the foundation when those representatives may dispose of assets or change asset distributions or the nomination of beneficiaries.":
        [
          "Personen, welche Vertreter der Stiftung bestimmen oder ernennen können, sofern diese Vertreter über Vermögenswerte verfügen oder die Vermögenszuteilung beziehungsweise Ernennung von Begünstigten ändern können.",
        ],
      "Further person(s)": ["Weitere Person(en)"],
      "Is/are there (a) further person(s) with the right to revoke the foundation?":
        [
          "Hat/Haben diese weitere(n) Person(en) das Recht, die Stiftung zu widerrufen?",
        ],
      "It is a criminal offence to deliberately provide false information on this form (article 251 of the Swiss Criminal Code, document forgery).":
        [
          "Die vorsätzliche Angabe falscher Informationen in diesem Formular ist eine strafbare Handlung (Urkundenfälschung gemäss Artikel 251 des Schweizerischen Strafgesetzbuchs).",
        ],
      "The contracting partner(s) undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Der/die Vertragspartner verpflichtet/verpflichten sich, allfällige Änderungen an den hier gemachten Angaben unverzüglich mitzuteilen.",
        ],
      "Declaration for trusts (T)": ["Erklärung für Trusts (T)"],
      "Declaration for trusts.": ["Erklärung über Trusts."],
      "Contracting partner and trust": ["Vertragspartner und Trust"],
      "The undersigned hereby declare(s) that as trustee or a member of highest supervisory body of an underlying company of a trust known as:":
        [
          "Der/die Unterzeichnete(n) erklärt/erklären hiermit, dass er/sie Trustee oder Mitglied des obersten Aufsichtsorgans einer unterliegenden Gesellschaft eines Trusts usw. mit dem Namen/der Firma:",
        ],
      "Name of the trust": ["Name/Firma des Trusts"],
      "and, in such capacity, provide(s) to the best of his/her/their knowledge the following information:":
        [
          "ist/sind und in dieser Funktion nach seinem/ihrem besten Wissen die folgenden Informationen übermittelt/übermitteln:",
        ],
      "Name and information pertaining to the trust": [
        "Namen und Angaben zum Trust",
      ],
      "Type of trust": ["Art des Trusts"],
      "Discretionary trust": ["Discretionary Trust"],
      "Non-discretionary trust": ["Non-discretionary Trust"],
      "Revocable trust": ["Revocable Trust"],
      "Irrevocable trust": ["Irrevocable Trust"],
      "Information pertaining to the settlor": ["Angaben zum Settlor"],
      "Information pertaining to the ultimate economic, not fiduciary, settlor of the trust (individual(s) or entity/entities).":
        [
          "Angaben zum tatsächlichen, nicht treuhänderischen Settlor des Trusts (Einzelperson/en oder Gesellschaft/en).",
        ],
      "Settlor(s)": ["Settlor"],
      "Does the settlor have the right to revoke the trust?": [
        "Hat der Settlor das Recht, den Trust zu widerrufen?",
      ],
      "Settlors of pre-existing trusts": ["Settlor(s) vorbestehender Trusts"],
      "Complete this section if the trust results from a restructuring (re-settlement) or merger of pre-existing trusts.":
        [
          "Auszufüllen, wenn der Trust aus einer Restrukturierung (Re-Settlement) oder Zusammenlegung (Merger) vorbestehender Trusts entstanden ist.",
        ],
      "Settlor(s) of the pre-existing trust(s)": [
        "Settlor(s) des/der vorbestehenden Trusts",
      ],
      "In addition to defined beneficiaries, or if no beneficiary has been defined (for example, descendants of the settlor).":
        [
          "Zusätzlich zu bestimmten Begünstigten oder falls keine bestimmten Begünstigten festgelegt wurden (z.B. Nachkommen des Settlors).",
        ],
      "Protectors": ["Protektoren"],
      "Protector(s)": ["Protektor(en)"],
      "Does the protector have the right to revoke the trust?": [
        "Hat der Protektor das Recht, den Trust zu widerrufen?",
      ],
      "Further persons having the right to appoint the trustee of a trust.": [
        "Weitere Personen, welche das Recht haben, den Trustee eines Trusts zu bestimmen.",
      ],
      "Do any further persons have the right to revoke the trust?": [
        "Hat/Haben diese weitere(n) Person(en) das Recht, den Trust zu widerrufen?",
      ],
      "The contracting partner(s) hereby declare(s) to be entitled to open a business relationship for the trust above or its underlying company.":
        [
          "Der/die Vertragspartner bestätigt/bestätigen, dass er/sie zur Aufnahme der Geschäftsbeziehung für den oben genannten Trust oder dessen unterliegender Gesellschaft berechtigt ist/sind.",
        ],
      "The contracting partner(s) hereby undertake(s) to automatically inform of any changes to the information contained herein.":
        [
          "Der/die Vertragspartner verpflichtet/verpflichten sich, allfällige Änderungen an den hier gemachten Angaben unverzüglich mitzuteilen.",
        ],
      "The customer is the person with whom the member concludes the contract with regard to the financial service provided (civil law). If the\n  member acts as the director of a domiciliary company, then that domiciliary company is the customer.":
        [
          "Kunde ist die Person, mit welcher das Mitglied den Vertrag über die erbrachte Finanzdienstleistung abschliesst (Zivilrecht). Handelt das\n  Mitglied als Organ einer Sitzgesellschaft, so ist diese Sitzgesellschaft der Kunde.",
        ],
      "Identification Form (customer)": ["Identifikationsformular (Kunde)"],
      "The customer has to be identified on entering into a permanent business relationship or on concluding a cash transaction, which meets the according threshold.":
        [
          "Die Vertragspartei muss identifiziert werden bei allen dauernden Geschäftsbeziehungen sowie bei Kassageschäften, bei welchen der entsprechende Schwellenwert erreicht wird.",
        ],
      "Correspondence language:": ["Korrespondenzsprache:"],
      "French": ["Französisch"],
      "Italian": ["Italienisch"],
      "Identification form (basic customer information)": [
        "Identifikationsformular (Basisangaben zum Kunden)",
      ],
      "Information on customer": ["Angaben zum Kunden"],
      "Customer type": ["Kundentyp"],
      "Natural person (incl. sole proprietors)": [
        "Natürliche Person (inkl. Einzelunternehmen)",
      ],
      "Legal entity": ["Juristische Person"],
      "Applicable if customer is a natural person": [
        "Anwendbar, wenn der Kunde eine natürliche Person ist",
      ],
      "Residential address in Switzerland": ["Wohnsitzadresse in der Schweiz"],
      "Telephone": ["Telefon"],
      "Email": ["E-Mail"],
      "Date of birth": ["Geburtsdatum"],
      "Copy of identification document": ["Kopie des Ausweisdokuments"],
      "Only official government IDs (incl. passports) are accepted. Please scan both sides if applicable.":
        [
          "Es werden nur amtliche Ausweise (inkl. Pässe) akzeptiert. Bitte scannen Sie gegebenenfalls beide Seiten.",
        ],
      "Sole proprietor": ["Einzelunternehmen"],
      "Information on customer (sole proprietor)": [
        "Angaben zum Kunden (Einzelunternehmen)",
      ],
      "Applicable only if customer is a sole proprietor": [
        "Nur anwendbar, wenn der Kunde ein Einzelunternehmen ist",
      ],
      "Company name": ["Firmenname"],
      "Registered office": ["Sitz"],
      "Company identification document": [
        "Identifikationsdokument des Unternehmens",
      ],
      "Information on customer (legal entity)": [
        "Angaben zum Kunden (juristische Person)",
      ],
      "Applicable if customer is a legal entity": [
        "Anwendbar, wenn der Kunde eine juristische Person ist",
      ],
      "Domicile": ["Sitz"],
      "Contact person": ["Kontaktperson"],
      "Copy of identification document (not older than 12 months)": [
        "Kopie des Ausweisdokuments (nicht älter als 12 Monate)",
      ],
      "Company share registry file": ["Aktienbuchauszug"],
      "Correspondence Preferences": ["Korrespondenzpräferenzen"],
      "Information on the natural persons who establish the business relationship for legal entities and partnerships":
        [
          "Angaben zu den natürlichen Personen, die für juristische Personen und Personengesellschaften die Geschäftsbeziehung eröffnen (Eröffner)",
        ],
      "For legal entities and partnerships the identity of the natural persons who establish the business relationship must be verified.":
        [
          "Bei juristischen Personen und Personengesellschaften ist die Identität der natürlichen Personen, welche die Geschäftsbeziehung eröffnen, zu überprüfen.",
        ],
      "Persons establishing the legal relationship": [
        "Personen, welche die Geschäftsbeziehung begründen",
      ],
      "Residential address": ["Wohnsitzadresse"],
      "Signing authority of the person": ["Zeichnungsberechtigung der Person"],
      "Power of attorney arrangements": ["Vollmachtregelung"],
      "Sole signature authority": ["Einzelzeichnungsberechtigung"],
      "Collective authority with two signatures": [
        "Kollektivzeichnungsberechtigung zu zweien",
      ],
      "Other (please specify)": ["Andere (bitte angeben)"],
      "Other type of signing authority": [
        "Andere Art der Zeichnungsberechtigung",
      ],
      "Evidence of signing authority:": [
        "Nachweis der Zeichnungsberechtigung:",
      ],
      "Company register extract": ["Handelsregisterauszug"],
      "Mandate": ["Mandat"],
      "Other": ["Andere"],
      "Specify other way of establishing signing authority:": [
        "Andere Art des Nachweises der Zeichnungsberechtigung angeben:",
      ],
      "Copy of document that serves as evidence of signing authority:": [
        "Kopie des Dokuments, das als Nachweis der Zeichnungsberechtigung dient:",
      ],
      "Customer classification": ["Kundenklassifizierung"],
      "Classification for the establishment of the beneficial owner of the assets and/or controlling person":
        [
          "Klassifizierung zur Feststellung des wirtschaftlich Berechtigten der Vermögenswerte und/oder des Kontrollinhabers",
        ],
      "The customer is:": ["Der Kunde ist:"],
      "A natural person and there are no doubts that this person is the sole beneficial owner of the assets":
        [
          "Eine natürliche Person und es bestehen keine Zweifel, dass diese selber an den Vermögenswerten wirtschaftlich berechtigt ist",
        ],
      "An operational legal entity or partnership": [
        "Eine operative juristische Person oder Personengesellschaft",
      ],
      "A foundation (or a similar construct; incl. underlying companies)": [
        "Eine Stiftung (oder ein ähnliches Konstrukt; inkl. Underlying Companies)",
      ],
      "A trust (incl. underlying companies)": [
        "Ein Trust (inkl. Underlying Companies)",
      ],
      "A life insurance policy with separately managed accounts / securities accounts (so-called insurance wrappers)":
        [
          "Eine Lebensversicherung mit separater Konto-/Depotführung (sog. Insurance Wrapper)",
        ],
      "Special Clarifications": ["Besondere Abklärungen"],
      "When a business relationship or transaction is associated with increased risk, appears unusual or evidence exists that the assets are the proceeds of a felony or a qualified tax offence, the member has to perform additional clarifications.":
        [
          "Wenn eine Geschäftsbeziehung oder Transaktion mit einem erhöhten Risiko verbunden ist, ungewöhnlich erscheint oder Anhaltspunkte dafür bestehen, dass die Vermögenswerte aus einem Verbrechen oder einem qualifizierten Steuervergehen stammen, hat das Mitglied zusätzliche Abklärungen durchzuführen.",
        ],
      "Customer": ["Kunde"],
      "Reason for special clarifications": ["Grund für besondere Abklärungen"],
      "Reason": ["Grund"],
      "Description of the circumstances/transactions, which triggered the special clarifications":
        [
          "Beschreibung der Umstände/Transaktionen, welche die besonderen Abklärungen ausgelöst haben",
        ],
      "can't be empty": ["darf nicht leer sein"],
      "Used means of clarification": ["Verwendete Abklärungsmittel"],
      "Means": ["Mittel"],
      "Gathering of information from the customer, beneficial owner of the assets, controlling person":
        [
          "Einholung von Informationen beim Kunden, wirtschaftlich Berechtigten der Vermögenswerte, dem Kontrollinhaber",
        ],
      "Consultation of generally accessible sources and databases": [
        "Konsultation allgemein zugänglicher Quellen und Datenbanken",
      ],
      "Enquiries with trustworthy persons": [
        "Erkundigungen bei vertrauenswürdigen Personen",
      ],
      "Other, which?": ["Andere, welche?"],
      "Other means of clarification:": ["Andere Abklärungsmittel:"],
      "Optional supplemental information for the special clarifications.": [
        "Optionale ergänzende Angaben zu den besonderen Abklärungen.",
      ],
      "Summary and plausibility check of the gathered information": [
        "Zusammenfassung und Plausibilitätsprüfung der eingeholten Informationen",
      ],
      "The results of the clarifications have to be documented and their plausibility has to be checked.":
        [
          "Die Ergebnisse der Abklärungen sind zu dokumentieren und auf ihre Plausibilität zu prüfen.",
        ],
      "Summary": ["Zusammenfassung"],
      "Gathered/Consulted documents": ["Eingeholte/konsultierte Dokumente"],
      "Result of the special clarification": [
        "Ergebnis der besonderen Abklärung",
      ],
      "Result": ["Ergebnis"],
      "No suspicion": ["Kein Verdacht"],
      "The plausibility of the circumstances could be checked, no reasonable suspicion pursuant to Art. 9 AMLA (possibly update of customer profile and/or risk profile)":
        [
          "Die Plausibilität der Umstände konnte überprüft werden, kein begründeter Verdacht gemäss Art. 9 GwG (gegebenenfalls Aktualisierung des Kundenprofils und/oder Risikoprofils)",
        ],
      "Reasonable suspicion": ["Begründeter Verdacht"],
      "Reasonable suspicion pursuant to Art. 9 AMLA, duty to file a report with MROS":
        ["Begründeter Verdacht gemäss Art. 9 GwG, Meldepflicht bei der MROS"],
      "Simple suspicion": ["Einfacher Verdacht"],
      "Simple suspicion pursuant to Art. 305ter Para. 2 StGB, right to notify MROS":
        [
          "Einfacher Verdacht gemäss Art. 305ter Abs. 2 StGB, Melderecht gegenüber der MROS",
        ],
      "Other, what?": ["Andere, was?"],
      "Result clarification": ["Erläuterung des Ergebnisses"],
      "Identification Form (acceptance)": ["Identifikationsformular (Annahme)"],
      "Acceptance of business relationship": ["Annahme der Geschäftsbeziehung"],
      "Date (conclusion of contract):": ["Datum (Vertragsabschluss):"],
      "Accepted via:": ["Angenommen über:"],
      "Face to face": ["Persönlich"],
      "Authenticated copy of identification document": [
        "Beglaubigte Kopie des Ausweisdokuments",
      ],
      "Residential address validated": ["Wohnsitzadresse überprüft"],
      "Further information:": ["Weitere Angaben:"],
      "Evaluation with regard to embargo procedures/terrorism lists on establishing the business relationship":
        [
          "Prüfung im Hinblick auf Embargomassnahmen/Terrorlisten bei Aufnahme der Geschäftsbeziehung",
        ],
      "Verification whether the customer, beneficial owners of the assets, controlling persons, authorized representatives or other involved persons are listed on an embargo/terrorism list.":
        [
          "Überprüfung, ob der Kunde, die wirtschaftlich Berechtigten der Vermögenswerte, die Kontrollinhaber, bevollmächtigten Vertreter oder andere beteiligte Personen auf einer Embargo-/Terrorliste aufgeführt sind.",
        ],
      "Embargo/terrorism status:": ["Embargo-/Terror-Status:"],
      "Not listed on embargo/terrorism list.": [
        "Nicht auf einer Embargo-/Terrorliste aufgeführt.",
      ],
      "Listed on embargo/terrorism list.": [
        "Auf einer Embargo-/Terrorliste aufgeführt.",
      ],
      "Embargo/terrorism information:": ["Embargo-/Terror-Angaben:"],
      "Verification date": ["Datum der Überprüfung"],
      "Supplemental files": ["Ergänzende Dokumente"],
      "Risk Profile AMLA": ["Risikoprofil GwG"],
      "Evaluation of politically exposed persons (PEP-Check)": [
        "Beurteilung politisch exponierter Personen (PEP-Check)",
      ],
      "This evaluation has to be completed by all members for every business relationship.":
        [
          "Diese Beurteilung ist von allen Mitgliedern für jede Geschäftsbeziehung durchzuführen.",
        ],
      "Foreign PEP": ["Ausländische PEP"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a foreign PEP or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine ausländische PEP oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "Domestic PEP": ["Inländische PEP"],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a domestic PEP or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine inländische PEP oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "PEP of International Organisations": [
        "PEP internationaler Organisationen",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative a PEP in International Organisations or closely related to such a person?":
        [
          "Ist der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter eine PEP einer internationalen Organisation oder steht in einer engen Beziehung zu einer solchen Person?",
        ],
      "Acceptance date": ["Datum der Annahme"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with a PEP was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer Geschäftsbeziehung mit einer PEP eingeholt wurde.",
        ],
      'Evaluation "high risk" or non-cooperative country': [
        "Beurteilung „Hochrisikoland“ oder nicht kooperatives Land",
      ],
      "High-risk or non-cooperative country": [
        "Hochrisikoland oder nicht kooperatives Land",
      ],
      "Is the customer, the beneficial owner or the controlling person or authorised representative in a country considered by the FATF as high-risk or non-cooperative and for which FATF requires increased diligence?":
        [
          "Befindet sich der Kunde, der wirtschaftlich Berechtigte, der Kontrollinhaber oder der bevollmächtigte Vertreter in einem Land, das von der FATF als Hochrisikoland oder nicht kooperatives Land eingestuft wird und für welches die FATF erhöhte Sorgfaltspflichten verlangt?",
        ],
      "When the decision of the Senior executive body on the acceptance of such a business relationship was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer solchen Geschäftsbeziehung eingeholt wurde.",
        ],
      "Evaluation of business relationship risk": [
        "Beurteilung des Risikos der Geschäftsbeziehung",
      ],
      "Country risk": ["Länderrisiko"],
      "Applicable country risk types": ["Anwendbare Arten von Länderrisiken"],
      "Nationality of the customer": ["Staatsangehörigkeit des Kunden"],
      "Nationality of the beneficial owner of the assets": [
        "Staatsangehörigkeit des wirtschaftlich Berechtigten der Vermögenswerte",
      ],
      "Domicile/residential address of the customer": [
        "Sitz/Wohnsitzadresse des Kunden",
      ],
      "Domicile/residential address of the beneficial owner of the assets": [
        "Sitz/Wohnsitzadresse des wirtschaftlich Berechtigten der Vermögenswerte",
      ],
      "Domicile/residential address of the controlling person": [
        "Sitz/Wohnsitzadresse des Kontrollinhabers",
      ],
      "Country risk level (nationality)": [
        "Länderrisikostufe (Staatsangehörigkeit)",
      ],
      "Risk category according to VQF country list (VQF doc. no. 902.4.1)": [
        "Risikokategorie gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Low (Risk 0)": ["Niedrig (Risiko 0)"],
      "Risk 0 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 0 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Medium (Risk 1)": ["Mittel (Risiko 1)"],
      "Risk 1 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 1 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "High (Risk 2)": ["Hoch (Risiko 2)"],
      "Risk 2 acc. to VQF country list (VQF doc. no. 902.4.1)": [
        "Risiko 2 gemäss VQF-Länderliste (VQF-Dok. Nr. 902.4.1)",
      ],
      "Country risk type (place of business activity)": [
        "Art des Länderrisikos (Ort der Geschäftstätigkeit)",
      ],
      "Beneficial owner": ["Wirtschaftlich Berechtigte(r)"],
      "Country risk level (business activity)": [
        "Länderrisikostufe (Geschäftstätigkeit)",
      ],
      "Industry risk": ["Branchenrisiko"],
      "Industry risk source": ["Quelle des Branchenrisikos"],
      "Beneficial owner of the assets": [
        "Wirtschaftlich Berechtigter der Vermögenswerte",
      ],
      "Industry risk level": ["Branchenrisikostufe"],
      "Transparent (Risk Level 0)": ["Transparent (Risikostufe 0)"],
      "Clearly defined, transparent, easily comprehensible business activity well known to the member.":
        [
          "Klar definierte, transparente, leicht nachvollziehbare Geschäftstätigkeit, die dem Mitglied gut bekannt ist.",
        ],
      "High cash transactions (Risk Level 1)": [
        "Hoher Anteil an Bargeldtransaktionen (Risikostufe 1)",
      ],
      "Business activity with a high level of cash transactions.": [
        "Geschäftstätigkeit mit einem hohen Anteil an Bartransaktionen.",
      ],
      "Not well known (Risk Level 1)": ["Nicht gut bekannt (Risikostufe 1)"],
      "Business activity not well known to the member.": [
        "Geschäftstätigkeit, die dem Mitglied nicht gut bekannt ist.",
      ],
      "High-risk trade (Risk Level 2)": [
        "Handel mit hohem Risiko (Risikostufe 2)",
      ],
      "Trade in munitions/arms, raw gem stones/diamonds, jewellery, international trade in exotic animals, casino and lottery business, trade in erotic wares.":
        [
          "Handel mit Munition/Waffen, Rohedelsteinen/Diamanten, Schmuck, internationaler Handel mit exotischen Tieren, Casino- und Lotteriegeschäft, Handel mit Erotikartikeln.",
        ],
      "Unknown industry (Risk Level 2)": ["Unbekannte Branche (Risikostufe 2)"],
      "Member has no personal knowledge of the customer’s industry.": [
        "Das Mitglied verfügt über keine persönliche Kenntnis der Branche des Kunden.",
      ],
      "Contact risk": ["Kontaktrisiko"],
      "Type of contact to the customer/beneficial owner of the assets.": [
        "Art des Kontakts zum Kunden/wirtschaftlich Berechtigten der Vermögenswerte.",
      ],
      "Contact risk level": ["Kontaktrisikostufe"],
      "Low contact risk": ["Tiefes Kontaktrisiko"],
      "Personal acquaintance between member and customer/beneficial owner of the assets over several years (at least 2) prior to entering into the business relationship":
        [
          "Persönliche Bekanntschaft zwischen Mitglied und Kunde/wirtschaftlich Berechtigtem der Vermögenswerte über mehrere Jahre (mindestens 2) vor Aufnahme der Geschäftsbeziehung",
        ],
      "Medium contact risk": ["Mittleres Kontaktrisiko"],
      "The customer/beneficial owner was not personally known to the member for several years (at least 2) prior to entering into the business relationship; however (a) no business was entered into in the absence of the customer/beneficial owner, or (b) the customer was at least introduced/brokered by a trusted third party.":
        [
          "Der Kunde/wirtschaftlich Berechtigte war dem Mitglied nicht während mehrerer Jahre (mindestens 2) vor Aufnahme der Geschäftsbeziehung persönlich bekannt; jedoch wurde (a) keine Geschäftsbeziehung in Abwesenheit des Kunden/wirtschaftlich Berechtigten eingegangen, oder (b) der Kunde wurde zumindest von einem vertrauenswürdigen Dritten eingeführt/vermittelt.",
        ],
      "High contact risk": ["Hohes Kontaktrisiko"],
      "The customer/beneficial owner was not personally known to the member and business was entered into in the absence of the former (relationship by correspondence) and the customer was not introduced/brokered by a trusted third party.":
        [
          "Der Kunde/wirtschaftlich Berechtigte war dem Mitglied nicht persönlich bekannt, und die Geschäftsbeziehung wurde in dessen Abwesenheit eingegangen (Korrespondenzbeziehung), wobei der Kunde nicht von einem vertrauenswürdigen Dritten eingeführt/vermittelt wurde.",
        ],
      "Summary evaluation": ["Zusammenfassende Beurteilung"],
      "Justification for risk assessment": ["Begründung der Risikobeurteilung"],
      "Risk classification": ["Risikoklassifizierung"],
      "Conclusion whether the business relationship is with or without increased risk.":
        [
          "Schlussfolgerung, ob die Geschäftsbeziehung mit oder ohne erhöhtes Risiko verbunden ist.",
        ],
      "No high risk": ["Kein hohes Risiko"],
      "High risk": ["Hohes Risiko"],
      "When the decision of the Senior executive body on the acceptance of a business relationship with increased risk was obtained on.":
        [
          "Datum, an dem der Entscheid des obersten Geschäftsführungsorgans über die Annahme einer Geschäftsbeziehung mit erhöhtem Risiko eingeholt wurde.",
        ],
      "Customer Profile": ["Kundenprofil"],
      "The information below has to refer to the persons from whom the assets originate ultimately (e.g. beneficial owner of the assets, founder/creator of a trust or foundation). Is the customer an operational legal entity or partnership the information may refer to the entity itself (not to the controlling person), unless the entity holds the assets in trust for a third party.":
        [
          "Die nachstehenden Angaben müssen sich auf die Personen beziehen, von denen die Vermögenswerte letztlich stammen (z. B. wirtschaftlich Berechtigter der Vermögenswerte, Gründer/Errichter eines Trusts oder einer Stiftung). Ist der Kunde eine operativ tätige juristische Person oder Personengesellschaft, können sich die Angaben auf die Gesellschaft selbst (nicht auf den Kontrollinhaber) beziehen, sofern die Gesellschaft die Vermögenswerte nicht treuhänderisch für einen Dritten hält.",
        ],
      "Business activity": ["Geschäftstätigkeit"],
      "Profession, business activities, etc. (former, current, potentially planned)":
        [
          "Beruf, Geschäftstätigkeiten usw. (frühere, aktuelle, allenfalls geplante)",
        ],
      "Financial circumstances": ["Finanzielle Verhältnisse"],
      "Income and assets, liabilities (estimated)": [
        "Einkommen und Vermögen, Verbindlichkeiten (geschätzt)",
      ],
      "Origin of the deposited assets involved": [
        "Herkunft der betroffenen eingebrachten Vermögenswerte",
      ],
      "Will the customer deposit assets with Taler Operations AG?": [
        "Wird der Kunde Vermögenswerte bei der Taler Operations AG einbringen?",
      ],
      "Nature, amount and currency of deposited assets.": [
        "Art, Betrag und Währung der eingebrachten Vermögenswerte.",
      ],
      "Category": ["Kategorie"],
      "Savings": ["Ersparnisse"],
      "Own business operations": ["Eigene Geschäftstätigkeit"],
      "Inheritance": ["Erbschaft"],
      "Category clarification": ["Erläuterung der Kategorie"],
      "Detailed description of the origins/economic background of the assets involved in the business relationship":
        [
          "Detaillierte Beschreibung der Herkunft/des wirtschaftlichen Hintergrunds der in die Geschäftsbeziehung eingebrachten Vermögenswerte",
        ],
      "Nature and purpose of the business relationship": [
        "Art und Zweck der Geschäftsbeziehung",
      ],
      "Purpose of the business relationship": ["Zweck der Geschäftsbeziehung"],
      "Information on the planned development of the business relationship and the assets":
        [
          "Angaben zur geplanten Entwicklung der Geschäftsbeziehung und der Vermögenswerte",
        ],
      "Details on usual business volume": [
        "Angaben zum üblichen Geschäftsvolumen",
      ],
      "Relationship with third parties": ["Beziehung zu Dritten"],
      "Relation of the customer to the beneficial owner, controlling persons, authorised signatories and other persons involved in the business relationship":
        [
          "Beziehung des Kunden zum wirtschaftlich Berechtigten, den Kontrollinhabern, den Zeichnungsberechtigten und anderen an der Geschäftsbeziehung beteiligten Personen",
        ],
      "Relation to other AMLA-Files": ["Bezug zu anderen GwG-Dossiers"],
      "Introducer / agents / references": [
        "Vermittler / Beauftragte / Referenzen",
      ],
      "Further information": ["Weitere Angaben"],
      "Other relevant information": ["Weitere relevante Angaben"],
      "Declaration of identity of the beneficial owner (A) — customer": [
        "Feststellung des wirtschaftlich Berechtigten (A) — Kunde",
      ],
      "The customer completes the declaration directly in the form.": [
        "Der Kunde füllt die Erklärung direkt im Formular aus.",
      ],
      "Declaration of identity of the beneficial owner": [
        "Feststellung des wirtschaftlich Berechtigten",
      ],
      "Beneficial owner details": ["Angaben zum wirtschaftlich Berechtigten"],
      "Beneficial owner(s)": ["Wirtschaftlich Berechtigte(r)"],
      "The person(s) listed below is/are the beneficial owner(s) of the assets involved in the business relationship. If the contracting partner is also the sole beneficial owner of the assets, the contracting partner's detail must be set out below":
        [
          "Die nachfolgend aufgeführte(n) Person(en) ist/sind an den in die Geschäftsbeziehung eingebrachten Vermögenswerten wirtschaftlich berechtigt. Ist der Vertragspartner selber allein an diesen Vermögenswerten wirtschaftlich berechtigt, so sind nachstehend seine Personalien festzuhalten",
        ],
      "Domicile address": ["Sitzadresse"],
      "Declaration of identity of the beneficial owner (A) — AML officer": [
        "Feststellung des wirtschaftlich Berechtigten (A) — GwG-Beauftragter",
      ],
      "The AML officer records the declaration and uploads the customer's signed PDF.":
        [
          "Der GwG-Beauftragte erfasst die Erklärung und lädt das vom Kunden unterzeichnete PDF hoch.",
        ],
      "January": ["Januar"],
      "February": ["Februar"],
      "March": ["März"],
      "April": ["April"],
      "May": ["Mai"],
      "June": ["Juni"],
      "July": ["Juli"],
      "August": ["August"],
      "September": ["September"],
      "October": ["Oktober"],
      "November": ["November"],
      "December": ["Dezember"],
      "Previous year": ["Vorheriges Jahr"],
      "Next year": ["Nächstes Jahr"],
      "Previous month": ["Vorheriger Monat"],
      "Next month": ["Nächster Monat"],
      "Close dialog": ["Dialog schliessen"],
      "Official form language": ["Offizielle Formularsprache"],
      "This form is shown in an official, legally binding language.": [
        "Dieses Formular wird in einer offiziellen, rechtsverbindlichen Sprache angezeigt.",
      ],
      "Official translation": ["Offizielle Übersetzung"],
      "This form is shown in an official translation, but it is not legally binding. Only the %1$s text is legally binding.":
        [
          "Dieses Formular wird in einer offiziellen Übersetzung angezeigt, die jedoch nicht rechtsverbindlich ist. Nur der Text in %1$s ist rechtsverbindlich.",
        ],
      "Unofficial form translation": ["Inoffizielle Formularübersetzung"],
      "This form is not officially supported in the selected language. The translation may be incomplete, and some text may be shown in %1$s. Only the %2$s text is legally binding.":
        [
          "Dieses Formular wird in der ausgewählten Sprache nicht offiziell unterstützt. Die Übersetzung kann unvollständig sein, und Teile des Textes können in %1$s angezeigt werden. Nur der Text in %2$s ist rechtsverbindlich.",
        ],
      "Shorten file contents.": ["Dateiinhalte kürzen."],
      "Result JSON:": ["JSON-Ergebnis:"],
      "List of fields with errors": ["Liste der Felder mit Fehlern"],
      "Delete this item?": ["Diesen Eintrag löschen?"],
      "Keep item": ["Eintrag behalten"],
      "Delete item": ["Eintrag löschen"],
      "Cancel": ["Abbrechen"],
      "Delete": ["Löschen"],
      "Add item": ["Eintrag hinzufügen"],
      "Save changes": ["Änderungen speichern"],
      "Item %1$s": ["Eintrag %1$s"],
      "Edit %1$s": ["%1$s bearbeiten"],
      "Edit": ["Bearbeiten"],
      "Clear selection": ["Auswahl löschen"],
      "Toggle choices": ["Auswahlmöglichkeiten anzeigen"],
      "No element found": ["Kein Element gefunden"],
      "years": ["Jahre"],
      "months": ["Monate"],
      "days": ["Tage"],
      "hours": ["Stunden"],
      "minutes": ["Minuten"],
      "seconds": ["Sekunden"],
      "No expiration": ["Keine Ablaufzeit"],
      "Forever": ["Für immer"],
      "The selected file is too large.": [
        "Die ausgewählte Datei ist zu gross.",
      ],
      "The selected file could not be read.": [
        "Die ausgewählte Datei konnte nicht gelesen werden.",
      ],
      "Upload a file": ["Eine Datei hochladen"],
      "Clear": ["Leeren"],
      "Download a copy.": ["Eine Kopie herunterladen."],
      "This option is not available.": ["Diese Option ist nicht verfügbar."],
      "The maximum number of selections has been reached.": [
        "Die maximale Anzahl von Auswahlmöglichkeiten wurde erreicht.",
      ],
      "Remove %1$s": ["%1$s entfernen"],
      "Simple comment": ["Einfacher Kommentar"],
      "Terms URL": ["URL der Bedingungen"],
      "Terms version": ["Version der Bedingungen"],
      "Provider name": ["Name des Anbieters"],
      "Only show the external link": ["Nur den externen Link anzeigen"],
      "Name and birthdate": ["Name und Geburtsdatum"],
      "Select an example from the list on the left.": [
        "Wählen Sie links in der Liste ein Beispiel aus.",
      ],
      "Example not found.": ["Beispiel nicht gefunden."],
      "An error occurred while rendering the example.": [
        "Beim Anzeigen des Beispiels ist ein Fehler aufgetreten.",
      ],
      "Group": ["Gruppe"],
      "Component": ["Komponente"],
      "Example": ["Beispiel"],
      "Arguments": ["Argumente"],
      "Dataset": ["Datensatz"],
      "Dataset %1$s of %2$s": ["Datensatz %1$s von %2$s"],
      "Select a story": ["Beispiel auswählen"],
      "Open stories navigation": ["Beispielnavigation öffnen"],
      "Stories navigation": ["Beispielnavigation"],
      "Stories": ["Beispiele"],
      "Close stories navigation": ["Beispielnavigation schliessen"],
      "Language": ["Sprache"],
      "%1$s": ["%1$s"],
      "Free-form message": ["Freitext-Nachricht"],
      "Are you a cross-border truck driver?": [
        "Sind Sie ein grenzüberschreitend tätiger Lkw-Fahrer?",
      ],
      "How much cash are you carrying?": [
        "Wie viel Bargeld führen Sie mit sich?",
      ],
      "Germany": ["Deutschland"],
      "Switzerland": ["Schweiz"],
      "Sign-in failed": ["Anmeldung fehlgeschlagen"],
      "Check your password.": ["Überprüfen Sie Ihr Passwort."],
      "Try again in a moment.": ["Versuchen Sie es gleich noch einmal."],
      "First error": ["Erster Fehler"],
      "First description": ["Erste Beschreibung"],
      "Second error": ["Zweiter Fehler"],
      "Second description": ["Zweite Beschreibung"],
      "Saved": ["Gespeichert"],
      "Request failed": ["Anfrage fehlgeschlagen"],
      "Try again.": ["Versuchen Sie es erneut."],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "de-CH",
  completeness: 100,
};
